import { cache, cacheName, getConfig } from '@/utils/cacheManager'
import { Job } from '@/class/model/booking/Job'
import $store from '@/store'
import * as FileType from '@/class/cargo/model/parameters/FileType'
import { getCacheListByKey, getFilterCacheList, getObjectByCache, getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import StrUtils from '../../../../utils/StrUtils'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { RailwayExportJob } from '@/class/model/booking/RailwayExportJob'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import { AirImportJob } from '@/class/model/booking/AirImportJob'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import * as EQSize from '@/class/cargo/model/parameters/EQSize'
import * as NumberUtils from '@/utils/NumberUtils'
import { MessageBox } from 'element-ui'
import { queryMAWBOtherCharge } from '@/api/AirExport/mAWBInfoOtherCharge'
import { updateMasterMAWBOtherCharge } from '@/api/AirExport/airExportJob'
import { checkJobOfClosingAccount } from '@/api/act/closingAccount'
import { getOfficeConfigByName, getUserDeptOffices } from '@/api/user'
import lang from '@/lang'
import checkPermission from '@/utils/permission'
import {
  isExistHBLANDMBL,
  hasCheckRuleCondition,
  checkBySaveJobNode,
  checkPoNoIsExist,
  checkBsItemOpened, batchLockJobFunc, checkBalanceBeforeSubmit, getJobByKeys, updateInquiryJobState
} from '@/api/booking/job'
import { hasConfigCheckRule, hasConfigCheckRuleByJobs, queryByNode } from '@/api/sysManage/baseConfig/checkRuleConfig'
import { Message } from '@/utils/Message'
import {
  getAllSlaveChargeList,
  getChargeList,
  jdySendPoItems, jdyUnlockStatus,
  queryCarrierCodeFunc
} from '@/api/seaExport/seaExportJob'
import { IntegratedJob } from '@/class/model/booking/IntegratedJob'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { User } from '@/class/model/sys/User'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import moment from 'moment'
import { querySubscribeConfig } from '@/api/sysManage/subscribePortPushRule'
import { checkFreightInsurance, checkHmFreightInsurance } from '@/api/external/insureInfo'
import { TabError } from '@/utils/class/TabError'
import { getMatchedUserPorts } from '@/api/userPort'
import { Office } from '@/class/model/sys/Office'
import ColumnUtils from '@/utils/ColumnUtils'
import * as routeWarehouseMappingApi from '@/api/sysManage/baseConfig/routeWarehouseMapping'
import { CreditInfo } from '@/class/model/sys/CreditInfo'
import * as ContractConstants from '@/class/cargo/model/parameters/ContractConstants'
import { SPLIT_BUBBLE_COLLECT_ITEMS } from '@/class/cargo/model/parameters/AirExportConstants'
import { Company } from '@/class/model/mdm/Company'
import * as CargoOfRoleType from '@/class/cargo/model/parameters/CargoOfRoleType'
import { formatNumberToThousands, sortByMultiField } from '@/utils'
import { xhqGetCfmAddress } from '@/api/seaExport/seaCargoDoc'
import { getFileList } from '@/api/storage'
import URL from '@/api/urlTranslator'
import { cleanCircleObject, dateCompare, mergeArray, multiply, submitDataByPost } from '@/utils/commonUtil'
import DateUtils from '@/utils/dateUtils'
import { checkJobHasMblFunc, checkMblNoDataFunc } from '@/api/booking/mblManagement'
import { MBL2 } from '@/class/cargo/model/parameters/CargoDocConsts'
import * as OverseaAgentGrade from '@/class/cargo/model/parameters/OverseaAgentGrade'
import { WarehouseInfo } from '@/class/model/booking/WarehouseInfo'
import { saveSeaBookingSpace as saveSeaBookingSpaceSE } from '@/api/seaExport/seaExportJob'
import { saveSeaBookingSpace as saveSeaBookingSpaceSI } from '@/api/SeaImport/seaImportJob'
import { saveAeBookingSpace } from '@/api/AirExport/airExportJob'
import { saveRailwayExport } from '@/api/railwayExport/reBooking'
import { CheckCargoDocHistory } from '@/class/model/booking/CheckCargoDocHistory'
import { isVesselOrVoyageChanged } from './vesselVoyageChangeRules'
import {
  CARGODOC_CFM_STATE_CMPFEED,
  CARGODOC_CFM_STATE_SHIPPER_CONFIRMED,
  CARGODOC_CFM_STATE_YQR, EXPORT_CONTROLLED_PRODUCT_YES_NOT_PERMISSION,
  OPEN_PRICE_REMINDER_TYPE_NOT_RECORD,
  OPEN_PRICE_REMINDER_TYPE_NOT_SAVE, OPEN_PRICE_REMINDER_TYPE_REMINDER_USER,
  PORT_TYPE_AIRPORT,
  PORT_TYPE_SEAPORT
} from '@/class/cargo/model/parameters/SystemConstants'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import lodash from 'lodash'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import { checkJobAtdDescFunc, checkEtdDaysCreditInfo, getCreditInfoByJobUuid } from '@/api/partner/creditInfo'
import * as ChargeItemTarget from '@/class/cargo/model/parameters/ChargeItemTarget'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import { getTransportationModeAll } from '@/api/basicData/transshipmentTransportationMode'
import { getCompanyList } from '@/api/company'
import { queryIataPriceCarrier } from '@/api/price/iataPrice'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import * as SpecialFieldConstants from '@/utils/SpecialFieldConstants'
import * as AdvancedSearchConsts from '@/class/cargo/model/utils/AdvancedSearchConsts'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import * as ediApi from '@/api/seaExport/edi'
import * as BillingConstants from '@/class/cargo/model/parameters/BillingConstants'
import { getEDITemplate } from '@/api/sysManage/baseConfig/ediTemplate'
import { ModelMap } from '@/class/cargo/model/parameters/ModelMap'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { getShippingContract } from '@/api/price/priceFcl'
import { REQUIRE_USER_DEFINED_FIELD_1 } from '@/class/cargo/model/parameters/CheckRuleConstants'
import { loadingShipTime } from '@/api/voyage'
import { executeOpenPriceWarning, matchOpenPriceConfig } from '@/api/sysManage/aviationExchangePrice'
import i18n from '@/lang'
import { checkSensitiveWord } from '@/api/basicData/sensitiveWord'
import {
  CARGO_CHINESE_NAME,
  CARGO_ENGLISH_NAME
} from '@/views/cargo/v0/Information/components/sensitiveWord/SensitiveWordConstant'
import { getAllShipCompany, getByUuidShipCompany } from '@/api/partner/shipping'
import fa from 'element-ui/src/locale/lang/fa'

export const COMPARE_FIELD = { '航班号': 'voyageFlight', '订舱日期': 'bookingDate', '实际进场时间': 'actualEntryTime', '实际配载时间': 'actualLoadingTime', '预计起飞时间': 'estimatedDepartureTime', '实际起飞时间': 'actualDepartureTime', '预计抵达时间': 'estimatedArrivalTime', '实际抵达时间': 'actualArrivalTime', '实际收单时间': 'actualReceivingTime', '实际卸货时间': 'actualUnloadingTime', '实际到货通知时间': 'actualArrivalNotificationTime', '实际提货时间': 'actualPickupTime', '二程航班号': 'secondVoyage', '二程起运港(代码)': 'secondPolCode', '二程起运港': 'secondPol', '二程目的港(代码)': 'secondPodCode', '二程目的港': 'secondPod', '预计抵达中转时间': 'estimatedTransferArrivalTime', '抵达中转时间': 'transferArrivalTime', '预计中转起飞时间': 'estimatedTransferDepartureTime', '中转起飞时间': 'transferDepartureTime' }

export class JobUtils {
  /**
   * 航线/港口预设配置缓存
   */
  static regionPortPresetConfigCache = new Map()

  //   /**
  //    * 计算计费重量：针对空运订舱统一按照配置来
  //    * 0:四舍五入，保留3位小数
  //    * 1、不保留小数，直接取整
  //    * 2、小于等于0.5取0.5，大于0.5取1
  //    */
  static calcChargeWeight(weight, cubage, isRound, cWeightCeil) {
    weight = isNaN(weight) ? 0 : weight
    cubage = isNaN(cubage) ? 0 : cubage
    if (Number(cWeightCeil) === 4) {
      return Math.max(NumberUtils.ToFixed2(cubage * 167, 1), weight)
    }
    const value = Math.max(weight, cubage * 1000 / 6)
    if (!isRound) { // 如果是HAWB提单，则不改变规则，直接取3位数。
      return Number(value.toFixed(3))
    }
    if (Number(cWeightCeil) === 1) {
      return Math.ceil(value)
    } else if (Number(cWeightCeil) === 2) {
      return NumberUtils.roundHalfUp2(value, 0)
    } else if (Number(cWeightCeil) === 3) {
      // CARGO-40148 中邮，“空运计费重量取整”配置增加关闭项 保留三位 正常四舍五入
      return Number(value.toFixed(3))
    } else {
      return this.safeWeight(value)
    }
  }

  static calcChargeWeight2(weight, isRound = true, cWeightCeil = '0') {
    if (Number(cWeightCeil) === 4) {
      return weight
    }
    if (!isRound) { // 如果是HAWB提单，则不改变规则，直接取3位数。
      return NumberUtils.parseNumber(weight, 3)
    }
    if (Number(cWeightCeil) === 1) {
      return Math.ceil(weight)
    } else if (Number(cWeightCeil) === 2) {
      return NumberUtils.roundHalfUp2(weight, 0)
    } else if (Number(cWeightCeil) === 3) {
      // CARGO-40148 中邮，“空运计费重量取整”配置增加关闭项 保留三位 正常四舍五入
      return Number(weight.toFixed(3))
    } else {
      return this.safeWeight(weight)
    }
  }

  /**
     * 分泡计算
     */
  static calcProportion(propRate, weight, cubage, isRound = true, cWeightCeil = '0', splitBubbleCollectionFormat = false) {
    weight = Number(weight) || 0
    cubage = Number(cubage) || 0
    if (Number(cWeightCeil) === 4) {
      return Math.max(NumberUtils.ToFixed2(cubage * 167, 1), weight)
    }
    if (propRate === 0 || isNaN(propRate)) {
      return this.calcChargeWeight(weight, cubage, isRound, cWeightCeil)
    }

    let propedWeight = 0
    if (cubage / 0.006 > weight) {
      if (splitBubbleCollectionFormat) {
        const state = CommonState.getStateByCode(SPLIT_BUBBLE_COLLECT_ITEMS, propRate)
        if (state) {
          const names = state.chineseName.split('/')
          const molecule = Number(names[0]) // 分子
          const denominator = Number(names[1]) // 分母
          propedWeight = weight + NumberUtils.ToFixed2((cubage / 0.006 - weight) / denominator * molecule, 3)
        } else {
          propedWeight = weight + (cubage / 0.006 - weight) * (propRate / 100)
        }
      } else {
        propedWeight = weight + (cubage / 0.006 - weight) * (propRate / 100)
      }
    } else {
      propedWeight = this.calcChargeWeight(weight, cubage, isRound, cWeightCeil)
    }
    /* if(!isRound) {
      formatter.fractionalDigits = 3
      }
      return isRound ? JobUtils.safeWeight(propedWeight) : formatter.parseNumber(formatter.format(propedWeight))*/
    return this.calcChargeWeight2(propedWeight, isRound, cWeightCeil)
  }

  /**
   * 小于等于0.5KG的都进位到0.5，超过0.5的都进位到整数位
   */
  static safeWeight(value) {
    let v = Number(value)
    if (!isNaN(value)) {
      const a = Math.floor(value)
      const b = value - a
      if (b < 0.501 && b >= 0.001) {
        v = a + 0.5
      } else if (b >= 0.501) {
        v = a + 1
      } else {
        v = a
      }
    }
    return v
  }

  //   /**
  //    * 格式化进仓编号,去除中划线和空格
  //    */
  //   static function formatWarehouseNo(value: String): String {
  //     if (value == null)
  //       return null
  //     var reg1: RegExp = /-/g
  //     value = value.replace(reg1, "")
  //     var reg2: RegExp = /\s/g
  //     value = value.replace(reg2, "")
  //     return value
  //   }

  //   /**
  //    * 格式化进仓编号,去除空格
  //    */
  //   static function formatWarehouseNo1(value: String): String {
  //     if (value == null)
  //       return null
  //     var reg2: RegExp = /\s/g
  //     value = value.replace(reg2, "")
  //     return value
  //   }

  //   /**
  //    * 船名航次
  //    */
  //   static function getVesselFlight(job: Job): String {
  //     if (job == null) {
  //       return ""
  //     }
  //     if (job.vessel != null && job.vessel != '' && job.voyageFlight != null && job.voyageFlight != '') {
  //       return job.vessel + "/" + job.voyageFlight
  //     }
  //     else if (job.vessel != null && job.voyageFlight == null) {
  //       return job.vessel
  //     }
  //     else if (job.vessel == null && job.voyageFlight != null) {
  //       return job.voyageFlight
  //     }
  //     return ""
  //   }

  //   /**
  //    * 按业务类型过滤
  //    */
  //   static function brokerFilter(job: Job, company: Company): Boolean {
  //     if (job == null)
  //       return true
  //     else if (job.lob == "SE")
  //       return company.isSeaExport
  //     else if (job.lob == "SI")
  //       return company.isSeaImport
  //     else if (job.lob == "AE")
  //       return company.isAirExport
  //     else if (job.lob == "AI")
  //       return company.isAirImport
  //     else
  //       return true
  //   }

  //   /**
  //    * 1.current 新的Job
  //    * 2.target 原有Job
  //    * 3.opType 操作类型(复制费用、发送分公司)
  //    * 在委托公司向被委托公司发送业务时，把相关的费用也发至被委托公司
  //    */
  //   static function copyJobCharge(current: Job, target: Job, opType: int = 0): void {
  //     var costTotalRMB: Number = 0
  //     var costTotalUSD: Number = 0
  //     var sellingTotalRMB: Number = 0
  //     var sellingalUSD: Number = 0
  //     var usdRate: Number = 0
  //     for each(var charge: Charge in target.charges)
  //     {
  //       if (!charge.isAdvance && !charge.isControlled && charge.measure != "BOX") {
  //         // CARGO-2711，用户复制【费用】的时候，只能复制普通费用
  //         if (charge.isSpecial) {
  //           continue
  //         }
  //         var copiedCharge: Charge = new Charge()
  //         copiedCharge.branchId = charge.branchId
  //         if (opType == 0) {
  //           copiedCharge.isReceivable = charge.isReceivable
  //         } else if (opType == 1) {
  //           copiedCharge.isReceivable = true
  //         }
  //         copiedCharge.chargeItemId = charge.chargeItemId
  //         copiedCharge.accountId = charge.accountId
  //         copiedCharge.currency = charge.currency
  //         copiedCharge.exchangeRate = RateUtil.getForeignExchangeRateByJob("RMB", copiedCharge.currency, target, function (rate: Number): void {
  //           copiedCharge.exchangeRate = rate
  //         })
  //         copiedCharge.measure = charge.measure
  //         copiedCharge.quantity = charge.quantity
  //         copiedCharge.unitRate = charge.unitRate
  //         copiedCharge.amount = charge.amount
  //         copiedCharge.taxAmount = charge.taxAmount
  //         copiedCharge.taxRate = charge.taxRate
  //         copiedCharge.excludingTaxAmount = charge.excludingTaxAmount
  //         copiedCharge.isOversea = charge.isOversea
  //         copiedCharge.remarks = charge.remarks
  //         copiedCharge.job = current
  //         if (copiedCharge.currency == "RMB") {
  //           if (copiedCharge.isReceivable) {
  //             costTotalRMB += copiedCharge.amount
  //           } else {
  //             sellingTotalRMB += copiedCharge.amount
  //           }
  //         } else if (copiedCharge.currency == "USD") {
  //           if (copiedCharge.isReceivable) {
  //             costTotalUSD += copiedCharge.amount
  //           } else {
  //             sellingalUSD += copiedCharge.amount
  //           }
  //           usdRate = copiedCharge.exchangeRate
  //         } else { }
  //         // CARGO-7916 复制费用时，费用序号一起复制
  //         copiedCharge.serialNumber = charge.serialNumber
  //         copiedCharge.invoiceTitle = charge.invoiceTitle
  //       }
  //     }

  //     //处理新增的没有开票抬头的费用
  //     doChargeInvoiceTitle(target)
  //     //计算预估利润总值
  //     getJobEstimateNumbers(current, costTotalRMB, costTotalUSD, sellingTotalRMB, sellingalUSD, usdRate)
  //   }

  //   static var resourceManager: IResourceManager = ResourceManager.getInstance()

  //   static function doChargeInvoiceTitle(job: Job) {
  //     var compKeys: IList = new ArrayCollection()
  //     for each(var c: Charge in job.charges) {
  //       // 新增
  //       if (c.isNewInstance() && c.accountId > 0 && (c.invoiceTitle == null || c.invoiceTitle == "")) {
  //         compKeys.addItem(c.accountId)
  //       }
  //     }
  //     if (compKeys.length > 0) {
  //       Title.queryDefaultTitlesByCompanyIds2(compKeys, function (event: ResultEvent): void {
  //         var titleMap: Object = event.result as Object
  //         if (titleMap) {
  //           for each(var c: Charge in job.charges) {
  //         // 新增
  //         if (c.isNewInstance() && c.accountId > 0 && titleMap.hasOwnProperty(String(c.accountId))) {
  //           if (titleMap[String(c.accountId)] != null)
  //             c.invoiceTitle = titleMap[String(c.accountId)]
  //         }
  //       }
  //     }
  //     for each(var c: Charge in job.charges) {
  //       if (c.invoiceTitle == "" || c.invoiceTitle == null) {
  //         var company: Company = Company.getCompanyById(c.accountId)
  //         if (company) {
  //           if (resourceManager.localeChain[0] == "zh_CN") {
  //             if (StringUtil.trim(company.chineseName) == "") {
  //               c.invoiceTitle = company.englishName
  //             }
  //             c.invoiceTitle = company.chineseName
  //           }
  //           else {
  //             c.invoiceTitle = company.englishName
  //           }
  //         }
  //       }
  //     }
  //   }, function(event: FaultEvent): void {
  //     //
  //   })
  // }
  // 		}

  // /**
  //  * 发送分copy应付费用
  //  */
  // static function copySellingCharge(current: Job, target: Job): void {
  //   var costTotalRMB: Number = 0
  //   var costTotalUSD: Number = 0
  //   var sellingTotalRMB: Number = 0
  //   var sellingalUSD: Number = 0
  //   var usdRate: Number = 0
  //   for each(var charge: Charge in target.charges)
  //   {
  //     if (!charge.isAdvance && !charge.isReceivable && charge.accountId == target.bookingAgent) {
  //       var copiedCharge: Charge = new Charge()
  //       copiedCharge.isReceivable = true
  //       copiedCharge.inputDate = new Date()
  //       copiedCharge.inputBy = Session.getInstance().user.userId
  //       copiedCharge.branchId = Session.getInstance().currentOffice.officeId
  //       copiedCharge.inputByDep = Session.getInstance().currentDepartment.departmentId
  //       copiedCharge.chargeItemId = charge.chargeItemId
  //       copiedCharge.accountId = current.customerId
  //       copiedCharge.currency = charge.currency
  //       copiedCharge.exchangeRate = RateUtil.getForeignExchangeRateByJob("RMB", copiedCharge.currency, current, function (rate: Number): void {
  //         copiedCharge.exchangeRate = rate
  //       })
  //       copiedCharge.measure = charge.measure
  //       copiedCharge.quantity = charge.quantity
  //       copiedCharge.unitRate = charge.unitRate
  //       copiedCharge.amount = charge.amount
  //       copiedCharge.taxAmount = charge.taxAmount
  //       copiedCharge.taxRate = charge.taxRate
  //       copiedCharge.excludingTaxAmount = charge.excludingTaxAmount
  //       copiedCharge.isOversea = charge.isOversea
  //       copiedCharge.remarks = charge.remarks
  //       copiedCharge.job = current
  //       if (copiedCharge.currency == "RMB") {
  //         costTotalRMB += copiedCharge.amount
  //       } else if (copiedCharge.currency == "USD") {
  //         costTotalUSD += copiedCharge.amount
  //         usdRate = copiedCharge.exchangeRate
  //       } else { }
  //     }
  //   }
  //   getJobEstimateNumbers(current, costTotalRMB, costTotalUSD, sellingTotalRMB, sellingalUSD, usdRate)
  // }

  // /**
  //  *
  //  * 复制舱单数据格式化
  //  * @param currentJob
  //  * @param targetJob
  //  */
  // static function copyJobManifestInfo(targetJob: Job, sourceJob: Job): void {
  //   if (sourceJob == null || targetJob == null || sourceJob.manifestInfos == null || sourceJob.manifestInfos.length == 0)
  //     return
  //   var manifestInfos: ArrayCollection = new ArrayCollection()
  //   for each(var source: ManifestInfo in sourceJob.manifestInfos) {
  //     var target: ManifestInfo = ManifestInfo.copy(source)
  //     target.job = targetJob
  //     manifestInfos.addItem(target)
  //   }
  //   targetJob.manifestInfos = manifestInfos
  // }

  // /**
  //  *
  //  * 复制第一单舱单数据格式化信息
  //  * @param currentJob
  //  * @param targetJob
  //  */
  // static function copyJobFirstManifestInfo(targetJob: Job, sourceJob: Job): void {
  //   if (sourceJob == null || targetJob == null || sourceJob.manifestInfos == null || sourceJob.manifestInfos.length == 0)
  //     return
  //   var manifestInfos: ArrayCollection = new ArrayCollection()
  //   var source: ManifestInfo = sourceJob.manifestInfos.getItemAt(0) as ManifestInfo
  //   var target: ManifestInfo = ManifestInfo.copy(source)
  //   target.job = targetJob
  //   manifestInfos.addItem(target)

  //   targetJob.manifestInfos = manifestInfos
  // }

  // /**
  //  * 计算Job预估费用
  //  */
  // private static function getJobEstimateNumbers(current: Job, costTotalRMB: Number, costTotalUSD: Number, sellingTotalRMB: Number, sellingalUSD: Number, usdRate: Number): void {
  //   current.EstimateAccountsReceivable = Number((costTotalRMB + (costTotalUSD * usdRate)).toFixed(2))
  //   current.EstimateAccountsPayable = Number((sellingTotalRMB + (sellingalUSD * usdRate)).toFixed(2))
  //   current.EstimateGrossProfit = Number((current.EstimateAccountsReceivable - current.EstimateAccountsPayable).toFixed(2))
  // }

  // /**
  //  * 同步小票仓库信息
  //  */
  // static function refreshLclSlavesWarehouseInfo(current: Job, target: Job): void {
  //   var warehouseInfo: WarehouseInfo = null
  //   if (current.warehouseInfo == null || current.warehouseInfo.length == 0) {
  //     warehouseInfo = new WarehouseInfo()
  //   } else {
  //     warehouseInfo = current.warehouseInfo.getItemAt(0) as WarehouseInfo
  //   }
  //   if (target.warehouseInfo && target.warehouseInfo.length > 0) {
  //     var targetWarehouseInfo: WarehouseInfo = target.warehouseInfo.getItemAt(0) as WarehouseInfo
  //     warehouseInfo.quantity = targetWarehouseInfo.quantity
  //     warehouseInfo.warehouseCmp = targetWarehouseInfo.warehouseCmp
  //     warehouseInfo.warehouseContact = targetWarehouseInfo.warehouseContact
  //     warehouseInfo.warehouseContactTel = targetWarehouseInfo.warehouseContactTel
  //     warehouseInfo.arriveDate = targetWarehouseInfo.arriveDate
  //     warehouseInfo.warehouseAddress = targetWarehouseInfo.warehouseAddress
  //     warehouseInfo.remarks = targetWarehouseInfo.remarks
  //     warehouseInfo.job = current
  //   }
  // }

  // /**
  //  * 复制仓库信息
  //  */
  // static function copyJobWareHouse(current: Job, target: Job, isCreateCharge: Boolean = true): void {
  //   if (target && target.warehouseInfo && target.warehouseInfo.length > 0) {
  //     var targetWarehouseInfo: WarehouseInfo = target.warehouseInfo.getItemAt(0) as WarehouseInfo
  //     var warehouseInfo: WarehouseInfo = new WarehouseInfo()
  //     warehouseInfo.quantity = targetWarehouseInfo.quantity
  //     warehouseInfo.warehouseCmp = targetWarehouseInfo.warehouseCmp
  //     warehouseInfo.warehouseContact = targetWarehouseInfo.warehouseContact
  //     warehouseInfo.warehouseContactTel = targetWarehouseInfo.warehouseContactTel
  //     warehouseInfo.arriveDate = targetWarehouseInfo.arriveDate
  //     warehouseInfo.warehouseAddress = targetWarehouseInfo.warehouseAddress
  //     warehouseInfo.remarks = targetWarehouseInfo.remarks
  //     if (isCreateCharge) {
  //       var chargeItemId: int = parseInt(Config.configMap["WarehousePackingFeeCode"])
  //       var oldCharge: Charge = getCostCharge(target, chargeItemId) //装箱费
  //       if (oldCharge && oldCharge.accountId > 0) {
  //         var charge: Charge = createPackingCharge(current)
  //         charge.chargeItemId = chargeItemId
  //         charge.branchId = oldCharge.branchId
  //         charge.accountId = oldCharge.accountId
  //         charge.measure = oldCharge.measure
  //         charge.quantity = oldCharge.quantity
  //         charge.unitRate = oldCharge.unitRate
  //         charge.amount = oldCharge.amount
  //         charge.taxAmount = oldCharge.taxAmount
  //         charge.taxRate = oldCharge.taxRate
  //         charge.excludingTaxAmount = oldCharge.excludingTaxAmount
  //         charge.remarks = oldCharge.remarks
  //       }
  //     }
  //     warehouseInfo.job = current
  //   }
  // }

  // /**
  //  * 复制门点装箱
  //  */
  // static function copyJobTruckingInfo(current: Job, target: Job, isCreateCharge: Boolean = true): void {

  //   if (target && target.trucking && target.trucking.length > 0) {
  //     for each(var trucking: TruckingInfo in target.trucking)
  //     {
  //       var truckingInfo: TruckingInfo = new TruckingInfo()
  //       truckingInfo.job = current
  //       truckingInfo.truckOrderNo = createTruckOrderNo(current)
  //       truckingInfo.carryingCmp = trucking.carryingCmp
  //       truckingInfo.driver = trucking.driver
  //       truckingInfo.driverTel = trucking.driverTel
  //       truckingInfo.weight = trucking.weight
  //       truckingInfo.cubage = trucking.cubage
  //       truckingInfo.quantity = trucking.quantity
  //       truckingInfo.loadingDate = trucking.loadingDate
  //       truckingInfo.doorName = trucking.doorName
  //       truckingInfo.doorAddr = trucking.doorAddr
  //       truckingInfo.doorMan = trucking.doorMan
  //       truckingInfo.doorManTel = trucking.doorManTel
  //       truckingInfo.remarks = trucking.remarks
  //       truckingInfo.soNo = trucking.soNo
  //       if (isCreateCharge) {
  //         var chargeItemId: int = parseInt(Config.configMap["TruckingFeeCode"])
  //         var oldCharge: Charge = getCostCharge(target, chargeItemId) //装箱费
  //         if (oldCharge && oldCharge.accountId > 0) {
  //           var charge: Charge = createPackingCharge(current)
  //           charge.chargeItemId = chargeItemId
  //           charge.branchId = oldCharge.branchId
  //           charge.accountId = oldCharge.accountId
  //           charge.measure = oldCharge.measure
  //           charge.quantity = oldCharge.quantity
  //           charge.unitRate = oldCharge.unitRate
  //           charge.amount = oldCharge.amount
  //           charge.taxAmount = oldCharge.taxAmount
  //           charge.taxRate = oldCharge.taxRate
  //           charge.excludingTaxAmount = oldCharge.excludingTaxAmount
  //           charge.remarks = oldCharge.remarks
  //         }
  //       }
  //     }
  //   }
  // }

  // /**
  //  * 获取装箱费用
  //  */
  // static function getCostCharge(job: Job, chargeCode: int): Charge {
  //   var c: Charge = null
  //   for each(var charge: Charge in job.charges)
  //   {
  //     if (charge.chargeItemId == chargeCode && !charge.isReceivable) {
  //       c = charge
  //       break
  //     }
  //   }
  //   return c
  // }

  // /**
  //  * 创建装箱费
  //  */
  // static function createPackingCharge(job: Job): Charge {
  //   var charge: Charge = new Charge()
  //   charge.job = job
  //   charge.quantity = 1
  //   charge.currency = "RMB"
  //   charge.exchangeRate = RateUtil.getForeignExchangeRateByJob("RMB", charge.currency, job, function (rate: Number): void {
  //     charge.exchangeRate = rate
  //   })
  //   charge.measure = "NML"
  //   charge.isReceivable = false
  //   charge.isOversea = false
  //   charge.verifiedAmount = 0
  //   charge.inputDate = new Date()
  //   charge.inputBy = Session.getInstance().user.userId
  //   charge.branchId = Session.getInstance().currentOffice.officeId
  //   return charge
  // }

  // /**
  //  * 复制报关行信息
  //  */
  // static function copyCustomsBroker(current: Job, target: Job): void {
  //   current.customsBroker = target.customsBroker
  //   current.customsRemarks = target.customsRemarks
  // }

  /**
   * 创建单证流转记录
   */
  static createFile(invoice = null, invoiceNo = null) {
    if (!invoice) {
      return null
    }
    const charges = invoice['chargeList']
    if (!charges) {
      return null
    }
    const files = []
    const jobMap = new Map()
    for (let i = 0; i < charges.length; i++) {
      const charge = charges[i]
      if (!jobMap.has(charge['jobUuid'])) {
        jobMap[charge['jobUuid']] = charge
      }
    }
    jobMap.forEach(function(value, key) {
      const charge = value
      const file = {}
      file.jobUuid = charge['jobUuid']
      file.customsBroker = 0
      if (charge['jobCustomerId']) {
        const customer = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(charge['jobCustomerId']))
        if (customer != null) {
          file.receiveCompany = customer.chineseName
          file.expressAddress = customer.address
        }
      } else {
        file.receiveCompany = ''
        file.expressAddress = ''
      }
      file.receiveDate = new Date()
      file.receivePerson = charge['jobCustomerContact']
      file.receiveTel = charge['jobContactTelephone']
      file.isTax = false
      file.inputBy = $store.getters.userId
      file.inputDate = new Date()
      file.branchId = $store.getters.currentOfficeId
      file.inputByDep = $store.getters.currentDeptId
      file.fileType = FileType.INV_TYPE.code // 发票
      file.fileNo = invoiceNo
      file.originFileId = invoice.uuid
      files.push(file)
    })
    return files
  }

  /**
   * 货物明细汇总
   */
  static getWarehouseInDetail(warehouseInDetails) {
    if (!warehouseInDetails || warehouseInDetails.length === 0) {
      return ''
    }
    let str = ''
    let quantity = 0
    let weight = 0
    let cubage = 0
    let brokenQuantity = 0
    for (const warehouseIn of warehouseInDetails) {
      quantity += warehouseIn.quantitySum
      weight += warehouseIn.weightSum
      cubage += warehouseIn.cubageSum
      if (warehouseIn.broken) {
        brokenQuantity += warehouseIn.brokenQuantity
      }
    }
    str += '件数:' + quantity.toFixed(0)
    str += '\r'
    str += '重量:' + weight.toFixed(2)
    str += '\r'
    str += '体积:' + cubage.toFixed(3)
    str += '\r'
    if (brokenQuantity > 0) {
      str += '有破损'
      str += '  破损件数:' + brokenQuantity.toFixed(0)
    } else {
      str += '无破损'
    }
    return str
  }

  // /**
  //  * 获取锦绣报关行
  //  */
  // static function getJxBrokerCustomsEdi(): Array {
  //   var ids: Array = []
  //   var result: String = String(Config.configMap["JxBrokerCustomsEdi"])
  //   if (result != null && result != "")
  //     ids = result.split(",")
  //   return ids
  // }

  /**
   * 派车单号生成
   */
  static createTruckOrderNo(job) {
    if (!job || !job.uuid) {
      return ''
    }
    let count = 1
    if (job.trucking && job.trucking.length > 0) {
      // 是否有派车单号中不包含业务编号的数据
      let hasNoContainsJobNo = false
      // 含业务编号的最大序号，防止派车单号重复
      let maxNumber = 0
      for (const item of job.trucking) {
        if (item.showTruckOrderNo) {
          if (String(item.showTruckOrderNo).startsWith(job.jobNo + '_')) {
            const num = item.showTruckOrderNo.replace(`${job.jobNo}_`, '')
            if (!isNaN(num) && maxNumber < Number(num)) {
              maxNumber = Number(num)
            }
          } else {
            hasNoContainsJobNo = true
          }
        }
      }
      if (hasNoContainsJobNo) {
        // 判断一下，防止派车单号重复
        if (job.trucking.length + 1 > maxNumber) {
          count = job.trucking.length + 1
        } else {
          count = maxNumber + 1
        }
      } else {
        const truckingSorted = job.trucking.sort((a, b) => {
          const suffixA = a.truckOrderNo.replace(`${job.jobNo}_`, '')
          const suffixB = b.truckOrderNo.replace(`${job.jobNo}_`, '')
          return suffixA - suffixB
        })
        const lastTruck = truckingSorted[truckingSorted.length - 1]
        count = Number(lastTruck.truckOrderNo.replace(`${job.jobNo}_`, '')) + 1
      }
    }
    return job.jobNo + '_' + count
  }

  /**
   * 派车单号生成
   */
  static createShowTruckOrderNo(job, hcInfoTrucking) {
    if (!job || !job.uuid) {
      return ''
    }
    let count = 1
    if (hcInfoTrucking && hcInfoTrucking.length > 0) {
      // 是否有派车单号中不包含业务编号的数据
      let hasNoContainsJobNo = false
      // 含业务编号的最大序号，防止派车单号重复
      let maxNumber = 0
      for (const item of hcInfoTrucking) {
        if (item.showTruckOrderNo) {
          if (String(item.showTruckOrderNo).startsWith(job.jobNo + '_')) {
            const num = item.showTruckOrderNo.replace(`${job.jobNo}_`, '')
            if (!isNaN(num) && maxNumber < Number(num)) {
              maxNumber = Number(num)
            }
          } else {
            hasNoContainsJobNo = true
          }
        }
      }
      if (hasNoContainsJobNo) {
        // 判断一下，防止派车单号重复
        if (hcInfoTrucking.length + 1 > maxNumber) {
          count = hcInfoTrucking.length + 1
        } else {
          count = maxNumber + 1
        }
      } else {
        const truckingSorted = hcInfoTrucking.sort((a, b) => {
          const suffixA = a.showTruckOrderNo.replace(`${job.jobNo}_`, '')
          const suffixB = b.showTruckOrderNo.replace(`${job.jobNo}_`, '')
          return suffixA - suffixB
        })
        const lastTruck = truckingSorted[truckingSorted.length - 1]
        count = Number(lastTruck.showTruckOrderNo.replace(`${job.jobNo}_`, '')) + 1
      }
    }
    return job.jobNo + '_' + count
  }

  /**
   * 目的地派送派车单号生成
   */
  static createTruckOrderNoForPod(job) {
    if (!job || !job.uuid) {
      return ''
    }
    let count = 1
    if (job.truckingInfoPods && job.truckingInfoPods.length) {
      const truckingSorted = job.truckingInfoPods.sort((a, b) => {
        const suffixA = a.truckOrderNo.replace(`${job.jobNo}_`, '')
        const suffixB = b.truckOrderNo.replace(`${job.jobNo}_`, '')
        return suffixA - suffixB
      })
      const lastTruck = truckingSorted[truckingSorted.length - 1]
      count = Number(lastTruck.truckOrderNo.replace(`${job.jobNo}_`, '')) + 1
    }
    return job.jobNo + '_' + count
  }

  /**
   * 派车单号生成
   */
  static createDanNo(job) {
    if (job === null || StrUtils.isEmpty(job.uuid)) {
      return ''
    }
    const prefix = job.jobNo + '_'
    let count = 1
    if (job.specialGoods && job.specialGoods.length > 1) {
      const length = job.specialGoods.length
      const lastDanNo = job.specialGoods[length - 2].danNo.replace(prefix, '')
      count = Number(lastDanNo) + 1
    }
    return prefix + count
  }

  // /**
  //  * 同步件毛体,计费重量(很久以前被注释，改为在后台job实体同步,修改到后台同步的原因未知)
  //  */
  // static function refreshLclSlavesQwc(lclMaster: Job): void {
  //   //			var actQuantity:Number =0.0
  //   //			var actWeight:Number = 0.0
  //   //			var actCubage:Number = 0.0
  //   //			var cntQuantity:Number = 0.0
  //   //			var cntWeight:Number = 0.0
  //   //			var cntCubage:Number = 0.0
  //   //			var chargeWeight:Number = 0.0
  //   //			for each(var lclJob:Job in lclMaster.lclSlaves)
  //   //			{
  //   //				actQuantity += lclJob.quantityActual
  //   //				actWeight += lclJob.weightActual
  //   //				actCubage += lclJob.cubageActual
  //   //				cntQuantity += lclJob.quantityContract
  //   //				cntWeight += lclJob.weightContract
  //   //				cntCubage += lclJob.cubageContract
  //   //				chargeWeight += lclJob.chargeWeight
  //   //			}
  //   //			lclMaster.quantityActual = actQuantity
  //   //			lclMaster.weightActual = actWeight
  //   //			lclMaster.cubageActual = actCubage
  //   //			lclMaster.quantityContract = cntQuantity
  //   //			lclMaster.weightContract = cntWeight
  //   //			lclMaster.cubageContract = cntCubage
  //   //			lclMaster.chargeWeight = chargeWeight
  // }

  // /**
  //  * 同步件毛体,计费重量(移除小票和加入小票时,对主单件毛体计费重量重新计算)
  //  */
  // static function refreshLclSlavesQwc2(lclMaster: Job): void {
  //   var actQuantity: Number = 0.0
  //   var actWeight: Number = 0.0
  //   var actCubage: Number = 0.0
  //   var cntQuantity: Number = 0.0
  //   var cntWeight: Number = 0.0
  //   var cntCubage: Number = 0.0
  //   var chargeWeight: Number = 0.0
  //   for each(var lclJob: Job in lclMaster.lclSlaves)
  //   {
  //     actQuantity += lclJob.quantityActual
  //     actWeight += lclJob.weightActual
  //     actCubage += lclJob.cubageActual
  //     cntQuantity += lclJob.quantityContract
  //     cntWeight += lclJob.weightContract
  //     cntCubage += lclJob.cubageContract
  //     chargeWeight += lclJob.chargeWeight
  //   }
  //   lclMaster.quantityActual = actQuantity
  //   lclMaster.weightActual = actWeight
  //   lclMaster.cubageActual = actCubage
  //   lclMaster.quantityContract = cntQuantity
  //   lclMaster.weightContract = cntWeight
  //   lclMaster.cubageContract = cntCubage
  //   lclMaster.chargeWeight = chargeWeight
  // }

  /**
   * 系统保持：job中的报关行、报关管理中报关行、文件管理中报关单类型文件的报关行统一，更改一处后别处也更新。
   */
  static async synCustomsBroker(job, customsBroker, type = 0) {
    await cache.load(cacheName.CONFIG)
    const syncMode = Number(cache.config.get('CustomsBrokerSynMode'))
    if (syncMode === 1 && customsBroker > 0) {
      await new Job(job).getCustomsInfo()
      switch (type) {
        case 0:
          await new Job(job).getFile()
          for (const file of job.file) {
            if (file.fileType === '3') {
              file.customsBroker = customsBroker
            }
          }
          for (const csInfo of job.customsInfo) {
            csInfo.customsBroker = customsBroker
          }
          break
        case 1:
          job.customsBroker = customsBroker
          for (const csInfo2 in job.customsInfo) {
            csInfo2.customsBroker = customsBroker
          }
          break
        default:
          break
      }
    }
  }

  // /**
  //  * @private
  //  */
  // static function getJoinContainerNo(job: Job): String {
  //   var containerNo: String = ""
  //   for each(var c: Container in job.containers)
  //   {
  //     if (containerNo.length == 0 && c.containerNo != null && c.containerNo != "") {
  //       containerNo = c.containerNo
  //     }
  //     else {
  //       if (c.containerNo != null && c.containerNo != "") {
  //         containerNo += ("," + c.containerNo)
  //       }
  //     }
  //   }
  //   return containerNo
  // }

  // /**
  //  * @private
  //  */
  // static function getJoinContainerNo2(job: Job): String {
  //   var containerNo: String = ""
  //   if (job.lclMaster) {
  //     for each(var cu: ContainerUsage in job.containerUsages) {
  //       var cc: Container = cu.container
  //       if (cc != null) {
  //         if (containerNo.length == 0 && cc.containerNo != null && cc.containerNo != "") {
  //           containerNo = cc.containerNo
  //         } else {
  //           if (cc.containerNo != null && cc.containerNo != "") {
  //             containerNo += ("," + cc.containerNo)
  //           }
  //         }
  //       }
  //     }
  //   } else {
  //     for each(var c: Container in job.containers) {
  //       if (containerNo.length == 0 && c.containerNo != null && c.containerNo != "") {
  //         containerNo = c.containerNo
  //       } else {
  //         if (c.containerNo != null && c.containerNo != "") {
  //           containerNo += ("," + c.containerNo)
  //         }
  //       }
  //     }
  //   }
  //   return containerNo
  // }

  // /**
  //  * @private
  //  */
  // static function getJoinContainerNoNew(job: Job): String {
  //   var containerNo: String = ""
  //   if (job.lclMaster) {
  //     for each(var cu: ContainerUsage in job.containerUsages) {
  //       var cc: Container = cu.container
  //       if (containerNo.length == 0 && cc.containerNo != null && cc.containerNo != "") {
  //         containerNo = cc.containerNo + "-" + cc.sealNo
  //       } else {
  //         if (cc.containerNo != null && cc.containerNo != "") {
  //           containerNo += ("," + cc.containerNo + "-" + cc.sealNo)
  //         }
  //       }
  //     }
  //   } else {
  //     containerNo = getContainerNo(job.containers)
  //   }
  //   return containerNo
  // }

  // static function getContainerNo(cList: ArrayCollection): String {
  //   var containerNo: String = ""
  //   for each(var c: Container in cList) {
  //     if (containerNo.length == 0 && c.containerNo != null && c.containerNo != "") {
  //       containerNo = c.containerNo + "-" + c.sealNo
  //     }
  //     else {
  //       if (c.containerNo != null && c.containerNo != "") {
  //         containerNo += ("," + c.containerNo + "-" + c.sealNo)
  //       }
  //     }
  //   }
  //   return containerNo
  // }

  // /**
  //  * 货量描述
  //  */
  // static function getSeaEqDesc(job: Job): String {
  //   var desc: String = ""
  //   for each(var seq: SeaEQ in job.seaEQ)
  //   {
  //     if (0 == desc.length) {
  //       desc = seq.EQquantity + "*" + seq.EQsize + seq.EQtype
  //     }
  //     else {
  //       desc += ("," + seq.EQquantity + "*" + seq.EQsize + seq.EQtype)
  //     }
  //   }
  //   return desc
  // }

  /**
   * 检查应付费用是否全部审核
   */
  static async checkChargeStateVerify(job) {
    var count = 0
    var overseaSellingDetails = []
    const charges = await new Job(job).getCharges()
    for (const charge of charges) {
      if (!charge.receivable) {
        overseaSellingDetails.push(charge)
      }
    }
    if (overseaSellingDetails.length === 0) {
      return false
    }
    for (const charge1 of overseaSellingDetails) {
      if (charge1.chargeState === 2) {
        count += 1
      }
    }
    return count === overseaSellingDetails.length
  }

  // /**
  //  * 双击业务列表中的job,业务编号定位到相应的详情中业务编号的位置
  //  */
  // static function jobNoLocation(jobGrid: AdvancedDataGrid, index: int, verticalScrollPositionInput: int = 0): Number {
  //   var height: Number = 0
  //   var rowCount: int = jobGrid.rowCount
  //   var verticalScrollPosition: int = verticalScrollPositionInput == 0 ? jobGrid.verticalScrollPosition : verticalScrollPositionInput
  //   var listView: HierarchicalCollectionView = jobGrid.dataProvider as HierarchicalCollectionView
  //   if (listView && listView.length > 0 && rowCount > 0) {
  //     var max: Number = jobGrid.maxVerticalScrollPosition
  //     var offset: int = index + 2 - rowCount - verticalScrollPosition
  //     if (offset <= 2 && offset >= 0) {
  //       height = index
  //     } else if (offset > - rowCount && offset <= 2 - rowCount) {
  //       height = verticalScrollPosition - (rowCount - 2)
  //     } else {
  //       height = verticalScrollPosition
  //       if (index > rowCount - 2 && verticalScrollPosition == 0) {
  //         height = index
  //       }
  //     }
  //     if (height < 0) {
  //       height = 0
  //     }
  //     if (max - height <= 1 || max <= height) {
  //       height = jobGrid.maxVerticalScrollPosition
  //     }
  //   }
  //   return int(height)
  // }

  /**
   * 将提单收发通代码同步至基本页签收发通代码(不考虑拆并单)
   * synchronousShipperCodeAndConsigneeCodeAndNotifyCode：是否开启同步
   * type:发生修变的字段
   * synchronization：同步方向（0:基本同步至提单,1：提单同步至基本）
   */
  static async synchronousShipperCodeAndConsigneeCodeAndNotifyCode(job, sycSCN, type, synchronization, manifestAddress = null) {
    if (sycSCN) {
      if (job.mblOnly) {
        // 勾选直单,将mbl提单收发通代码同步至基本页签
        const mblDoc = await new Job(job).getCargoDocByDocType(CargoDocConsts.MBL, false)
        if (mblDoc && mblDoc.state !== 3) {
          this.sycSCNBasicInformation(job, mblDoc, type, synchronization, manifestAddress)
        }
      } else {
        // 不勾选直单
        // a.勾选了HBL，取值HBL
        if (job.signHBL) {
          const hblDoc = await new Job(job).getCargoDocByDocType(CargoDocConsts.HBL, false)
          if (hblDoc) {
            this.sycSCNBasicInformation(job, hblDoc, type, synchronization, manifestAddress)
          }
        } else {
          // 如果勾选了MBL，取值MBL
          if (job.signMBL) {
            const mblDoc = await new Job(job).getCargoDocByDocType(CargoDocConsts.MBL, false)
            if (mblDoc) {
              this.sycSCNBasicInformation(job, mblDoc, type, synchronization, manifestAddress)
            }
          }
        }
      }
    }
  }

  // 同步收发通 1-7行
  static sycSCNBasicInformation(job, cargoDoc, type, synchronization, manifestAddress) {
    if (type === 'shipper') {
      if (synchronization === 0) {
        cargoDoc.shipperId = job.shipperId
        if (manifestAddress) {
          cargoDoc.shipperLine1 = manifestAddress.addressLine1
          cargoDoc.shipperLine2 = manifestAddress.addressLine2
          cargoDoc.shipperLine3 = manifestAddress.addressLine3
          cargoDoc.shipperLine4 = manifestAddress.addressLine4
          cargoDoc.shipperLine5 = manifestAddress.addressLine5
          cargoDoc.shipperLine6 = manifestAddress.addressLine6
          cargoDoc.shipperLine7 = manifestAddress.addressLine7
        } else {
          cargoDoc.shipperLine1 = ''
          cargoDoc.shipperLine2 = ''
          cargoDoc.shipperLine3 = ''
          cargoDoc.shipperLine4 = ''
          cargoDoc.shipperLine5 = ''
          cargoDoc.shipperLine6 = ''
          cargoDoc.shipperLine7 = ''
        }
      } else {
        job.shipperId = cargoDoc.shipperId
        if (manifestAddress) {
          job.shipperLine1 = manifestAddress.addressLine1
          job.shipperLine2 = manifestAddress.addressLine2
          job.shipperLine3 = manifestAddress.addressLine3
          job.shipperLine4 = manifestAddress.addressLine4
          job.shipperLine5 = manifestAddress.addressLine5
          job.shipperLine6 = manifestAddress.addressLine6
          job.shipperLine7 = manifestAddress.addressLine7
        } else {
          job.shipperLine1 = ''
          job.shipperLine2 = ''
          job.shipperLine3 = ''
          job.shipperLine4 = ''
          job.shipperLine5 = ''
          job.shipperLine6 = ''
          job.shipperLine7 = ''
        }
      }
    }
    if (type === 'consignee') {
      if (synchronization === 0) {
        cargoDoc.consigneeId = job.consigneeId
        if (manifestAddress) {
          cargoDoc.consigneeLine1 = manifestAddress.addressLine1
          cargoDoc.consigneeLine2 = manifestAddress.addressLine2
          cargoDoc.consigneeLine3 = manifestAddress.addressLine3
          cargoDoc.consigneeLine4 = manifestAddress.addressLine4
          cargoDoc.consigneeLine5 = manifestAddress.addressLine5
          cargoDoc.consigneeLine6 = manifestAddress.addressLine6
          cargoDoc.consigneeLine7 = manifestAddress.addressLine7
        } else {
          cargoDoc.consigneeLine1 = ''
          cargoDoc.consigneeLine2 = ''
          cargoDoc.consigneeLine3 = ''
          cargoDoc.consigneeLine4 = ''
          cargoDoc.consigneeLine5 = ''
          cargoDoc.consigneeLine6 = ''
          cargoDoc.consigneeLine7 = ''
        }
      } else {
        job.consigneeId = cargoDoc.consigneeId
        if (manifestAddress) {
          job.consigneeLine1 = manifestAddress.addressLine1
          job.consigneeLine2 = manifestAddress.addressLine2
          job.consigneeLine3 = manifestAddress.addressLine3
          job.consigneeLine4 = manifestAddress.addressLine4
          job.consigneeLine5 = manifestAddress.addressLine5
          job.consigneeLine6 = manifestAddress.addressLine6
          job.consigneeLine7 = manifestAddress.addressLine7
        } else {
          job.consigneeLine1 = ''
          job.consigneeLine2 = ''
          job.consigneeLine3 = ''
          job.consigneeLine4 = ''
          job.consigneeLine5 = ''
          job.consigneeLine6 = ''
          job.consigneeLine7 = ''
        }
      }
    }
    if (type === 'notify') {
      if (synchronization === 0) {
        cargoDoc.notifyId = job.notifyId
        if (manifestAddress) {
          cargoDoc.notifyLine1 = manifestAddress.addressLine1
          cargoDoc.notifyLine2 = manifestAddress.addressLine2
          cargoDoc.notifyLine3 = manifestAddress.addressLine3
          cargoDoc.notifyLine4 = manifestAddress.addressLine4
          cargoDoc.notifyLine5 = manifestAddress.addressLine5
          cargoDoc.notifyLine6 = manifestAddress.addressLine6
          cargoDoc.notifyLine7 = manifestAddress.addressLine7
        } else {
          cargoDoc.notifyLine1 = ''
          cargoDoc.notifyLine2 = ''
          cargoDoc.notifyLine3 = ''
          cargoDoc.notifyLine4 = ''
          cargoDoc.notifyLine5 = ''
          cargoDoc.notifyLine6 = ''
          cargoDoc.notifyLine7 = ''
        }
      } else {
        job.notifyId = cargoDoc.notifyId
        if (manifestAddress) {
          job.notifyLine1 = manifestAddress.addressLine1
          job.notifyLine2 = manifestAddress.addressLine2
          job.notifyLine3 = manifestAddress.addressLine3
          job.notifyLine4 = manifestAddress.addressLine4
          job.notifyLine5 = manifestAddress.addressLine5
          job.notifyLine6 = manifestAddress.addressLine6
          job.notifyLine7 = manifestAddress.addressLine7
        } else {
          job.notifyLine1 = ''
          job.notifyLine2 = ''
          job.notifyLine3 = ''
          job.notifyLine4 = ''
          job.notifyLine5 = ''
          job.notifyLine6 = ''
          job.notifyLine7 = ''
        }
      }
    }
  }

  /**
   * 复制业务时，校验新业务每个岗位角色在当前分公司是否有对对应的岗位权限
   */
  static checkUserRolePrivilege(list, userId) {
    let result = true
    if (list && list.length > 0) {
      for (const item of list) {
        if (item.userId === userId) {
          result = false
          break
        }
      }
    }
    return result
  }

  // /**
  //  * @private
  //  */
  // static function getRegionName(job: SeaExportJob): String {
  //   var port: Seaport = Seaport.getSeaport(job.dischargingPortCode)
  //   if (port) {
  //     var region: Region = Region.getRegion(port.region)
  //     return region == null ? "" : region.name
  //   }
  //   return ""
  // }

  /**
   * 复制业务时，校验新业务每个岗位角色在当前分公司是否有对对应的岗位权限
   */
  static async getLclSlavesAndCharges(job) {
    const result = this.getJobByType(job)
    if (!result) return job
    if (result.charges) result.charges = ''
    await result.getCharges() // 加载当前业务的费用
    if (result.masterFlag) {
      if (result.lclSlaves) result.lclSlaves = ''
      await result.getLclSlaves() // 加载小票
      if (result.lclSlaves && result.lclSlaves.length > 0) {
        const chargeMap = await result.getAllSlaveChargeList() // 加载所有小票费用
        if (chargeMap) {
          for (const slave of result.lclSlaves) {
            if (!chargeMap[slave.uuid]) continue
            const charges = chargeMap[slave.uuid]
            slave.charges = []
            if (charges && charges.length > 0) slave.charges = charges
          }
        }
        // for (const oldSlave of result.lclSlaves) {
        //   const slave = this.getJobByType(oldSlave)
        //   if (slave.charges) slave.charges = ''
        //   await slave.getCharges() // 加载小票费用
        // }
      }
    }
    return result
  }

  // 获取小票费用和提单
  static async getSlaveChargeCargoDoc(job) {
    const result = this.getJobByType(job)
    if (!result) return job
    if (result.charges) result.charges = ''
    await result.getCharges() // 加载当前业务的费用
    if (result.masterFlag) {
      if (result.lclSlaves) result.lclSlaves = ''
      await result.getLclSlaves() // 加载小票
      if (result.lclSlaves && result.lclSlaves.length > 0) {
        const chargeMap = await result.getAllSlaveChargeList() // 加载所有小票费用
        if (chargeMap) {
          for (const slave of result.lclSlaves) {
            if (!chargeMap[slave.uuid]) continue
            const charges = chargeMap[slave.uuid]
            slave.charges = []
            if (charges && charges.length > 0) slave.charges = charges
          }
        }
        const cargoDocMap = await result.getAllSlaveCargoDocList() // 加载所有小票提单
        if (cargoDocMap) {
          for (const slave of result.lclSlaves) {
            if (!cargoDocMap[slave.uuid]) continue
            const cargoDoc = cargoDocMap[slave.uuid]
            slave.cargoDoc = []
            if (cargoDoc && cargoDoc.length > 0) slave.cargoDoc = cargoDoc
          }
        }
      }
    }
    return result
  }

  static getJobByType(job) {
    let result = null
    switch (job.lob) {
      case 'SE':
        result = new SeaExportJob(job)
        break
      case 'SI':
        result = new SeaImportJob(job)
        break
      case 'AE':
        result = new AirExportJob(job)
        break
      case 'AI':
        result = new AirImportJob(job)
        break
      case 'RE':
      case 'RI':
        result = new RailwayExportJob(job)
        break
      case 'IE':
        result = new IntegratedJob(job)
        break
    }
    if (!result) return job
    return result
  }

  static batchCalcCubageQuantity(sizeStr = '') {
    if (!sizeStr) return null
    let cubage = 0
    let quantity = 0
    const sizes = sizeStr.split('\n')
    for (const size of sizes) {
      const value = this.calcCubageQuantity(size)
      if (value) {
        cubage += (value[0] || 0)
        quantity += (value[1] || 0)
      }
    }
    if (cubage) {
      cubage = NumberUtils.ToFixed2(cubage, 3)
    }
    if (quantity) {
      quantity = NumberUtils.ToFixed2(quantity, 0)
    }
    let cs = []
    if (cubage > 0 || quantity > 0) { cs = [cubage, quantity] }
    return cs
  }

  /**
   * size format:长*宽*高*件数</br>
   * size:20*30*40*15, return:[0.36, 15];
   */
  static calcCubageQuantity(size) {
    if (!size) return null
    const reg = /\s/g
    size = size.replace(reg, '')
    let values = []
    if (this.validateSize(size)) {
      let volume = 1
      const r = size.split('*')
      for (const n of r) {
        volume *= n
      }
      volume = volume / 1000 / 1000
      const quantity = (isNaN(r[3]) ? 0 : Number(r[3]))
      values = [volume, quantity]
    }
    return values
  }

  static validateSize(size) {
    let pass = false
    const r = size.split('*')
    if (r.length === 4) {
      pass = true
      for (const s of r) {
        const float = parseFloat(s)
        if (isNaN(float) || float === 0) {
          pass = false
          break
        }
      }
    }
    return pass
  }

  static async checkJobMAWBOtherCharge(job) {
    if (job && job.carrierId > 0) {
      await queryMAWBOtherCharge({ 'carrierId': job.carrierId }).then(res => {
        if (res.data > 0) {
          MessageBox.confirm('已更新小票票数，是否刷新主票MAWB相关信息？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            closeOnClickModal: false,
            type: 'info'
          }).then(async() => {
            await updateMasterMAWBOtherCharge(job).then(async res => {
              // 原逻辑是需要执行下面的代码，checkJobMAWBOtherCharge被调用的地方已经重新加载过，不需要下面的逻辑
              // if (res.data) {
              //   await new AirExportJob(job).loadJobRelated({
              //     job: true,
              //     airCargoDoc: true
              //   })
              // }
            })
          }).catch(() => {
          })
        }
      })
    }
  }

  static copyFailTip(copyNum, newJobList, view) {
    // 若 复制未全部成功 给出提示
    const count = newJobList ? newJobList.length : 0
    if (copyNum > count) {
      view.$confirm(view.$t('CargoMsg.Cargo_CopyResult', [count + 1, copyNum - count]), view.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: view.$t('CargoMsg.Cargo_Got_It'),
        showCancelButton: false,
        type: 'warning'
      })
    }
  }

  static getCreditCheckJob(job) {
    return {
      lob: job.lob,
      customerId: job.customerId,
      opOffice: job.opOffice,
      uuid: job.uuid,
      cargoSource: job.cargoSource,
      designationAgent: job.designationAgent,
      // PILL-66 区分不同维度合同，分别进行独立信控管理（规则条件）
      customJobType: job.customJobType,
      copyNum: job.copyNum
    }
  }
  static handlingSpecialCharactersForCargoDoc(cargoDoc) {
    if (!cargoDoc) return
    cargoDoc.shipperCode = JobUtils.handlingSpecialCharacters(cargoDoc.shipperCode)
    cargoDoc.shipperLine1 = JobUtils.handlingSpecialCharacters(cargoDoc.shipperLine1)
    cargoDoc.shipperLine2 = JobUtils.handlingSpecialCharacters(cargoDoc.shipperLine2)
    cargoDoc.shipperLine3 = JobUtils.handlingSpecialCharacters(cargoDoc.shipperLine3)
    cargoDoc.shipperLine4 = JobUtils.handlingSpecialCharacters(cargoDoc.shipperLine4)
    cargoDoc.shipperLine5 = JobUtils.handlingSpecialCharacters(cargoDoc.shipperLine5)
    cargoDoc.shipperLine6 = JobUtils.handlingSpecialCharacters(cargoDoc.shipperLine6)
    cargoDoc.shipperLine7 = JobUtils.handlingSpecialCharacters(cargoDoc.shipperLine7)

    cargoDoc.consigneeCode = JobUtils.handlingSpecialCharacters(cargoDoc.consigneeCode)
    cargoDoc.consigneeLine1 = JobUtils.handlingSpecialCharacters(cargoDoc.consigneeLine1)
    cargoDoc.consigneeLine2 = JobUtils.handlingSpecialCharacters(cargoDoc.consigneeLine2)
    cargoDoc.consigneeLine3 = JobUtils.handlingSpecialCharacters(cargoDoc.consigneeLine3)
    cargoDoc.consigneeLine4 = JobUtils.handlingSpecialCharacters(cargoDoc.consigneeLine4)
    cargoDoc.consigneeLine5 = JobUtils.handlingSpecialCharacters(cargoDoc.consigneeLine5)
    cargoDoc.consigneeLine6 = JobUtils.handlingSpecialCharacters(cargoDoc.consigneeLine6)
    cargoDoc.consigneeLine7 = JobUtils.handlingSpecialCharacters(cargoDoc.consigneeLine7)

    cargoDoc.notifyCode = JobUtils.handlingSpecialCharacters(cargoDoc.notifyCode)
    cargoDoc.notifyLine1 = JobUtils.handlingSpecialCharacters(cargoDoc.notifyLine1)
    cargoDoc.notifyLine2 = JobUtils.handlingSpecialCharacters(cargoDoc.notifyLine2)
    cargoDoc.notifyLine3 = JobUtils.handlingSpecialCharacters(cargoDoc.notifyLine3)
    cargoDoc.notifyLine4 = JobUtils.handlingSpecialCharacters(cargoDoc.notifyLine4)
    cargoDoc.notifyLine5 = JobUtils.handlingSpecialCharacters(cargoDoc.notifyLine5)
    cargoDoc.notifyLine6 = JobUtils.handlingSpecialCharacters(cargoDoc.notifyLine6)
    cargoDoc.notifyLine7 = JobUtils.handlingSpecialCharacters(cargoDoc.notifyLine7)

    cargoDoc.agentCode = JobUtils.handlingSpecialCharacters(cargoDoc.agentCode)
    cargoDoc.agentPartyLine1 = JobUtils.handlingSpecialCharacters(cargoDoc.agentPartyLine1)
    cargoDoc.agentPartyLine2 = JobUtils.handlingSpecialCharacters(cargoDoc.agentPartyLine2)
    cargoDoc.agentPartyLine3 = JobUtils.handlingSpecialCharacters(cargoDoc.agentPartyLine3)
    cargoDoc.agentPartyLine4 = JobUtils.handlingSpecialCharacters(cargoDoc.agentPartyLine4)
    cargoDoc.agentPartyLine5 = JobUtils.handlingSpecialCharacters(cargoDoc.agentPartyLine5)
    cargoDoc.agentPartyLine6 = JobUtils.handlingSpecialCharacters(cargoDoc.agentPartyLine6)
    cargoDoc.agentPartyLine7 = JobUtils.handlingSpecialCharacters(cargoDoc.agentPartyLine7)
    cargoDoc.dispatchingPlace = JobUtils.handlingSpecialCharacters(cargoDoc.dispatchingPlace)
    cargoDoc.loadingPort = JobUtils.handlingSpecialCharacters(cargoDoc.loadingPort)
    cargoDoc.dischargingPort = JobUtils.handlingSpecialCharacters(cargoDoc.dischargingPort)
    cargoDoc.destinationPort = JobUtils.handlingSpecialCharacters(cargoDoc.destinationPort)
    cargoDoc.destinationPlace = JobUtils.handlingSpecialCharacters(cargoDoc.destinationPlace)
    JobUtils.checkSpecialCharacters(cargoDoc, 'hsCode')
    JobUtils.checkSpecialCharacters(cargoDoc, 'remarks')
    JobUtils.checkSpecialCharacters(cargoDoc, 'mark')
    JobUtils.checkSpecialCharacters(cargoDoc, 'cargoEnglishName')
  }
  static checkSpecialCharacters(entity, field) {
    if (entity && Object.prototype.hasOwnProperty.call(entity, field)) {
      entity[field] = JobUtils.handlingSpecialCharacters(entity[field])
    }
  }
  // 处理特殊字符
  static handlingSpecialCharacters(str) {
    if (!str) return str
    let tmp = ''
    for (let i = 0; i < str.length; i++) {
      if (str.charCodeAt(i) === 12288) {
        tmp += String.fromCharCode(str.charCodeAt(i) - 12256)
        continue
      }
      if (str.charCodeAt(i) > 65280 && str.charCodeAt(i) < 65375) {
        tmp += String.fromCharCode(str.charCodeAt(i) - 65248)
      } else {
        tmp += String.fromCharCode(str.charCodeAt(i))
      }
    }
    // 再去掉零宽字符
    return JobUtils.removeZeroWidth(tmp)
  }

  // 常见零宽字符范围
  static removeZeroWidth(str) {
    return str.replace(/[\u200B-\u200D\uFEFF\u2060-\u206F]/g, '')
  }
  /**
   * 判断业务是否关账(由于五大业务以及个别操作都要校验是否关账，所以放在Util中统一处理)
   * @param branchId
   * @param closingDate
   * @returns {Promise<boolean>}
   */
  static async checkJobOfClosingAccount(branchId = 0, closingDate = null) {
    if (!branchId || !closingDate) {
      return true
    }
    const result = await checkJobOfClosingAccount({ branchId: branchId, closingDate: closingDate }).then(res => res.data)
    if (result) {
      await MessageBox.alert(lang.t('Message.JobOfClosingAccountTip'))
      return false
    } else {
      return true
    }
  }

  /**
   * 校验是否填写自定义业务类型
   * @param branchId
   * @param closingDate
   * @returns {Promise<boolean>}
   */
  static async checkCustomJobType(job) {
    if (!job.lob || job.uuid || !cache.office.officeId) {
      return true
    }
    const res = await getOfficeConfigByName({
      officeId: cache.office.officeId,
      configName: (job.lob === 'RI' ? 'RE' : job.lob) + 'JobNoPattern'
    })
    if (res && res.data && res.data.value) {
      const pattern = res.data.value
      let hasConfigCustomJobType = false
      let index = -1
      for (let i = 0; i < pattern.length; ++i) {
        if (pattern[i] === '$' && pattern[i + 1] === '{') {
          index = i
          continue
        }
        if (pattern[i] === '}' && index > -1) {
          const name = pattern.substring(index + 2, i)
          if (name.indexOf('customJobType') === 0) {
            hasConfigCustomJobType = true
            break
          }
          index = -1
        }
      }
      if (hasConfigCustomJobType && StrUtils.isEmpty(job.customJobType)) {
        await MessageBox.alert(lang.t('Message.CheckCustomJobTypeTips'))
        return false
      } else {
        return true
      }
    }
  }

  /**
   * 校验业务的某些字段字符串是否含有非法字符
   */
  static async validateIllegalCharacter(job) {
    let shipperTip = false
    let consigneeTip = false
    let notifyTip = false
    let secondNotifyTip = false
    let shipperMblTip = false
    let consigneeMblTip = false
    let notifyMblTip = false
    let secondNotifyMblTip = false
    const isValidateLine7 = job.lob === 'SE' || job.lob === 'AI' // 空运进口和海出需要验证第七行数据
    // 发货人
    if (StrUtils.isChinese(job.shipperLine1) || StrUtils.isContainSpecialCharacter(job.shipperLine1)) {
      shipperTip = true
    }
    if (StrUtils.isChinese(job.shipperLine2) || StrUtils.isContainSpecialCharacter(job.shipperLine2)) {
      shipperTip = true
    }
    if (StrUtils.isChinese(job.shipperLine3) || StrUtils.isContainSpecialCharacter(job.shipperLine3)) {
      shipperTip = true
    }
    if (StrUtils.isChinese(job.shipperLine4) || StrUtils.isContainSpecialCharacter(job.shipperLine4)) {
      shipperTip = true
    }
    if (StrUtils.isChinese(job.shipperLine5) || StrUtils.isContainSpecialCharacter(job.shipperLine5)) {
      shipperTip = true
    }
    if (StrUtils.isChinese(job.shipperLine6) || StrUtils.isContainSpecialCharacter(job.shipperLine6)) {
      shipperTip = true
    }
    if (isValidateLine7 && (StrUtils.isChinese(job.shipperLine7) || StrUtils.isContainSpecialCharacter(job.shipperLine7))) {
      shipperTip = true
    }
    // 收货人
    if (StrUtils.isChinese(job.consigneeLine1) || StrUtils.isContainSpecialCharacter(job.consigneeLine1)) {
      consigneeTip = true
    }
    if (StrUtils.isChinese(job.consigneeLine2) || StrUtils.isContainSpecialCharacter(job.consigneeLine2)) {
      consigneeTip = true
    }
    if (StrUtils.isChinese(job.consigneeLine3) || StrUtils.isContainSpecialCharacter(job.consigneeLine3)) {
      consigneeTip = true
    }
    if (StrUtils.isChinese(job.consigneeLine4) || StrUtils.isContainSpecialCharacter(job.consigneeLine4)) {
      consigneeTip = true
    }
    if (StrUtils.isChinese(job.consigneeLine5) || StrUtils.isContainSpecialCharacter(job.consigneeLine5)) {
      consigneeTip = true
    }
    if (StrUtils.isChinese(job.consigneeLine6) || StrUtils.isContainSpecialCharacter(job.consigneeLine6)) {
      consigneeTip = true
    }
    if (isValidateLine7 && (StrUtils.isChinese(job.consigneeLine7) || StrUtils.isContainSpecialCharacter(job.consigneeLine7))) {
      consigneeTip = true
    }
    // 通知人
    if (StrUtils.isChinese(job.notifyLine1) || StrUtils.isContainSpecialCharacter(job.notifyLine1)) {
      notifyTip = true
    }
    if (StrUtils.isChinese(job.notifyLine2) || StrUtils.isContainSpecialCharacter(job.notifyLine2)) {
      notifyTip = true
    }
    if (StrUtils.isChinese(job.notifyLine3) || StrUtils.isContainSpecialCharacter(job.notifyLine3)) {
      notifyTip = true
    }
    if (StrUtils.isChinese(job.notifyLine4) || StrUtils.isContainSpecialCharacter(job.notifyLine4)) {
      notifyTip = true
    }
    if (StrUtils.isChinese(job.notifyLine5) || StrUtils.isContainSpecialCharacter(job.notifyLine5)) {
      notifyTip = true
    }
    if (StrUtils.isChinese(job.notifyLine6) || StrUtils.isContainSpecialCharacter(job.notifyLine6)) {
      notifyTip = true
    }
    if (isValidateLine7 && (StrUtils.isChinese(job.notifyLine7) || StrUtils.isContainSpecialCharacter(job.notifyLine7))) {
      notifyTip = true
    }
    // 第二通知人
    if (StrUtils.isChinese(job.alsoNotify) || StrUtils.isContainSpecialCharacter(job.alsoNotify)) {
      secondNotifyTip = true
    }
    // MBL拆并单
    let cargoDocs
    if (job.lob === 'SI') {
      cargoDocs = await new SeaImportJob(job).getSeaCargoDoc()
    } else if (job.lob === 'AE') {
      cargoDocs = await new AirExportJob(job).getAirCargoDoc()
    } else if (job.lob === 'SE') {
      cargoDocs = await new SeaExportJob(job).getSeaCargoDoc()
    }
    if (cargoDocs && cargoDocs.length > 0) {
      for (const item of cargoDocs) {
        if ((job.signMBL && (job.lob === 'SE' || job.lob === 'SI') && (item.docType === CargoDocConsts.MBL || item.docType === CargoDocConsts.MBL2)) || (job.lob === 'AE' && item.docType === CargoDocConsts.MAWB)) {
          // 发货人
          if (StrUtils.isChinese(item.shipperLine1) || StrUtils.isContainSpecialCharacter(item.shipperLine1)) {
            shipperMblTip = true
          }
          if (StrUtils.isChinese(item.shipperLine2) || StrUtils.isContainSpecialCharacter(item.shipperLine2)) {
            shipperMblTip = true
          }
          if (StrUtils.isChinese(item.shipperLine3) || StrUtils.isContainSpecialCharacter(item.shipperLine3)) {
            shipperMblTip = true
          }
          if (StrUtils.isChinese(item.shipperLine4) || StrUtils.isContainSpecialCharacter(item.shipperLine4)) {
            shipperMblTip = true
          }
          if (StrUtils.isChinese(item.shipperLine5) || StrUtils.isContainSpecialCharacter(item.shipperLine5)) {
            shipperMblTip = true
          }
          if (StrUtils.isChinese(item.shipperLine6) || StrUtils.isContainSpecialCharacter(item.shipperLine6)) {
            shipperMblTip = true
          }
          if (StrUtils.isChinese(item.shipperLine7) || StrUtils.isContainSpecialCharacter(item.shipperLine7)) {
            shipperMblTip = true
          }
          // 收货人
          if (StrUtils.isChinese(item.consigneeLine1) || StrUtils.isContainSpecialCharacter(item.consigneeLine1)) {
            consigneeMblTip = true
          }
          if (StrUtils.isChinese(item.consigneeLine2) || StrUtils.isContainSpecialCharacter(item.consigneeLine2)) {
            consigneeMblTip = true
          }
          if (StrUtils.isChinese(item.consigneeLine3) || StrUtils.isContainSpecialCharacter(item.consigneeLine3)) {
            consigneeMblTip = true
          }
          if (StrUtils.isChinese(item.consigneeLine4) || StrUtils.isContainSpecialCharacter(item.consigneeLine4)) {
            consigneeMblTip = true
          }
          if (StrUtils.isChinese(item.consigneeLine5) || StrUtils.isContainSpecialCharacter(item.consigneeLine5)) {
            consigneeMblTip = true
          }
          if (StrUtils.isChinese(item.consigneeLine6) || StrUtils.isContainSpecialCharacter(item.consigneeLine6)) {
            consigneeMblTip = true
          }
          if (StrUtils.isChinese(item.consigneeLine7) || StrUtils.isContainSpecialCharacter(item.consigneeLine7)) {
            consigneeMblTip = true
          }
          if (item.docType !== CargoDocConsts.MAWB) { // 空运提单不校验通知人和第二通知人
            if (StrUtils.isChinese(item.notifyLine1) || StrUtils.isContainSpecialCharacter(item.notifyLine1)) {
              notifyMblTip = true
            }
            if (StrUtils.isChinese(item.notifyLine2) || StrUtils.isContainSpecialCharacter(item.notifyLine2)) {
              notifyMblTip = true
            }
            if (StrUtils.isChinese(item.notifyLine3) || StrUtils.isContainSpecialCharacter(item.notifyLine3)) {
              notifyMblTip = true
            }
            if (StrUtils.isChinese(item.notifyLine4) || StrUtils.isContainSpecialCharacter(item.notifyLine4)) {
              notifyMblTip = true
            }
            if (StrUtils.isChinese(item.notifyLine5) || StrUtils.isContainSpecialCharacter(item.notifyLine5)) {
              notifyMblTip = true
            }
            if (StrUtils.isChinese(item.notifyLine6) || StrUtils.isContainSpecialCharacter(item.notifyLine6)) {
              notifyMblTip = true
            }
            if (StrUtils.isChinese(item.notifyLine7) || StrUtils.isContainSpecialCharacter(item.notifyLine7)) {
              notifyMblTip = true
            }
            if (job.lob === 'SI' || job.lob === 'SE') {
              if (StrUtils.isChinese(item.alsoNotify) || StrUtils.isContainSpecialCharacter(item.alsoNotify)) {
                secondNotifyMblTip = true
              }
            }
          }
        }
      }
    }
    let message = ''
    const shipper = lang.t('Message.Shipper')
    const consignee = lang.t('Message.Consignee')
    const notify = lang.t('Message.Notify')
    const secondNotify = lang.t('Message.SecondNotify')
    const mblMsg = job.lob === 'AE' ? 'MAWB' : 'MBL'
    if (shipperTip) {
      message = shipper
    }
    if (consigneeTip) {
      if (message) {
        message = message + '、' + consignee
      } else {
        message = consignee
      }
    }
    if (notifyTip) {
      if (message) {
        message = message + '、' + notify
      } else {
        message = notify
      }
    }
    if (secondNotifyTip) {
      if (message) {
        message = message + '、' + secondNotify
      } else {
        message = secondNotify
      }
    }

    if (shipperMblTip) {
      if (message) {
        message = message + '、' + mblMsg + shipper
      } else {
        message = mblMsg + shipper
      }
    }
    if (consigneeMblTip) {
      if (message) {
        message = message + '、' + mblMsg + consignee
      } else {
        message = mblMsg + consignee
      }
    }
    if (notifyMblTip) {
      if (message) {
        message = message + '、' + mblMsg + notify
      } else {
        message = mblMsg + notify
      }
    }
    if (secondNotifyMblTip) {
      if (message) {
        message = message + '、' + mblMsg + secondNotify
      } else {
        message = mblMsg + secondNotify
      }
    }
    if (message) {
      MessageBox.alert(lang.t('Message.SpecialCharacter', [message]))
      return false
    } else {
      return true
    }
  }

  /**
   * 获取追加查询条件
   * @param advConditions
   * @returns {boolean}
   */
  static appendQueryCondition(advConditions = []) {
    let appendQuery = false
    advConditions.forEach((element, index) => {
      if (Object.prototype.hasOwnProperty.call(element, 'appendQuery')) {
        appendQuery = element.appendQuery
        advConditions.splice(index, 1)
      }
    })
    return appendQuery
  }

  /**
   * 追加查询去重复
   * @param source
   * @param appendQuery
   * @returns {*[]}
   */
  static appendQueryRepeat(source = [], results = [], appendQuery = false) {
    if (appendQuery) {
      const idSet = source.reduce((acc, v) => {
        acc[v.uuid] = true
        return acc
      }, {})
      const list = results.filter(v => !idSet[v.uuid])
      return [...source, ...list]
    }
    return source
  }

  static getStateName(code, list) {
    for (const item of list) {
      if (item.code === code) {
        return $store.getters.language === 'zh' ? item.chineseName : item.englishName
      }
    }
  }
  /**
   * 当MBL和HBL都存在时，校验是否重复
   * @param job
   * @returns {Promise<Boolean>}
   */
  static async checkHBLANDMBL(job) {
    let hbl = ''
    let configValue = 0
    await cache.load(cacheName.CONFIG)
    if (job.lob === 'SE') { // 海运出口
      configValue = Number(cache.config.get('isAllowSEHBLNoRepeat'))
      const cargoDoc = await new SeaExportJob(job).getMainHbl()
      if (cargoDoc) {
        hbl = cargoDoc.hblNbr2
      }
      if (configValue === 2 && job.signHBL && !job.mblOnly && !job.masterFlag && job.mbl && job.mbl.trim() && hbl && hbl.trim()) {
        const count = await isExistHBLANDMBL({ branchId: $store.getters.currentOfficeId, lob: job.lob, hbl: hbl, jobUuid: job.uuid, mbl: job.mbl }).then(res => res.data)
        if (count && count > 0) {
          Message.warning(lang.t('Message.isExistHBLANDMBLTips'))
          return false
        }
      }
    } else if (job.lob === 'SI') { // 海运进口
      configValue = Number(cache.config.get('isAllowSIHBLNoRepeat'))
      hbl = job.hbl
      if (hbl) {
        if (configValue === 1) {
          const count = await isExistHBLANDMBL({ branchId: $store.getters.currentOfficeId, lob: job.lob, hbl: hbl, jobUuid: job.uuid, mbl: '' }).then(res => res.data)
          if (count && count > 0) {
            Message.warning(lang.t('Message.HBLRepeatedContinue'))
            return false
          }
        } else if (configValue === 2) {
          if (job.mbl && job.mbl.trim() && hbl && hbl.trim()) {
            const count = await isExistHBLANDMBL({ branchId: $store.getters.currentOfficeId, lob: job.lob, hbl: hbl, jobUuid: job.uuid, mbl: job.mbl }).then(res => res.data)
            if (count && count > 0) {
              Message.warning(lang.t('Message.isExistHBLANDMBLTips'))
              return false
            }
          }
        }
      }
    } else if (job.lob === 'AE') { // 空运出口
      configValue = Number(cache.config.get('isAllowHAWBRepeat'))
      const cargoDocs = await new AirExportJob(job).getAirCargoDoc()
      if (cargoDocs && cargoDocs.length > 0) {
        for (const item of cargoDocs) {
          if (item.docType === CargoDocConsts.HAWB) {
            hbl = item.hblNbr2
            break
          }
        }
      }
      if (hbl && hbl.trim()) {
        if (configValue === 1) {
          const count = await isExistHBLANDMBL({ branchId: $store.getters.currentOfficeId, lob: job.lob, hbl: hbl, jobUuid: job.uuid, mbl: '' }).then(res => res.data)
          if (count && count > 0) {
            Message.warning(lang.t('Message.HAWBRepeatedContinue'))
            return false
          }
        } else if (configValue === 2) {
          if (job.mbl && job.mbl.trim()) {
            const count = await isExistHBLANDMBL({ branchId: $store.getters.currentOfficeId, lob: job.lob, hbl: hbl, jobUuid: job.uuid, mbl: job.mbl }).then(res => res.data)
            if (count && count > 0) {
              Message.warning(lang.t('Message.isExistHBLANDMBLTips'))
              return false
            }
          }
        }
      }
    } else if (job.lob === 'AI') { // 空运进口
      configValue = Number(cache.config.get('isAllowAIHBLNoRepeat'))
      hbl = job.hbl
      if (configValue === 2 && job.mbl && job.mbl.trim() && hbl && hbl.trim()) {
        const count = await isExistHBLANDMBL({ branchId: $store.getters.currentOfficeId, lob: job.lob, hbl: hbl, jobUuid: job.uuid, mbl: job.mbl }).then(res => res.data)
        if (count && count > 0) {
          Message.warning(lang.t('Message.isExistHBLANDMBLTips'))
          return false
        }
      }
    }
    return true
  }

  /**
   * 校验减少的箱数是否有效
   * @param preJob
   * @param job
   * @returns
   */
  static checkReduceContainerNum(preJob, job) {
    if (!preJob.uuid || !preJob.seaEQ || preJob.seaEQ.length === 0 || !job.seaEQ || job.seaEQ.length === 0) {
      return true
    }
    /* seaEQ映射 */
    const seaEQMap = new Map()
    for (const item of job.seaEQ) {
      seaEQMap.set(item.eqSize + item.eqType, item.eqQuantity)
    }
    // 当前箱子的Map
    const containerMap = new Map()
    let containers = null
    if (job.masterFlag) { // 主票取Container
      if (job.containers && job.containers.length > 0) {
        containers = job.containers
      }
    } else { // 小票取ContainerUsages
      if (job.containerUsages && job.containerUsages.length > 0) {
        containers = job.containerUsages
      }
    }
    if (containers) {
      for (const item of containers) {
        const eqSizeType = item.eqSize + item.eqType
        let num = containerMap.get(eqSizeType)
        if (!num) {
          num = 1
        } else {
          num += 1
        }
        containerMap.set(eqSizeType, num)
      }
    }
    // 比较同箱型箱种的数量，如果一致，就不执行后续的逻辑判断了。
    let allSame = true
    if (seaEQMap.size > 0) {
      if (containerMap.size > 0) {
        for (const [key, value] of seaEQMap) {
          const sumQuantity = containerMap.get(key) || 0
          if (sumQuantity !== value) {
            allSame = false
            break
          }
        }
        if (allSame) {
          for (const [key, value] of containerMap) {
            const sumQuantity = seaEQMap.get(key) || 0
            if (sumQuantity !== value) {
              allSame = false
              break
            }
          }
        }
      } else {
        allSame = false
      }
    }
    if (allSame) {
      return true
    }
    /* 减少的箱数 */
    const reduceContainerNums = []
    for (const item of preJob.seaEQ) {
      const name = item.eqSize + item.eqType
      const num = item.eqQuantity - (seaEQMap.get(name) || 0)
      if (num > 0) {
        reduceContainerNums.push({ name, eqSize: item.eqSize, eqType: item.eqType, num })
      }
    }
    if (reduceContainerNums.length === 0) {
      return true
    }
    /* 未关联箱封信息的箱数 */
    const noContainerSealNumMap = new Map()
    if (preJob.masterFlag) {
      if (!preJob.containers || preJob.containers.length === 0) {
        return true
      }
      for (const item of preJob.containers) {
        if (item.containerNo || item.sealNo) {
          continue
        }
        const eqSizeType = item.eqSize + item.eqType
        let num = noContainerSealNumMap.get(eqSizeType)
        if (!num) {
          num = 1
        } else {
          num += 1
        }
        noContainerSealNumMap.set(eqSizeType, num)
      }
    } else {
      if (!preJob.containerUsages || preJob.containerUsages.length === 0) {
        return true
      }
      for (const item of preJob.containerUsages) {
        if (item.containerNo || item.sealNo) {
          continue
        }
        const eqSizeObj = EQSize.getEQSizeByName(item.eqSize)
        const eqSizeType = (eqSizeObj ? eqSizeObj.code : item.eqSize) + item.eqType
        let num = noContainerSealNumMap.get(eqSizeType)
        if (!num) {
          num = 1
        } else {
          num += 1
        }
        noContainerSealNumMap.set(eqSizeType, num)
      }
    }
    // 【未关联箱封信息的箱数】必须大于等于【减少的箱数】
    for (const item of reduceContainerNums) {
      const noContainerSealNum = noContainerSealNumMap.get(item.name) || 0
      if (noContainerSealNum < item.num) {
        Message.warning(lang.t('queryJob.QuantityIsInconsistentOfEqSizeType', { eqSize: item.eqSize, eqType: item.eqType }))
        return false
      }
    }
    return true
  }

  /**
   * 校验箱型、箱量
   * @param job
   */
  static checkEqSizeEqType(job) {
    const seaEQ = job.seaEQ
    if (!seaEQ || seaEQ.length === 0) {
      return
    }
    const containerEqSizeTypeMap = new Map()
    if (job.masterFlag) {
      const containers = job.containers
      if (!containers || containers.length === 0) {
        return
      }
      for (const item of containers) {
        const eqSizeType = item.eqSize + item.eqType
        let num = containerEqSizeTypeMap.get(eqSizeType)
        if (!num) {
          num = 1
        } else {
          num += 1
        }
        containerEqSizeTypeMap.set(eqSizeType, num)
      }
    } else {
      const containerUsages = job.containerUsages
      if (!containerUsages || containerUsages.length === 0) {
        return
      }
      for (const item of containerUsages) {
        const eqSizeObj = EQSize.getEQSizeByName(item.eqSize)
        const eqSizeType = (eqSizeObj ? eqSizeObj.code : item.eqSize) + item.eqType
        let num = containerEqSizeTypeMap.get(eqSizeType)
        if (!num) {
          num = 1
        } else {
          num += 1
        }
        containerEqSizeTypeMap.set(eqSizeType, num)
      }
    }
    for (const item of seaEQ) {
      const num = containerEqSizeTypeMap.get(item.eqSize + item.eqType)
      if (num !== item.eqQuantity) {
        Message.warning(lang.t('queryJob.QuantityIsInconsistentOfEqSizeType', { eqSize: item.eqSize, eqType: item.eqType }))
        return
      }
    }
  }

  static async onWoodOrNotWoodChagne(job) {
    if (job.wood === AirExportConstants.NONE.code) {
      if (job.hazardousGoodsOption === AirExportConstants.NONE.code) {
        job.handlingInformationCode = ''
      } else if (job.hazardousGoodsOption === AirExportConstants.CARGO_AIRCRAFT_ONLY.code) {
        job.handlingInformationCode = AirExportConstants.HANDLING_INFORMATION_PAD.code
      } else if (job.hazardousGoodsOption === AirExportConstants.PASSENGER_AND_CARGO_AIRCRAFT.code) {
        job.handlingInformationCode = AirExportConstants.HANDLING_INFORMATION_PAS.code
      } else {
        job.handlingInformationCode = ''
      }
    } else if (job.wood === AirExportConstants.IS_WOOD.code) {
      if (job.hazardousGoodsOption === AirExportConstants.NONE.code) {
        job.handlingInformationCode = AirExportConstants.HANDLING_INFORMATION_WPM.code
      } else if (job.hazardousGoodsOption === AirExportConstants.CARGO_AIRCRAFT_ONLY.code) {
        job.handlingInformationCode = AirExportConstants.HANDLING_INFORMATION_WPM.code + ',' + AirExportConstants.HANDLING_INFORMATION_PAD.code
      } else if (job.hazardousGoodsOption === AirExportConstants.PASSENGER_AND_CARGO_AIRCRAFT.code) {
        job.handlingInformationCode = AirExportConstants.HANDLING_INFORMATION_WPM.code + ',' + AirExportConstants.HANDLING_INFORMATION_PAS.code
      } else {
        job.handlingInformationCode = AirExportConstants.HANDLING_INFORMATION_WPM.code
      }
    } else if (job.wood === AirExportConstants.NON_WOOD.code) {
      if (job.hazardousGoodsOption === AirExportConstants.NONE.code) {
        job.handlingInformationCode = AirExportConstants.HANDLING_INFORMATION_ISP.code
      } else if (job.hazardousGoodsOption === AirExportConstants.CARGO_AIRCRAFT_ONLY.code) {
        job.handlingInformationCode = AirExportConstants.HANDLING_INFORMATION_ISP.code + ',' + AirExportConstants.HANDLING_INFORMATION_PAD.code
      } else if (job.hazardousGoodsOption === AirExportConstants.PASSENGER_AND_CARGO_AIRCRAFT.code) {
        job.handlingInformationCode = AirExportConstants.HANDLING_INFORMATION_ISP.code + ',' + AirExportConstants.HANDLING_INFORMATION_PAS.code
      } else {
        job.handlingInformationCode = AirExportConstants.HANDLING_INFORMATION_ISP.code
      }
    }
    await this.getHandlingInformationName(job)
  }
  static async onHazardousGoodsOptionChagne(job) {
    if (job.hazardousGoodsOption === AirExportConstants.NONE.code) {
      if (job.wood === AirExportConstants.NONE.code) {
        job.handlingInformationCode = ''
      } else if (job.wood === AirExportConstants.IS_WOOD.code) {
        job.handlingInformationCode = AirExportConstants.HANDLING_INFORMATION_WPM.code
      } else if (job.wood === AirExportConstants.NON_WOOD.code) {
        job.handlingInformationCode = AirExportConstants.HANDLING_INFORMATION_ISP.code
      } else {
        job.handlingInformationCode = ''
      }
    } else if (job.hazardousGoodsOption === AirExportConstants.CARGO_AIRCRAFT_ONLY.code) {
      if (job.wood === AirExportConstants.NONE.code) {
        job.handlingInformationCode = AirExportConstants.HANDLING_INFORMATION_PAD.code
      } else if (job.wood === AirExportConstants.IS_WOOD.code) {
        job.handlingInformationCode = AirExportConstants.HANDLING_INFORMATION_WPM.code + ',' + AirExportConstants.HANDLING_INFORMATION_PAD.code
      } else if (job.wood === AirExportConstants.NON_WOOD.code) {
        job.handlingInformationCode = AirExportConstants.HANDLING_INFORMATION_ISP.code + ',' + AirExportConstants.HANDLING_INFORMATION_PAD.code
      } else {
        job.handlingInformationCode = AirExportConstants.HANDLING_INFORMATION_PAD.code
      }
    } else if (job.hazardousGoodsOption === AirExportConstants.PASSENGER_AND_CARGO_AIRCRAFT.code) {
      if (job.wood === AirExportConstants.NONE.code) {
        job.handlingInformationCode = AirExportConstants.HANDLING_INFORMATION_PAS.code
      } else if (job.wood === AirExportConstants.IS_WOOD.code) {
        job.handlingInformationCode = AirExportConstants.HANDLING_INFORMATION_WPM.code + ',' + AirExportConstants.HANDLING_INFORMATION_PAS.code
      } else if (job.wood === AirExportConstants.NON_WOOD.code) {
        job.handlingInformationCode = AirExportConstants.HANDLING_INFORMATION_ISP.code + ',' + AirExportConstants.HANDLING_INFORMATION_PAS.code
      } else {
        job.handlingInformationCode = AirExportConstants.HANDLING_INFORMATION_PAS.code
      }
    }
    await this.getHandlingInformationName(job)
  }
  static async getHandlingInformationName(job) {
    if (!job.handlingInformationCode) {
      job.handlingInformation = ''
      return
    }
    const finalValue = job.handlingInformationCode.toString().split(',')
    const code1 = AirExportConstants.HANDLING_INFORMATION_WPM.code
    const code2 = AirExportConstants.HANDLING_INFORMATION_ISP.code
    const code3 = AirExportConstants.HANDLING_INFORMATION_PAD.code
    const code4 = AirExportConstants.HANDLING_INFORMATION_PAS.code
    const value1 = AirExportConstants.HANDLING_INFORMATION_WPM.englishName
    const value2 = AirExportConstants.HANDLING_INFORMATION_ISP.englishName
    const value3 = AirExportConstants.HANDLING_INFORMATION_PAD.englishName
    const value4 = AirExportConstants.HANDLING_INFORMATION_PAS.englishName
    const numberToEnglish = {
      [code1]: value1,
      [code2]: value2,
      [code3]: value3,
      [code4]: value4
    }
    const result = []
    for (let i = 0; i < finalValue.length; i++) {
      const subArray = finalValue[i]
      result.push(numberToEnglish[subArray] || subArray)
    }
    if (result.length > 1) {
      job.handlingInformation = result[0] + '\n' + result[1]
    } else {
      job.handlingInformation = result[0]
    }
  }

  /**
   * 验证主票是否分摊费用、业务模块公用
   * @param jobUuid
   * @returns {Promise<boolean>}
   */
  static async checkMasterShare(jobUuid) {
    if (!jobUuid) return true
    const charges = await getChargeList(jobUuid).then(res => res.data)
    if (charges && charges.length > 0) {
      for (const charge of charges) {
        if (charge.apportioned) {
          Message.warning(lang.t('CargoMsg.Cargo_MasterTicketShareCharge'))
          return false
        }
      }
    }
    return true
  }

  /**
   * 验证操作分公司是否配置了验证规则
   * @param jobUuid
   * @returns {Promise<boolean>}
   */
  static async hasCheckRuleCondition(useCheckRule = false, checkNode = 0, branchId = 0) {
    if (!checkNode || !branchId) return true
    if (!useCheckRule) return false // 传入这个就少走了接口
    const hasCheckRule = await hasCheckRuleCondition({ checkNode: checkNode, branchId: branchId }).then(res => res.data)
    return hasCheckRule
  }

  // 验证节点在job下是否有配置验证规则
  static async hasConfigCheckRule(checkNode, jobKey, lob) {
    if (checkNode === 10) { // 单节点验证弹窗的逻辑，节点10会被转为2
      checkNode = 2
    }
    return await hasConfigCheckRule({ checkNode, jobKey, lob }).then(res => res.data)
  }
  // 验证节点在job下是否有配置验证规则
  static async queryByNode(checkNode, branchId) {
    return await queryByNode({ checkNode, branchId }).then(res => res.data)
  }

  // 验证节点在多个job下是否有配置验证规则
  static async hasConfigCheckRuleByJobs(checkNode, jobKeys, lob) {
    if (jobKeys instanceof Array && jobKeys.length > 0) {
      return await hasConfigCheckRuleByJobs({ checkNode, jobUuids: jobKeys, lob }).then(res => res.data)
    }
    return false
  }

  /**
   * 验证箱号是否正被费用使用
   * @param _job
   * @param oldValue
   * @returns {boolean}
   */
  static checkCNoHandler(_job, oldValue) {
    if (_job && _job.charges && _job.charges.length > 0) {
      for (const charge of _job.charges) {
        if (charge.relationContainerNo) {
          const cNos = charge.relationContainerNo.split(',')
          if (cNos.includes(oldValue)) {
            Message.warning(lang.t('Message.ContainerTip'))
            return true
          }
        }
      }
    }
    return false
  }

  /**
   * 新增复制业务时 验证当前公司是否为总公司
   * @returns {boolean}
   */
  static checkHQ() {
    const officeId = $store.getters.currentOfficeId
    if (officeId === 1) {
      Message.warning(lang.t('Message.CompanySelectedIsHQCannotAddNewBookings'))
      return true
    }
    return false
  }
  static dateChange(value) {
    if (!value) {
      return value
    }
    return String(new Date(value)).substr(0, 3).toUpperCase()
  }
  static setSailingDay(job) {
    if (job) {
      job.sailingDay = JobUtils.dateChange(job.etd)
      job.etaSailingDay = JobUtils.dateChange(job.eta)
      job.atdSailingDay = JobUtils.dateChange(job.atd)
      job.ataSailingDay = JobUtils.dateChange(job.ata)
    }
  }

  static async changeCarrierId(view, job, carrierId) {
    let updateVesselLine = true
    if (job.scNo && carrierId) {
      let shippingContractList = []
      await this.queryContractNumber().then(contractNumbers => {
        shippingContractList = contractNumbers
      })
      await cache.load(cacheName.CONFIG)
      const sCNumberSelectMethod = Number(cache.config.get('SCNumberSelectMethod')) !== 0
      const shippingContract = shippingContractList.find(item => item.contractNumber === job.scNo)
      if (shippingContract && sCNumberSelectMethod && shippingContract.shippingCompany && shippingContract.shippingCompany !== carrierId) {
        const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(shippingContract.shippingCompany))
        if (company) {
          const message = view.$t('SeaExport.NumberApplicableToShippingCompany', [view.$store.getters.language === 'zh' ? company.chineseName : company.englishName])
          await view.$confirm(view.$t('SeaExport.ShippingCompanyDifferent', [message]),
            view.$t('common.btn.confirm'), {
              confirmButtonText: view.$t('common.btn.ok'),
              cancelButtonText: view.$t('common.btn.cancel'),
              dangerouslyUseHTMLString: true,
              type: 'warning'
            }
          ).then(async() => {
          }).catch(() => {
            updateVesselLine = false
          })
        }
      }
    }
    if (updateVesselLine) {
      job.carrierId = carrierId
    }
  }

  static async seEtdChange(view, value, form, context, isJyd) {
    let updateEtd = true
    if (form.scNo) {
      let shippingContractList = []
      await this.queryContractNumber().then(contractNumbers => {
        shippingContractList = contractNumbers
      })
      const shippingContract = shippingContractList.find(item => item.contractNumber === form.scNo)
      if (shippingContract) {
        const validityStart = shippingContract.validityStart
        const validityEnd = shippingContract.validityEnd
        await cache.load(cacheName.CONFIG)
        const sCNumberSelectMethod = Number(cache.config.get('SCNumberSelectMethod')) !== 0
        if (validityStart && validityEnd && sCNumberSelectMethod) {
          const isValidTimeRange = this.isValidTimeRange(value, validityStart, validityEnd)
          if (!isValidTimeRange) {
            const validPeriod = DateUtils.formatStandardDate(validityStart) + ' ~ ' + DateUtils.formatStandardDate(validityEnd)
            const message = view.$t('SeaExport.ValidPeriodMessage', [validPeriod])
            await view.$confirm(view.$t('SeaExport.EtdDifferentValidityPeriod', [message]),
              view.$t('common.btn.confirm'), {
                confirmButtonText: view.$t('common.btn.ok'),
                cancelButtonText: view.$t('common.btn.cancel'),
                dangerouslyUseHTMLString: true,
                type: 'warning'
              }
            ).then(async() => {
            }).catch(() => {
              updateEtd = false
            })
          }
        }
      }
    }
    if (updateEtd) {
      await this.etdChange(value, form, context, isJyd)
    }
  }
  static isValidTimeRange(value, validityStart, validityEnd) {
    const selectedTime = new Date(value).getTime()
    const start = new Date(validityStart).getTime()
    const end = new Date(validityEnd).getTime()
    return selectedTime >= start && selectedTime <= end
  }
  static async etdChange(value, form, context, isJyd) {
    const oldValue = form.etd
    form.etd = value
    form.sailingDay = JobUtils.dateChange(form.etd)
    await this.ETDChange(oldValue, form)
    await ChargeUtils.updateETDFee(form, form.etd, context, true)
    if (form.etd) {
      await this.matchRegionWarehouseMappingConfig(form, null, false, null, context.modifiedData)
    }
    if (isJyd) {
      // 新增
      if (!form.uuid || !form.customsDate) {
        form.customsDate = form.etd
      }
    }
  }

  /**
   * ETD 选择控制
   */
  static async ETDChange(oldValue, job) {
    await cache.load(cacheName.CONFIG)
    this.syncSignDateBl = Number(cache.config.get('syncSignDateBl'))
    if (this.syncSignDateBl === 0) {
      for (const cargoDoc of job.seaCargoDoc) {
        const allow = (cargoDoc.docType === CargoDocConsts.MBL || cargoDoc.docType === CargoDocConsts.MBL2 ||
          cargoDoc.docType === CargoDocConsts.HBL || cargoDoc.docType === CargoDocConsts.HBL2 ||
          cargoDoc.docType === CargoDocConsts.HAWB2) && cargoDoc.state < 2 && (!cargoDoc.signDateBL ||
          (oldValue && dateCompare(cargoDoc.signDateBL, oldValue) === 0))
        if (allow) {
          cargoDoc.signDateBL = job.etd
        }
      }
    }
  }

  /**
   * 检验业务检查节点是否符合
   * @param saveBody
   * @param lob
   * @param node
   * @returns {Promise<{needShowDialog: boolean, rowData: []}>}
   */
  static async checkBySaveJobNode(saveBody, lob, node) {
    const result = {
      needShowDialog: false,
      rowData: []
    }
    if (!saveBody || !lob || !node) return result
    const data = {}
    data.checkNode = node
    data.lob = lob
    if (data.lob === 'SE') {
      data.seJob = saveBody.job
      data.containers = saveBody.containers
      data.cargoDocs = saveBody.seaCargoDoc
      data.seaCargoDocs = saveBody.seaCargoDoc
      data.hblJoinMergeJobList = saveBody.hblJoinMergeJobList
      // 目前目的港派车仅远程订舱保存需要
      if (CheckRuleConstants.NODE_SAVE_REMOTE_BOOKING.code === node) {
        data.dischargingTruckingInfo = saveBody.dischargingTruckingInfo
      }
    } else if (data.lob === 'SI') {
      data.cargoDocs = saveBody.seaCargoDoc
      data.siJob = saveBody.job
    } else if (data.lob === 'AE') {
      data.cargoDocs = saveBody.airCargoDoc
      data.aeJob = saveBody.job
    } else if (data.lob === 'AI') {
      data.cargoDocs = saveBody.airCargoDoc
      data.aiJob = saveBody.job
    } else if (data.lob === 'IE') {
      data.containers = saveBody.containers
      data.ieJob = saveBody.job
    } else if (data.lob === 'RE' || data.lob === 'RI') {
      data.railwayJob = saveBody.job
    }
    if (saveBody.hasOwnProperty('seaEQ') && saveBody.seaEQ) {
      data.seaEQ = saveBody.seaEQ
    }
    if (saveBody.hasOwnProperty('truckingInfo') && saveBody.truckingInfo) {
      data.truckingInfo = saveBody.truckingInfo
    }
    // CARGO-35024 验证规则：有仓储服务需录入仓库、有报关服务需录入报关行、有门点服务需录入车队无效
    if (saveBody.hasOwnProperty('warehouseInfo') && saveBody.warehouseInfo) {
      data.warehouseInfo = saveBody.warehouseInfo
    }
    if (saveBody.charges) {
      data.charges = saveBody.charges
    }
    if (saveBody.poItems) {
      data.poItems = saveBody.poItems
    }
    if (saveBody.delChargeUuids) {
      data.delChargeUuids = saveBody.delChargeUuids
    }
    let needShowDialog = false
    // CARGO-52433 中邮:财务审核调整费用报错
    if (CheckRuleConstants.NODE_NEW_FINANCE_ADJUSTMENT.code === node) {
      try {
        console.log('checkBySaveJobNode 1 =====================', data)
        cleanCircleObject(data)
        console.log('checkBySaveJobNode 2 =====================', data)
      } catch (e) {
        console.log('checkBySaveJobNode error =====================', e)
      }
    }
    await checkBySaveJobNode(data).then(res => {
      result.rowData = res.data || []
      if (result && result.rowData.length > 0) {
        for (const checkRule of result.rowData) {
          if (checkRule && checkRule.expressions) {
            for (const item of checkRule.expressions) {
              if (!item.match) {
                needShowDialog = true
                break
              }
            }
          }
          if (needShowDialog) {
            break
          }
        }
      }
    })
    result.needShowDialog = needShowDialog
    return result
  }

  /**
   * 船名修改后，若原船名不为空，且与新值不等，则提醒是否清空船期字段
   * @param job
   * @param field
   * @param newVal
   * @param view
   * @param oldVessel
   * @returns {Promise<void>}
   */
  static async vesselOrVoyageChange(job, field, newVal, view, oldVessel = '', cleanPolPortInfo = false) {
    // 若原船名不为空，且与新值不等，则提醒是否清空船期字段; oldVessel代表客户每次修改的值。
    // CARGO-32609 外红：更改船名后，没有弹窗跳出提醒
    if (isVesselOrVoyageChanged(job, field, newVal, oldVessel)) {
      // REQ-0028 决议②④：改船名/航次（含清空）触发即静默清 ATD——置于块首，
      // 与船期字段的「确认弹窗/直接清」两态无关，也不入确认文案（有船期字段
      // 与否、cleanPolPortInfo 配置与否、点 Yes/No 均不影响 ATD 清空）
      job.atd = null
      let flag = false
      const fieldMsg = []
      if (job.portDistrict) {
        fieldMsg.push(lang.t('SeaExport.HarborDistrict'))
      }
      if (job.berthPlanDate) {
        fieldMsg.push(lang.t('SeaExport.PlannedBerthingTime'))
      }
      if (job.unBerthPlanDate) {
        fieldMsg.push(lang.t('SeaExport.PlanDepartureTime'))
      }
      if (job.actualBerthPlanDate) {
        fieldMsg.push(lang.t('SeaExport.ActualBerthingTime'))
      }
      if (job.actualUnBerthPlanDate) {
        fieldMsg.push(lang.t('SeaExport.RealDepartureTime'))
      }
      if (job.terminalOpendate) {
        fieldMsg.push(lang.t('SeaExport.CYOpeningTime'))
      }
      if (job.terminalCutoff) {
        fieldMsg.push(lang.t('SeaExport.PortAreaCYCutOffTime'))
      }
      if (fieldMsg.length === 0) { // 都没有值，就不需要提醒
        return
      }
      if (cleanPolPortInfo) {
        // 清空船期字段
        job.portDistrict = ''
        job.berthPlanDate = ''
        job.unBerthPlanDate = ''
        job.actualBerthPlanDate = ''
        job.actualUnBerthPlanDate = ''
        job.terminalOpendate = ''
        job.terminalCutoff = ''
        return
      }
      await view.$confirm(lang.t('CargoMsg.Cargo_UpdateVesselVoyageMsg', [fieldMsg.join(',')]), lang.t('common.tips.prompt'), {
        confirmButtonText: lang.t('SeaExport.Yes'),
        cancelButtonText: lang.t('SeaExport.No'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        flag = true
      }).catch(() => {
      })
      if (flag) {
        // 清空船期字段
        job.portDistrict = ''
        job.berthPlanDate = ''
        job.unBerthPlanDate = ''
        job.actualBerthPlanDate = ''
        job.actualUnBerthPlanDate = ''
        job.terminalOpendate = ''
        job.terminalCutoff = ''
      }
    }
  }

  /**
   * 并单后会修改被并单的船名航次，此时提示是否清清空船期字段
   */
  static async vesselOrVoyageChange2(jobs, oldJob, view) {
    const fieldMsg = []
    let flag = false
    for (const job of jobs) {
      // 必须是委托拼箱
      if (job.vessel !== oldJob.vessel && job.containerLoadType === 'BB') {
        if (job.portDistrict && !fieldMsg.includes(lang.t('SeaExport.HarborDistrict'))) {
          fieldMsg.push(lang.t('SeaExport.HarborDistrict'))
        }
        if (job.berthPlanDate && !fieldMsg.includes(lang.t('SeaExport.PlannedBerthingTime'))) {
          fieldMsg.push(lang.t('SeaExport.PlannedBerthingTime'))
        }
        if (job.unBerthPlanDate && !fieldMsg.includes(lang.t('SeaExport.PlanDepartureTime'))) {
          fieldMsg.push(lang.t('SeaExport.PlanDepartureTime'))
        }
        if (job.actualBerthPlanDate && !fieldMsg.includes(lang.t('SeaExport.ActualBerthingTime'))) {
          fieldMsg.push(lang.t('SeaExport.ActualBerthingTime'))
        }
        if (job.actualUnBerthPlanDate && !fieldMsg.includes(lang.t('SeaExport.RealDepartureTime'))) {
          fieldMsg.push(lang.t('SeaExport.RealDepartureTime'))
        }
      }
    }
    if (fieldMsg.length === 0) { // 都没有值，就不需要提醒
      return
    }
    await view.$confirm(lang.t('CargoMsg.Cargo_UpdateVesselVoyageMsg', [fieldMsg.join(',')]), lang.t('common.tips.prompt'), {
      confirmButtonText: lang.t('SeaExport.Yes'),
      cancelButtonText: lang.t('SeaExport.No'),
      closeOnClickModal: false,
      type: 'info'
    }).then(() => {
      flag = true
    }).catch(() => {
    })
    return flag
  }

  /**
   * 货物明细汇总
   */
  static getFbaWarehouseInDetail(job, warehouseInDetails) {
    if (!warehouseInDetails || warehouseInDetails.length === 0) {
      return ''
    }
    let str = ''
    let quantity = 0
    let weight = 0
    let cubage = 0
    let brokenQuantity = 0
    for (const warehouseIn of warehouseInDetails) {
      if (warehouseIn.fba && !warehouseIn.oversea) {
        if (warehouseIn.broken) {
          brokenQuantity += warehouseIn.brokenQuantity
        }
        quantity = job.quantityActual
        weight = job.weightActual
        cubage = job.cubageActual
        break
      }
    }
    str += '件数:' + quantity.toFixed(0)
    str += '\r'
    str += '重量:' + weight.toFixed(2)
    str += '\r'
    str += '体积:' + cubage.toFixed(3)
    str += '\r'
    if (brokenQuantity > 0) {
      str += '有破损'
      str += '  破损件数:' + brokenQuantity.toFixed(0)
    } else {
      str += '无破损'
    }
    return str
  }
  // 目的地
  static initDestination(fbaQuotation) {
    const overseaWarehouses = getCacheListByKey(basicCacheKeys.basic_data_OverseaWarehouse)
    const destinationList = []
    if (fbaQuotation) {
      const partitionSettingList = fbaQuotation.partitionSettingList
      let warehouseCode = []
      for (const item of partitionSettingList) {
        const pod = item.pod
        if (pod && pod.split(',').length > 0) {
          warehouseCode = warehouseCode.concat(pod.split(','))
        }
      }
      for (const overseaWarehouse of overseaWarehouses) {
        if (warehouseCode.indexOf(overseaWarehouse.warehouseCode) > -1) {
          destinationList.push({ value: overseaWarehouse.warehouseCode, ifFba: overseaWarehouse.ifFba, label: overseaWarehouse.warehouseCode })
        }
      }
    } else {
      for (const overseaWarehouse of overseaWarehouses) {
        destinationList.push({ value: overseaWarehouse.warehouseCode, ifFba: overseaWarehouse.ifFba, label: overseaWarehouse.warehouseCode })
      }
    }
    return [{
      value: 'FBA',
      label: 'FBA',
      ifFba: true,
      children: destinationList.filter(item => item.ifFba) || []
    }, {
      value: 'NoFBA',
      label: lang.t('FbaJob.otherOverseaWarehouse'),
      ifFba: false,
      children: destinationList.filter(item => !item.ifFba) || []
    }]
  }
  // 获取焦点时需要将 warehouseCode 拼接成 数组，否则无法选中
  static focusWarehouseCode(fbaJob) {
    const warehouse = getObjectByCache(basicCacheKeys.basic_data_OverseaWarehouse, 'warehouseCode', fbaJob.warehouseCode)
    fbaJob.warehouseCode = warehouse && fbaJob.warehouseCode ? [(warehouse.ifFba ? 'FBA' : 'NoFBA'), fbaJob.warehouseCode] : []
  }
  // 失去焦点时需要将 warehouseCode 还原成 字符串，否则保存的值有问题
  static blurWarehouseCode(fbaJob) {
    if (fbaJob.warehouseCode && fbaJob.warehouseCode instanceof Array && fbaJob.warehouseCode.length > 1) {
      fbaJob.warehouseCode = fbaJob.warehouseCode[1]
    }
  }
  // 亚马逊仓库编码
  static warehouseCodeHandler(fbaJob, dataArr) {
    let data = {}
    if (dataArr && dataArr.length > 1) {
      data = { value: dataArr[1] }
    }
    fbaJob.warehouseCode = data.value
    fbaJob.country = ''
    fbaJob.zipCode = ''
    if (data.value) {
      const warehouse = getObjectByCache(basicCacheKeys.basic_data_OverseaWarehouse, 'warehouseCode', data.value)
      fbaJob.country = warehouse.countryCode
      fbaJob.zipCode = warehouse.zipCode
    }
  }
  // 处理fba收发通
  static fbaHandleSft(addr, handleType) {
    let curInfo = ''
    switch (handleType) {
      case 'shipper':
        if (addr.shipperEnterpriseName) {
          curInfo += addr.shipperEnterpriseName
        }
        if (addr.shipperAddress1) {
          if (curInfo) curInfo += '\n'
          curInfo += addr.shipperAddress1
        }
        addr.shipperLine3 = (addr.shipperCityCode +
            addr.shipperProvinceCode +
            addr.shipperCountryCode +
            addr.shipperZipCode)
        if (addr.shipperLine3) {
          if (curInfo) curInfo += '\n'
          curInfo += addr.shipperLine3
        }
        if (addr.notifyContactTel) {
          if (curInfo) curInfo += '\n'
          curInfo += ('TEL:' + addr.shipperContactTel)
        }
        break
      case 'consignee':
        if (addr.consigneeEnterpriseName) {
          curInfo += addr.consigneeEnterpriseName
        }
        if (addr.consigneeAddress1) {
          if (curInfo) curInfo += '\n'
          curInfo += addr.consigneeAddress1
        }
        addr.consigneeLine3 = (addr.consigneeCityCode +
            addr.consigneeProvinceCode +
            addr.consigneeCountryCode +
            addr.consigneeZipCode)
        if (addr.consigneeLine3) {
          if (curInfo) curInfo += '\n'
          curInfo += addr.consigneeLine3
        }
        if (addr.consigneeContactTel) {
          if (curInfo) curInfo += '\n'
          curInfo += ('TEL:' + addr.consigneeContactTel)
        }
        break
      case 'notify':
        if (addr.notifyEnterpriseName) {
          curInfo += addr.notifyEnterpriseName
        }
        if (addr.notifyAddress1) {
          if (curInfo) curInfo += '\n'
          curInfo += addr.notifyAddress1
        }
        addr.notifyLine3 = (addr.notifyCityCode +
            addr.notifyProvinceCode +
            addr.notifyCountryCode +
            addr.notifyZipCode)
        if (addr.notifyLine3) {
          if (curInfo) curInfo += '\n'
          curInfo += addr.notifyLine3
        }
        if (addr.notifyContactTel) {
          if (curInfo) curInfo += '\n'
          curInfo += ('TEL:' + addr.notifyContactTel)
        }
        break
      default:
        break
    }
    return curInfo
  }
  // 车型
  static vehicleTypeLabel(item) {
    if (item) {
      return item.englishName + '[' + item.chineseName + ']'
    }
    return ''
  }

  /**
   * 修改美国清关信息
   * @param job
   */
  static updateUsCustomsClearanceList(job) {
    if (job && job.usCustomsClearanceList && job.usCustomsClearanceList.length > 0) {
      // 修改起运港
      let countryCode = ''
      if (job.lob === 'SE' || job.lob === 'SI') {
        const port = getObjectByCache(TYPE_NAMES.basic_data_Seaport, 'code', job.loadingPortCode)
        if (port && port.countryCode) {
          countryCode = port.countryCode
        }
      } else if (job.lob === 'AE' || job.lob === 'AI') {
        const port = getObjectByCache(TYPE_NAMES.basic_data_Airport, 'code', job.loadingPortCode)
        if (port && port.countryCode) {
          countryCode = port.countryCode
        }
      }
      if (countryCode) {
        for (const item of job.usCustomsClearanceList) {
          item.countryOfOrigin = countryCode
          item.exportingCountry = countryCode
        }
      }
    }
  }

  /** *
   * 添加是否可以关闭模块的缓存变量, 当关闭模块时，会判断是否可以关闭，不可关闭则提示：“请先保存更改的数据，或退出编辑状态，然后关闭模块。”
   * @param module
   * @param canClose
   */
  static async setCanCloseModuleMap(module = '', canClose = true, jobNo = '') {
    if (module && $store && $store.state && $store.state.app) {
      await cache.load(cacheName.CONFIG)
      let key = module
      if (Number(cache.config.get('MultipleJobViewMode')) !== 0 && module === SystemConstants.CLOSE_MODULE_SE && jobNo) {
        key = key + '_' + jobNo
      }
      let canCloseModuleMap = $store.state.app.canCloseModuleMap
      if (!canCloseModuleMap) {
        canCloseModuleMap = new Set()
      }
      if (canClose) {
        if (canCloseModuleMap.has(key)) {
          canCloseModuleMap.delete(key)
        }
      } else {
        if (!canCloseModuleMap.has(key)) {
          canCloseModuleMap.add(key)
        }
      }
      await $store.dispatch('app/setCanCloseModuleMap', canCloseModuleMap)
    }
  }

  /**
   * 现场操作
   * @param job
   * @param data
   * @returns {Promise<void>}
   */
  static async siteOpChangeHandler(job, data) {
    job.siteOP = data.value
    job.siteOpDepartment = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'siteOp', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === $store.getters.currentOfficeId) {
            job.siteOpDepartment = item.departmentId
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'siteOp')
        job.siteOpDepartment = dep ? dep.departmentId : 0
      }
    }
  }

  /**
   * 验证额度超出，账期超出，全部超出
   * @param value
   */
  static async checkDateAndAmountExceeded(value) {
    let message = ''
    if (!value) return message
    if (value === 1) {
      // 额度账期都超出
      message = `${lang.t('queryJob.DateAndAmountExceededCreditControl')}</br>${lang.t('queryJob.ItAEntrustingUnitAgent')}</br>※${lang.t('queryJob.ThisHasBeenAutomaticallyCleared')}`
    } else if (value === 2) {
      // 额度超出
      message = `${lang.t('queryJob.AmountExceededCreditControl')}</br>${lang.t('queryJob.ItAEntrustingUnitAgent')}</br>※${lang.t('queryJob.ThisHasBeenAutomaticallyCleared')}`
    } else if (value === 3) {
      // 账期超出
      message = `${lang.t('queryJob.DateExceededCreditControl')}</br>${lang.t('queryJob.ItAEntrustingUnitAgent')}</br>※${lang.t('queryJob.ThisHasBeenAutomaticallyCleared')}`
    }
    return message
  }

  /**
   * 码头公司切换
   * @param job
   * @param data
   */
  static async terminalCompanyChangeHandler(job, data) {
    job.terminalCompany = data.value
    if (job.lob === SystemConstants.SE.code) { // 海出不需要这个
      return
    }
    const companyList = getCacheListByKey(basicCacheKeys.basic_data_Company)
    const company = companyList.find(p => p.cmpIdx === data.value)
    job.deliveryAddress = company ? company.deliveryAddress : ''
  }

  /**
   * 校验减少的箱数是否有效
   * @param preJob
   * @param job
   * @returns
   */
  static checkReduceUnitLoadDeviceNum(preJob, job) {
    if (!preJob.uuid || !preJob.airUld || preJob.airUld.length === 0 || !job.airUld || job.airUld.length === 0) {
      return true
    }
    /* seaEQ映射 */
    const seaEQMap = new Map()
    for (const item of job.airUld) {
      seaEQMap.set(item.containerCode + item.containerType, item.quantity)
    }
    // 当前箱子的Map
    const containerMap = new Map()
    let unitLoadDevices = null
    if (job.masterFlag) { // 主票取Container
      if (job.unitLoadDevices && job.unitLoadDevices.length > 0) {
        unitLoadDevices = job.unitLoadDevices
      }
    } else { // 小票取ContainerUsages
      if (job.unitLoadDeviceUsages && job.unitLoadDeviceUsages.length > 0) {
        unitLoadDevices = job.unitLoadDeviceUsages
      }
    }
    if (unitLoadDevices) {
      for (const item of unitLoadDevices) {
        const eqSizeType = item.containerCode + item.containerType
        let num = containerMap.get(eqSizeType)
        if (!num) {
          num = 1
        } else {
          num += 1
        }
        containerMap.set(eqSizeType, num)
      }
    }
    // 比较同箱型箱种的数量，如果一致，就不执行后续的逻辑判断了。
    let allSame = true
    if (seaEQMap.size > 0) {
      if (containerMap.size > 0) {
        for (const [key, value] of seaEQMap) {
          const sumQuantity = containerMap.get(key) || 0
          if (sumQuantity !== value) {
            allSame = false
            break
          }
        }
        if (allSame) {
          for (const [key, value] of containerMap) {
            const sumQuantity = seaEQMap.get(key) || 0
            if (sumQuantity !== value) {
              allSame = false
              break
            }
          }
        }
      } else {
        allSame = false
      }
    }
    if (allSame) {
      return true
    }
    /* 减少的箱数 */
    const reduceContainerNums = []
    for (const item of preJob.airUld) {
      const name = item.containerCode + item.containerType
      const num = item.quantity - (seaEQMap.get(name) || 0)
      if (num > 0) {
        reduceContainerNums.push({ name, containerCode: item.containerCode, containerType: item.containerType, num })
      }
    }
    if (reduceContainerNums.length === 0) {
      return true
    }
    /* 未关联箱封信息的箱数 */
    const noContainerSealNumMap = new Map()
    if (preJob.masterFlag) {
      if (!preJob.unitLoadDevices || preJob.unitLoadDevices.length === 0) {
        return true
      }
      for (const item of preJob.unitLoadDevices) {
        if (item.containerNumber) {
          continue
        }
        const eqSizeType = item.containerCode + item.containerType
        let num = noContainerSealNumMap.get(eqSizeType)
        if (!num) {
          num = 1
        } else {
          num += 1
        }
        noContainerSealNumMap.set(eqSizeType, num)
      }
    } else {
      if (!preJob.unitLoadDeviceUsages || preJob.unitLoadDeviceUsages.length === 0) {
        return true
      }
      for (const item of preJob.unitLoadDeviceUsages) {
        if (item.containerNumber) {
          continue
        }
        const eqSizeType = item.containerCode + item.containerType
        let num = noContainerSealNumMap.get(eqSizeType)
        if (!num) {
          num = 1
        } else {
          num += 1
        }
        noContainerSealNumMap.set(eqSizeType, num)
      }
    }
    // 【未关联箱封信息的箱数】必须大于等于【减少的箱数】
    for (const item of reduceContainerNums) {
      const noContainerSealNum = noContainerSealNumMap.get(item.name) || 0
      if (noContainerSealNum < item.num) {
        const name = CommonState.getNameByCode(SystemConstants.AIRPLANE_CONTAINER_TYPES, item.containerType)
        Message.warning(lang.t('queryJob.QuantityIsInconsistentOfCodeType', { containerCode: item.containerCode, containerType: name }))
        return false
      }
    }
    return true
  }

  /**
   * 校验箱型、箱量
   * @param job
   */
  static checkUldCodeAndType(job) {
    const airUld = job.airUld
    if (!airUld || airUld.length === 0) {
      return
    }
    const containerEqSizeTypeMap = new Map()
    if (job.masterFlag) {
      const unitLoadDevices = job.unitLoadDevices
      if (!unitLoadDevices || unitLoadDevices.length === 0) {
        return
      }
      for (const item of unitLoadDevices) {
        const eqSizeType = item.containerCode + item.containerType
        let num = containerEqSizeTypeMap.get(eqSizeType)
        if (!num) {
          num = 1
        } else {
          num += 1
        }
        containerEqSizeTypeMap.set(eqSizeType, num)
      }
    } else {
      const unitLoadDeviceUsages = job.unitLoadDeviceUsages
      if (!unitLoadDeviceUsages || unitLoadDeviceUsages.length === 0) {
        return
      }
      for (const item of unitLoadDeviceUsages) {
        const eqSizeType = item.containerCode + item.containerType
        let num = containerEqSizeTypeMap.get(eqSizeType)
        if (!num) {
          num = 1
        } else {
          num += 1
        }
        containerEqSizeTypeMap.set(eqSizeType, num)
      }
    }
    for (const item of airUld) {
      const num = containerEqSizeTypeMap.get(item.containerCode + item.containerType)
      if (num !== item.quantity) {
        const name = CommonState.getNameByCode(SystemConstants.AIRPLANE_CONTAINER_TYPES, item.containerType)
        Message.warning(lang.t('queryJob.QuantityIsInconsistentOfCodeType', { containerCode: item.containerCode, containerType: name }))
        return
      }
    }
  }

  /**
   * mbl修改后，若原mbl不为空，且与新值不等，则提醒是否清空港区字段
   * @param job
   * @param field
   * @param view
   * @returns {Promise<void>}
   */
  static async mblChange(job, field, view) {
    if (field !== 'mbl') {
      return
    }
    let flag = false
    const fieldMsg = []
    await new Job(job).loadPushHistoryLogs()
    const item = job.pushHistoryLogs
    const fieldNames = new Set()
    const fields = new Set()
    if (item) {
      for (const k in item) {
        for (const data of item[k]) {
          fieldNames.add(data.fieldName)
        }
      }
    }
    if (fieldNames.size === 0) {
      return
    }
    for (const fieldName of fieldNames) {
      if (job[COMPARE_FIELD[fieldName]]) {
        fieldMsg.push(fieldName)
        fields.add(COMPARE_FIELD[fieldName])
      }
    }
    if (fieldMsg.length === 0) { // 都没有值，就不需要提醒
      return
    }
    await view.$confirm(lang.t('CargoMsg.Cargo_UpdateMblMsg', [fieldMsg.join(',')]), lang.t('common.tips.prompt'), {
      confirmButtonText: lang.t('SeaExport.Yes'),
      cancelButtonText: lang.t('SeaExport.No'),
      closeOnClickModal: false,
      type: 'info'
    }).then(() => {
      flag = true
    }).catch(() => {
    })
    if (flag) {
      for (const field1 of fields) {
        job[field1] = ''
      }
    }
  }

  /**
   * 业务是否锁单
   * CARGO-35026 信控需要改成老版本(必发)
   * @param job
   * @returns {string|Event|*|boolean}
   */
  static isBlockJob(job) {
    if (!job) return false
    // 超期超额 且 特批 且 业务到期日有值，则判断业务到期日 是否有效，无效则将业务锁定
    if (job.blocked && job.specialApproval && job.specialApprovalDate) {
      const curDate = moment(new Date()).format('YYYY-MM-DD')
      const specialApprovalDate = moment(job.specialApprovalDate).format('YYYY-MM-DD')
      // 特批有效期小于当前日期，则锁定业务
      return specialApprovalDate < curDate
    }
    return job.blocked && !job.specialApproval
  }

  /**
   * 业务是否有效
   * PILL-964 信控配置，edi订舱配置锁定，业务锁定被特批后依旧不可以edi订舱
   * @param job
   * @returns {string|Event|*|boolean}
   */
  static isEffective(job) {
    if (!job) return false
    // 特批 且 业务到期日有值，则判断业务到期日 是否有效，无效则将业务锁定
    if (job.specialApproval && job.specialApprovalDate) {
      const curDate = moment(new Date()).format('YYYY-MM-DD')
      const specialApprovalDate = moment(job.specialApprovalDate).format('YYYY-MM-DD')
      // 特批有效期大于等于当前日期，则业务有效
      return specialApprovalDate >= curDate
    }
    return job.specialApproval
  }

  static async isPoNoExist(poNo, jobuuid) {
    let flg = true
    const count = await checkPoNoIsExist(poNo, jobuuid).then(res => res.data)
    if (count > 0) {
      await MessageBox.confirm(lang.t('CargoMsg.Cargo_PoNoExistTips'), lang.t('common.tips.prompt'), {
        confirmButtonText: lang.t('SeaExport.Yes'),
        cancelButtonText: lang.t('SeaExport.No'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        flg = true
      }).catch(() => {
        flg = false
      })
    }
    return flg
  }

  /**
   * 组装 RMB总收入、RMB总成本、RMB总利润、USD总收入、USD总成本、USD总利润、总收入、总成本、总利润
   * @param columnDefs
   */
  static async enrichTotalRevenueColumnDefs(columnDefs, view, containsTotal = true) {
    await cache.load(cacheName.CONFIG)
    const isHc = String(cache.config.get('ToExoSystem')) === 'HC'
    if (isHc) {
      const chargeCalculateAmount = Number(cache.config.get('chargeCalculateAmount')) === 1
      columnDefs.push(
        {
          headerName: view.$t('CargoMsg.Cargo_Receivable') + 'RMB',
          field: 'revenueSumRMB',
          colId: 'revenueSumRMB',
          width: 200,
          hide: true,
          enableRowGroup: true,
          cellRenderer: (params) => {
            const curValue = chargeCalculateAmount ? params.value : params.data['revenueNoTaxSumRMB']
            return formatNumberToThousands(ColumnUtils.formatNumber(curValue, 2, true, true))
          }
        },
        {
          headerName: view.$t('CargoMsg.Cargo_Receivable') + 'USD',
          field: 'revenueSumUSD',
          colId: 'revenueSumUSD',
          width: 200,
          hide: true,
          enableRowGroup: true,
          cellRenderer: (params) => {
            const curValue = chargeCalculateAmount ? params.value : params.data['revenueNoTaxSumUSD']
            return formatNumberToThousands(ColumnUtils.formatNumber(curValue, 2, true, true))
          }
        },
        {
          headerName: view.$t('CargoMsg.Cargo_Dues') + 'RMB',
          field: 'costSumRMB',
          colId: 'costSumRMB',
          width: 200,
          hide: true,
          enableRowGroup: true,
          cellRenderer: (params) => {
            const curValue = chargeCalculateAmount ? params.value : params.data['costNoTaxSumRMB']
            return formatNumberToThousands(ColumnUtils.formatNumber(curValue, 2, true, true))
          }
        },
        {
          headerName: view.$t('CargoMsg.Cargo_Dues') + 'USD',
          field: 'costSumUSD',
          colId: 'costSumUSD',
          width: 200,
          hide: true,
          enableRowGroup: true,
          cellRenderer: (params) => {
            const curValue = chargeCalculateAmount ? params.value : params.data['costNoTaxSumUSD']
            return formatNumberToThousands(ColumnUtils.formatNumber(curValue, 2, true, true))
          }
        },
        {
          headerName: view.$t('CargoMsg.Cargo_Profit') + 'RMB',
          field: 'revenueSubstractCostRMB',
          colId: 'revenueSubstractCostRMB',
          width: 200,
          hide: true,
          enableRowGroup: true,
          cellRenderer: (params) => {
            const curValue = chargeCalculateAmount ? params.value : params.data['revenueNoTaxSubstractCostRMB']
            return formatNumberToThousands(ColumnUtils.realProfit2Func(curValue))
          }
        },
        {
          headerName: view.$t('CargoMsg.Cargo_Profit') + 'USD',
          field: 'revenueSubstractCostUSD',
          colId: 'revenueSubstractCostUSD',
          width: 200,
          hide: true,
          enableRowGroup: true,
          cellRenderer: (params) => {
            const curValue = chargeCalculateAmount ? params.value : params.data['revenueNoTaxSubstractCostUSD']
            return formatNumberToThousands(ColumnUtils.realProfit2Func(curValue))
          }
        }
      )
      if (containsTotal) {
        columnDefs.push(
          {
            headerName: view.$t('CargoMsg.Cargo_TotalReceivable'),
            field: 'revenueSum',
            colId: 'revenueSum',
            width: 200,
            hide: true,
            enableRowGroup: true,
            cellRenderer: (params) => {
              const curValue = chargeCalculateAmount ? params.value : params.data['revenueNoTaxSum']
              return formatNumberToThousands(ColumnUtils.formatNumber(curValue, 2, true, true))
            }
          },
          {
            headerName: view.$t('CargoMsg.Cargo_TotalDues'),
            field: 'costSum',
            colId: 'costSum',
            width: 200,
            hide: true,
            enableRowGroup: true,
            cellRenderer: (params) => {
              const curValue = chargeCalculateAmount ? params.value : params.data['costNoTaxSum']
              return formatNumberToThousands(ColumnUtils.formatNumber(curValue, 2, true, true))
            }
          },
          {
            headerName: view.$t('FinanceManage.charge_profitAll'),
            field: 'revenueSubstractCost',
            colId: 'revenueSubstractCost',
            width: 200,
            hide: true,
            enableRowGroup: true,
            cellRenderer: (params) => {
              const curValue = chargeCalculateAmount ? params.value : params.data['revenueNoTaxSubstractCost']
              return formatNumberToThousands(ColumnUtils.realProfit2Func(curValue))
            }
          }
        )
      }
    }
  }

  /**
   * CARGO-36183 数据服务-增加船公司必填条件，及软提示
   * @param form
   * @returns {Promise<boolean>}
   */
  static async checkShippingCompanyCargoTracking(form) {
    if (form && !form.lclMasterUuid && form.mbl && (!form.carrierId || Number(form.carrierId) <= 0)) {
      let isOpen = null
      let subscribeConfig = null
      await Promise.all([
        querySubscribeConfig({}).then(res => {
          if (res.data && res.data.length > 0) {
            subscribeConfig = res.data[0]
          }
        }),
        checkBsItemOpened(SystemConstants.SHIPPING_COMPANY_CARGO_TRACKING).then(res => {
          isOpen = res.data // 这里没值会返回null
        })
      ])
      if (!isOpen) return false
      if (!subscribeConfig) return false
      // 匹配整拼类型
      const isContainerLoadType = subscribeConfig.containerLoadType && form.containerLoadType && subscribeConfig.containerLoadType.indexOf(form.containerLoadType) !== -1
      if (!isContainerLoadType) return false
      // 匹配推送客户白名单、全部
      const isPushCustomer = subscribeConfig.pushCondition && [1, 2].includes(subscribeConfig.pushCondition) // 1:全部 2：白名单 3：黑名单
      if (!isPushCustomer) return false
      // 匹配推送港口
      const isLoadingPort = subscribeConfig.loadingPortCodes && form.loadingPortCode && subscribeConfig.loadingPortCodes.indexOf(form.loadingPortCode) !== -1
      if (subscribeConfig.trackingLoadingPort && !isLoadingPort) return false
      Message.warning(lang.t('CargoMsg.Cargo_CheckShippingCompanyCargoTracking'))
      return true
    }
    return false
  }

  // 交叉委托，操作方修改了的字段
  static changeField(job, relatedChangeField) {
    // 初始化所有change字段为false
    const fields = [
      'change_vessel',
      'change_voyageFlight',
      'change_bookingAgent',
      'change_soNo',
      'change_secondVesselVoyage',
      'change_secondVoyage',
      'change_agentPartyLine1',
      'change_agentPartyLine2',
      'change_agentPartyLine3',
      'change_agentPartyLine4',
      'change_agentPartyLine5',
      'change_agentPartyLine6',
      'change_agentPartyLine7'
    ]
    // 将所有change字段重置为false
    fields.forEach(field => {
      job[field] = false
    })
    // 如果relatedChangeField有效，更新相应的change字段
    if (relatedChangeField) {
      try {
        const data = JSON.parse(relatedChangeField)
        if (data) {
          fields.forEach(field => {
            job[field] = data[field.replace('change_', '')] || false
          })
        }
      } catch (error) {
        console.error('Error parsing relatedChangeField:', error)
      }
    }
  }

  /**
   * 打开投保页面
   * @param payload
   * @returns {Promise<void>}
   */
  static async openInsure(payload, view) {
    await cache.load(cacheName.CONFIG)
    if (cache.config.get('ToExoSystem') === 'HONGMING') {
      checkHmFreightInsurance(payload).then(async res => {
        if (res.data.existRecord) {
          Message.warning(lang.t('Insurance.TheInsuranceHasExist'))
          return false
        }
        window.open(res.data.url)
      }).catch((data) => {
        if (data !== 'cancel' && data !== 'close') {
          Message.error({ 'message': data.replace(/\n/g, '<br>'), 'dangerouslyUseHTMLString': true })
        }
      })
      return false
    }
    // 验证投保参数
    let continueExec = true
    // 若参数校验异常会直接抛出，若已经存在投保记录则提示
    await checkFreightInsurance(payload).then(async res => {
      if (res.data.existRecord) {
        continueExec = false
        const promptText = lang.t('Insurance.ExistInsuranceReocordContinue') + `<span style="color:red">` + lang.t('Insurance.CreatedNewInsureForm') + `</span>` + '?' + `<br>` +
        lang.t('Insurance.ToViewOriginalApplication') + `<span style="color:red">` + lang.t('Insurance.Insurance') + `</span>` + lang.t('Insurance.Tab')
        await view.$confirm(promptText, lang.t('common.tips.prompt'), {
          confirmButtonText: lang.t('common.btn.yes'),
          cancelButtonText: lang.t('common.btn.no'),
          dangerouslyUseHTMLString: true,
          type: 'warning'
        }).then(async() => {
          continueExec = true
        })
      }
    }).catch((data) => {
      if (data !== 'cancel' && data !== 'close') {
        Message.error({ 'message': data.replace(/\n/g, '<br>'), 'dangerouslyUseHTMLString': true })
      }
      continueExec = false
    })
    return continueExec
  }

  /**
   * 批量更新sop模板
   * @param view
   * @param rows
   */
  static batchUpdateSopTemplate(view, rows) {
    if (rows.length <= 0) {
      view.$message.warning(view.$t('Message.SelectTheData'))
      return
    }
    if (rows.length > 200) {
      view.$message.warning(view.$t('SeaExport.maxSelectBusiness', ['200']))
      return
    }
    view.changeSopTemplateDialog.jobList = rows
    view.changeSopTemplateDialog.visible = true
  }

  static batchLockJobHandler(view, rows, autoLock, callBackFunc) {
    if (rows.length <= 0) {
      view.$message.warning(view.$t('Message.SelectTheData'))
      return
    }
    const jobKeys = Array.from(rows, p => p.uuid)
    const data = { jobs: jobKeys, autoLock: autoLock }
    const loading = getLoading4Cxt(this)
    batchLockJobFunc(data).then(res => {
      view.$message.success(view.$t('SeaExport.SuccessfulProcessing'))
      callBackFunc()
    }).finally(() => {
      loading.close()
    })
  }

  // 根据 海港 带出 航线
  static getLineByPort(portCode, portType) {
    if (!portCode) {
      return ''
    }
    let ports
    if (SystemConstants.PORT_TYPE_SEAPORT.code === portType) {
      ports = getCacheListByKey(basicCacheKeys.basic_data_Seaport)
    } if (SystemConstants.PORT_TYPE_AIRPORT.code === portType) {
      ports = getCacheListByKey(basicCacheKeys.basic_data_Airport)
    }
    if (ports && ports.length > 0) {
      const port = ports.find(p => p.code === portCode)
      if (port) {
        return port.region
      }
    }
    return ''
  }

  // 发送货物明细
  static async toSendPoItem(view, rows) {
    if (rows.length <= 0) {
      view.$message.warning(view.$t('Message.SelectTheData'))
      return
    }
    const jobKeys = Array.from(rows, p => p.uuid)
    const branchId = $store.getters.currentOfficeId
    const loading = getLoading()
    await jdySendPoItems({ branchId: branchId, jobUuids: jobKeys }).then(res => {
      const data = res.data
      if (data && data.successNum === 0 && data.failNum === 0) {
        view.$message.warning(view.$t('Message.NoSendingGoodsInfo'))
        return
      }
      if (data && data.successNum && data.failNum === 0) {
        view.$message.success(view.$t('Message.SuccessfullySent'))
        return
      }
      if (data && data.failNum) {
        const failList = data.jdyPoItemFailVOS || []
        let errorMessage = view.$t('SeaExport.sendFailInfo').replace('{0}', data.successNum).replace('{1}', data.failNum) + `<br>`
        failList.forEach((failItem, index) => {
          errorMessage += `${index + 1}. ` + view.$t('Clearing.BusinessNumber') + `：${failItem.jobNo} Order NO：${failItem.orderNo} ItemNO：${failItem.itemNo}` + view.$t('CargoMsg.Cargo_ResultMessage') + `: ${failItem.reason}<br>`
        })
        view.$message.warning({
          message: errorMessage,
          dangerouslyUseHTMLString: true
        })
      }
    }).finally(() => {
      loading.close()
    })
  }
  static async toUnlockStatus(view, rows) {
    if (rows.length <= 0) {
      view.$message.warning(view.$t('Message.SelectTheData'))
      return
    }
    const jobUuids = Array.from(rows, p => p.uuid)
    const loading = getLoading()
    await jdyUnlockStatus(jobUuids).then(res => {
      view.$message.success(view.$t('CargoMsg.Cargo_UnLockLabel') + view.$t('CargoMsg.Cargo_Success'))
    }).finally(() => {
      loading.close()
    })
  }
  // 业务退回预审
  static async batchReturnReview(view, rows) {
    if (rows.length <= 0) {
      view.$message.warning(view.$t('Message.SelectTheData'))
      return
    }
    await cache.load(cacheName.CONFIG)
    const isHc = String(cache.config.get('ToExoSystem')) === 'HC'
    // 数据校验
    const plannerEmpty = []
    let hasFob = false
    let hasNoFob = false
    for (const job of rows) {
      // if (job.jobState !== SystemConstants.STATE_OPERATING.code) {
      //   view.$message.warning(view.$t('CargoMsg.Cargo_ReturnCurrentOperationOnly'))
      //   return
      // }
      if (job.incoTerm === 'FOB') {
        hasFob = true
      } else {
        hasNoFob = true
        if (!job.planner) {
          plannerEmpty.push(job.jobNo)
        }
      }
    }
    if (isHc) {
      if (hasFob && hasNoFob) {
        view.$message.warning(view.$t('CargoMsg.Cargo_MixedBusinessTypeError'))
        return
      }
      if (plannerEmpty && plannerEmpty.length > 0) {
        view.$message.warning(view.$t('CargoMsg.Cargo_RouteManagerEmptyError', [plannerEmpty.join('、')]))
        return
      }
    }
    view.returnReviewDialog.selectedJobs = rows
    view.returnReviewDialog.visible = true
  }
  // 校验委托单位归属分公司范围
  static async checkCustomerBranchScope(job, tabName) {
    const customer = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', job.customerId)
    if (!customer || customer.branchId === 1) {
      return
    }
    await cache.load(cacheName.CONFIG)
    const customerIdBranchScope = Number(cache.config.get('CustomerIdBranchScope'))
    const branchIds = []
    if (customerIdBranchScope === 1) {
      if (job.opOffice > 0) {
        branchIds.push(job.opOffice)
      }
    } else if (customerIdBranchScope === 2) {
      if (job.salesOffice > 0) {
        branchIds.push(job.salesOffice)
      }
    } else if (customerIdBranchScope === 3) {
      if (job.opOffice > 0) {
        branchIds.push(job.opOffice)
      }
      if (job.salesOffice > 0) {
        branchIds.push(job.salesOffice)
      }
    }
    if (branchIds.length === 0) {
      return
    }
    if (!branchIds.includes(customer.branchId)) {
      throw new TabError(lang.t('queryJob.CustomerBranchScopeNot'), tabName)
    }
  }
  static async getReceiptCharges(form) {
    if (!form.lclSlaves || form.lclSlaves.length === 0 || !form.uuid) {
      return
    } else {
      const charges = await getAllSlaveChargeList(form.uuid).then(res => res.data)
      for (const job of form.lclSlaves) {
        job.charges = charges[job.uuid] ? charges[job.uuid] : []
      }
    }
  }

  static async opOfficeChange({ view, job, isRemoteBooking, warehouseCallback, modifiedData }) {
    if (job.lob !== 'IE') {
      await this.matchUserPortConfig(view, job, isRemoteBooking, async() => {
        return await MessageBox.confirm(lang.t('SystemMaintenance.OpOfficeChangeUpdateData'), lang.t('Message.Prompt'), {
          confirmButtonText: lang.t('Message.Yes'),
          cancelButtonText: lang.t('Message.No'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => true).catch(() => false)
      })
    }
    await this.matchRegionWarehouseMappingConfig(job, warehouseCallback, isRemoteBooking, async() => {
      return await MessageBox.confirm(lang.t('SystemMaintenance.WarehouseChangeUpdateData'), lang.t('Message.Prompt'), {
        confirmButtonText: lang.t('Message.Yes'),
        cancelButtonText: lang.t('Message.No'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => true).catch(() => false)
    }, modifiedData)
  }

  /**
   * 匹配用户关联港口的配置
   * @param job
   * @param isRemoteBooking 是否为远程订舱
   * @param {Object} otherParams { keepOriginValue // 保持原值 }
   * @returns
   */
  static async matchUserPortConfig(view, job, isRemoteBooking = false, alertCallbak, otherParams) {
    if (!job.lob) {
      return
    }
    const { keepOriginValue = false } = otherParams || {}
    if (view) {
      for (const key in view.userPortRoleData) {
        view.userPortRoleData[key] = null
      }
    }
    let config = null
    if (view) {
      await cache.load(cacheName.CONFIG)
      config = cache.config
    } else {
      config = await getConfig(job.opOffice, false)
    }
    const useUserPort = Number(config.get('useUserPort')) === 1
    if (!useUserPort) {
      return
    }
    if (isRemoteBooking) {
      const useUserPortRemoteBooking = Number(cache.hqConfig.get('useUserPortRemoteBooking')) === 1
      if (!useUserPortRemoteBooking) {
        return
      }
    }
    let portCode = ''
    let region = ''
    let operateType = ''
    let loadingPortCode = ''
    switch (job.lob) {
      case 'SE':
        portCode = job.dischargingPortCode
        operateType = job.containerLoadType
        loadingPortCode = job.loadingPortCode
        break
      case 'SI':
        portCode = job.dischargingPortCode
        operateType = job.containerLoadType
        loadingPortCode = job.loadingPortCode
        break
      case 'AE':
        portCode = job.destinationPortCode
        operateType = job.operateType
        loadingPortCode = job.loadingPortCode
        break
      case 'AI':
        portCode = job.dischargingPortCode
        operateType = job.operateType
        loadingPortCode = job.loadingPortCode
        break
      case 'RE':
        portCode = job.destinationStation
        region = job.transportLine
        operateType = job.containerLoadType
        loadingPortCode = job.departureStation
        break
      case 'RI':
        portCode = job.destinationStation
        region = job.transportLine
        operateType = job.containerLoadType
        loadingPortCode = job.departureStation
        break
    }
    if (portCode) {
      if (job.lob === 'SE' || job.lob === 'SI') {
        const port = getObjectByCache(TYPE_NAMES.basic_data_Seaport, 'code', portCode)
        if (port) {
          region = port.region
        }
      } else if (job.lob === 'AE' || job.lob === 'AI') {
        const port = getObjectByCache(TYPE_NAMES.basic_data_Airport, 'code', portCode)
        if (port) {
          region = port.region
        }
      }
    }
    // if (!portCode && !region) {
    //   return
    // }
    const res = await getMatchedUserPorts({ lob: job.lob, code: portCode, region, operateType, customJobType: job.customJobType,
      opOffice: job.opOffice, loadingPortCode, cargoType: job.cargoType, carrierId: job.carrierId, consigneeId: job.consigneeId, cargoSource: job.cargoSource,
      destinationAgent: job.destinationAgent })
    if (res.data.length === 0) {
      return
    }
    if (alertCallbak && !await alertCallbak()) {
      return
    }
    const roleUsersMap = new Map()
    for (const { userId, multipleRole, matchCount } of res.data) {
      const user = getObjectByCache(TYPE_NAMES.basic_data_User, 'userId', userId)
      if (!user || !multipleRole) {
        continue
      }
      const roles = multipleRole.split(',')
      for (const role of roles) {
        const items = role.split('-')
        const roleValue = items[0]
        const isDefault = items[1] === '1'
        let users = roleUsersMap.get(roleValue)
        if (!users) {
          users = []
          roleUsersMap.set(roleValue, users)
        }
        users.push(isDefault ? { ...user, isDefault, matchCount } : { ...user, matchCount })
      }
    }
    const manualSelectIfMultiple = Number(cache.hqConfig.get('useUserPortManualSelectIfMultiple')) === 1
    const useUserPortNotUpdate = Number(cache.hqConfig.get('useUserPortNotUpdate')) === 1
    for (const [role, users] of roleUsersMap) {
      // 按匹配项数量降序
      users.sort((a, b) => b.matchCount - a.matchCount)
      if (view) {
        view.userPortRoleData[role] = users
      }
      if (keepOriginValue) {
        continue
      }
      let userId = 0
      if (!(users.length > 1 && manualSelectIfMultiple)) {
        // const defaultUser = users.find(p => p.isDefault)
        // userId = defaultUser ? defaultUser.userId : users[0].userId
        // 取匹配字段最多的用户数据
        const maxMatchCount = users[0].matchCount
        // 可能存在匹配字段相同多的用户数据
        const candidates = users.filter(u => u.matchCount === maxMatchCount)
        // 优先默认值
        const selected = candidates.find(u => u.isDefault)
        if (selected) {
          // 多人都默认或都不默认，随机或取第一条
          userId = selected.userId
        } else {
          userId = candidates[0].userId
        }
      }
      switch (role) {
        case 'userDefinedRole1':
          if (useUserPortNotUpdate && job.userDefinedRoleId1) {
            break
          }
          job.userDefinedRoleId1 = userId
          if (userId > 0) {
            await this.loadUserDepOfficeByRole(userId, role, depId => { job.userDefinedRoleDept1 = depId }, officeId => { job.userDefinedRoleOffice1 = officeId })
          }
          break
        case 'userDefinedRole2':
          if (useUserPortNotUpdate && job.userDefinedRoleId2) {
            break
          }
          job.userDefinedRoleId2 = userId
          if (userId > 0) {
            await this.loadUserDepOfficeByRole(userId, role, depId => { job.userDefinedRoleDept2 = depId }, officeId => { job.userDefinedRoleOffice2 = officeId })
          }
          break
        case 'userDefinedRole3':
          if (useUserPortNotUpdate && job.userDefinedRoleId3) {
            break
          }
          job.userDefinedRoleId3 = userId
          if (userId > 0) {
            await this.loadUserDepOfficeByRole(userId, role, depId => { job.userDefinedRoleDept3 = depId }, officeId => { job.userDefinedRoleOffice3 = officeId })
          }
          break
        case 'userDefinedRole4':
          if (useUserPortNotUpdate && job.userDefinedRoleId4) {
            break
          }
          job.userDefinedRoleId4 = userId
          if (userId > 0) {
            await this.loadUserDepOfficeByRole(userId, role, depId => { job.userDefinedRoleDept4 = depId }, officeId => { job.userDefinedRoleOffice4 = officeId })
          }
          break
        case 'userDefinedRole5':
          if (useUserPortNotUpdate && job.userDefinedRoleId5) {
            break
          }
          job.userDefinedRoleId5 = userId
          if (userId > 0) {
            await this.loadUserDepOfficeByRole(userId, role, depId => { job.userDefinedRoleDept5 = depId }, officeId => { job.userDefinedRoleOffice5 = officeId })
          }
          break
        case 'userDefinedRole6':
          if (useUserPortNotUpdate && job.userDefinedRoleId6) {
            break
          }
          job.userDefinedRoleId6 = userId
          if (userId > 0) {
            await this.loadUserDepOfficeByRole(userId, role, depId => { job.userDefinedRoleDept6 = depId }, officeId => { job.userDefinedRoleOffice6 = officeId })
          }
          break
        case 'userDefinedRole7':
          if (useUserPortNotUpdate && job.userDefinedRoleId7) {
            break
          }
          job.userDefinedRoleId7 = userId
          if (userId > 0) {
            await this.loadUserDepOfficeByRole(userId, role, depId => { job.userDefinedRoleDept7 = depId }, officeId => { job.userDefinedRoleOffice7 = officeId })
          }
          break
        case 'overseaOp':
          if (useUserPortNotUpdate && job.overseaOp) {
            break
          }
          job.overseaOp = userId
          if (userId > 0) {
            await this.loadUserDepOfficeByRole(userId, role, depId => { job.overseaOpDepartment = depId })
          }
          break
        case 'siteOp':
          if (useUserPortNotUpdate && job.siteOP) {
            break
          }
          job.siteOP = userId
          if (userId > 0) {
            await this.loadUserDepOfficeByRole(userId, role, depId => { job.siteOpDepartment = depId })
          }
          break
        case 'doc':
          if (useUserPortNotUpdate && job.dc) {
            break
          }
          job.dc = userId
          if (userId > 0) {
            await this.loadUserDepOfficeByRole(userId, role, depId => { job.dcDepartment = depId }, officeId => { job.dcOffice = officeId })
          }
          break
        case 'csr':
          if (useUserPortNotUpdate && job.csr) {
            break
          }
          job.csr = userId
          if (userId > 0) {
            await this.loadUserDepOfficeByRole(userId, role, depId => { job.csrDepartment = depId }, officeId => { job.csrOffice = officeId })
          }
          break
        case 'op':
          if (useUserPortNotUpdate && job.op) {
            break
          }
          job.op = userId
          if (userId > 0) {
            await this.opChangeHandler(job, userId)
          }
          break
        case 'seaLine':
        case 'airline':
        case 'railwayLine':
          if (useUserPortNotUpdate && job.planner) {
            break
          }
          job.planner = userId
          if (userId > 0) {
            await this.loadUserDepOfficeByRole(userId, role, depId => { job.plannerDepartment = depId })
          }
          break
      }
    }
    return true
  }

  // 根据岗位加载用户部门和分公司
  static async loadUserDepOfficeByRole(userId, role, depCallback, officeCallback) {
    const offices = await User.getUserDepartmentOffices('role', role, userId)
    if (offices && offices.length > 1) {
      let departmentId = 0
      let officeId = 0
      for (const item of offices) {
        if (item.officeId === $store.getters.currentOfficeId) {
          if (depCallback) {
            departmentId = item.departmentId
          }
          if (officeCallback) {
            officeId = item.officeId
          }
          break
        }
      }
      if (depCallback) {
        depCallback(departmentId)
      }
      if (officeCallback) {
        officeCallback(officeId)
      }
    } else {
      const user = new User({ userId })
      const dep = await user.getDefaultDepartment('role', role)
      if (depCallback) {
        depCallback(dep ? dep.departmentId : 0)
      }
      if (officeCallback) {
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        officeCallback(office ? office.officeId : 0)
      }
    }
  }

  // 操作改变
  static async opChangeHandler(job, userId) {
    const user = getObjectByCache(TYPE_NAMES.basic_data_User, 'userId', userId)
    if (!user) {
      return
    }
    if (user.defaultDepId > 0) {
      job.opDepartment = user.defaultDepId
    } else {
      if (job.opOffice > 0) {
        await new User(user).getUserDefaultDepartmentByOffice('role', 'op', job.opOffice).then(dep => {
          job.opDepartment = dep ? dep.departmentId : 0
        })
      } else {
        await new User(user).getDefaultDepartment('role', 'op', job.opOffice).then(dep => {
          job.opDepartment = dep ? dep.departmentId : 0
        })
      }
    }
  }

  // 处理信控提醒信息
  static async handleCreditRemind(job, blockCreditData) {
    if (!blockCreditData || blockCreditData.length === 0) {
      return
    }
    await cache.load(cacheName.CONFIG)
    const useParentCreditSetting = cache.config.get('useParentCreditSetting' + job.lob) === '1'
    let creditModeStr = ''
    if (useParentCreditSetting) {
      creditModeStr = cache.hqConfig.get('creditMode' + job.lob)
    } else {
      creditModeStr = cache.config.get('creditMode' + job.lob)
    }
    const creditMode = creditModeStr ? (creditModeStr === '2' ? 2 : 1) : 2
    if (job.blocked || creditMode === 1) { // 业务已锁定，或者是锁单模式，则无需弹出提醒信息
      return
    }
    const msgList = []
    for (const item of blockCreditData) {
      let msg = lang.t('ReleaseNotes.lineCreditDialog.partners')
      msg += ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', item.cmpIdx, 'chineseName')
      if (item.dateExceeded) {
        msg += ' ' + lang.t('CargoMsg.Cargo_AccountPeriod')
      }
      if (item.amountExceeded) {
        msg += ' ' + lang.t('CargoMsg.Cargo_Limit')
      }
      msg += ' ' + lang.t('CargoMsg.Cargo_Exceeded') + '！'
      msgList.push(msg)
    }
    setTimeout(() => {
      Message.warning(msgList.join(' '))
    }, 50)
  }

  /**
   * 匹配航线与仓库、报关行、目的港代理 映射的配置
   * @param job
   * @param warehouseCallback
   * @param isRemoteBooking
   * @param alertCallbak
   * @param modifiedData
   * @param isCreate 是否为创建业务时触发
   * @param config
   * @returns
   */
  static async matchRegionWarehouseMappingConfig(job, warehouseCallback, isRemoteBooking = false, alertCallbak, modifiedData, isCreate = false, config) {
    if (!job.lob) {
      return
    }
    if (!config) {
      await cache.load(cacheName.CONFIG)
      config = cache.config
    }
    const associatedRoute = Number(config.get('AssociatedRoute')) === 1
    if (associatedRoute) {
      return
    }
    if (config.get('ToExoSystem') === 'JYD' && isCreate) {
      const warehousing = job.lob === 'SI' && job.masterFlag ? true : job.warehousing
      if (warehousing && warehouseCallback) {
        const callbackResult = warehouseCallback(0)
        if (callbackResult instanceof Promise) {
          await callbackResult
        }
      }
      job.customsBroker = 0
    }
    if (isRemoteBooking) {
      const useRouteWarehouseRemoteBooking = Number(cache.hqConfig.get('useRouteWarehouseRemoteBooking')) === 1
      if (!useRouteWarehouseRemoteBooking) {
        return
      }
    }
    let hasConfig = this.regionPortPresetConfigCache.get(job.lob)
    if (hasConfig === undefined) {
      await routeWarehouseMappingApi.getList({ lob: job.lob, paging: false }).then(res => {
        hasConfig = res.data.list.length > 0
        this.regionPortPresetConfigCache.set(job.lob, hasConfig)
      })
    }
    if (!hasConfig) {
      return
    }
    let portCode = ''
    let region = ''
    let operateType = ''
    let loadingPortCode = ''
    let carrierId = 0
    switch (job.lob) {
      case 'SE':
        portCode = job.dischargingPortCode
        operateType = job.containerLoadType
        loadingPortCode = job.loadingPortCode
        carrierId = job.carrierId
        break
      case 'SI':
        portCode = job.dischargingPortCode
        operateType = job.containerLoadType
        loadingPortCode = job.loadingPortCode
        carrierId = job.carrierId
        break
      case 'AE':
        portCode = job.destinationPortCode
        operateType = job.operateType
        loadingPortCode = job.loadingPortCode
        carrierId = job.carrierId
        break
      case 'AI':
        portCode = job.dischargingPortCode
        operateType = job.operateType
        loadingPortCode = job.loadingPortCode
        carrierId = job.carrierId
        break
      case 'RE':
        portCode = job.destinationStation
        region = job.transportLine
        operateType = job.containerLoadType
        loadingPortCode = job.departureStation
        break
      case 'RI':
        portCode = job.destinationStation
        region = job.transportLine
        operateType = job.containerLoadType
        loadingPortCode = job.departureStation
        break
      case 'IE':
        portCode = job.dischargingPortCode
        operateType = job.containerLoadType
        loadingPortCode = job.loadingPortCode
        if (job.containerLoadType === 'IC') {
          carrierId = job.carrierId
        }
        break
    }
    if (portCode) {
      if (job.lob === 'SE' || job.lob === 'SI' || job.lob === 'IE') {
        const port = getObjectByCache(TYPE_NAMES.basic_data_Seaport, 'code', portCode)
        if (port) {
          region = port.region
        }
      } else if (job.lob === 'AE' || job.lob === 'AI') {
        const port = getObjectByCache(TYPE_NAMES.basic_data_Airport, 'code', portCode)
        if (port) {
          region = port.region
        }
      }
    }
    // if (!portCode && !loadingPortCode && !region) {
    //   return
    // }
    const res = await routeWarehouseMappingApi.getMatchedRecords({ lob: job.lob, port: portCode, loadingPortCode, region, operateType, customJobType: job.customJobType, opOffice: job.opOffice, carrierId })
    if (!res.data) {
      // CARGO-46417 航线/港口预设配置模块里面的客户截关日期与系统默认的带值逻辑存在冲突 当业务【新增】和【编辑】时，优先取匹配条件的配置值。当没有对应匹配条件时，取系统默认值。（不要切换页签时，覆盖于匹配值）
      // 这里处理编辑的场景，新增已经处理过了, 限制业务类型为SE和AE 限制模式为编辑 限制etd
      if (job.uuid && job.etd && (job.lob === SystemConstants.SE.code || job.lob === SystemConstants.AE.code)) {
        this.customerCutoffDefaultHandle(job)
      }
      return
    }
    if (alertCallbak && !await alertCallbak()) {
      return
    }
    const {
      uuid, warehouseId, warehouseName, customsBroker, destinationAgent, portRequirement, dateCalculateIncludeCurrentDay, calculateIncludeEtdIsWeekend,
      arriveDateIncrement, fileCutoffIncrement, customerFileCutoffIncrement, customCutoffIncrement, customerCutoffIncrement, customerShutoutIncrement,
      incoTerm, paymentTermMBL, paymentTermHBL
    } = res.data
    console.log('res.data is', res.data)
    const warehousing = job.lob === 'SI' && job.masterFlag ? true : job.warehousing
    if (warehousing && warehouseId > 0 && warehouseCallback) {
      const callbackResult = warehouseCallback(warehouseId)
      if (callbackResult instanceof Promise) {
        await callbackResult
      }
      if (warehouseName) {
        if (job.warehouseInfo && job.warehouseInfo.length > 0) {
          job.warehouseName = warehouseName
          job.warehouseInfo[0].warehouseName = warehouseName
        }
      }
    }
    if (customsBroker > 0) {
      if (job.lob === 'SE' || job.lob === 'SI' || job.lob === 'AI' || job.lob === 'RE' || job.lob === 'RI' || job.lob === 'IE') {
        const customs = job.lob === 'SI' && job.masterFlag ? true : job.customs
        if (customs) {
          job.customsBroker = customsBroker
        }
      } else {
        job.customsBroker = customsBroker
      }
    }
    if (destinationAgent > 0 && (job.lob === 'SE' || job.lob === 'AE' || job.lob === 'RE' || job.lob === 'RI' || job.lob === 'IE')) {
      job.destinationAgent = destinationAgent
    }
    if (job.lob === 'SE') {
      const cargoDocs = job.seaCargoDoc
      if (cargoDocs && cargoDocs.length > 0) {
        for (const item of cargoDocs) {
          if (item.docType === CargoDocConsts.MBL || item.docType === CargoDocConsts.MBL2 || item.docType === CargoDocConsts.HBL || item.docType === CargoDocConsts.HBL2) {
            item.portRequirement = portRequirement
            item.regionWarehouseMappingUuid = uuid
            this.addSeaCargoDocToModifiedSet(item, modifiedData)
          }
        }
      }
    }
    console.log('job is', job)
    if ((job.lob === 'SE' || job.lob === 'AE') && job.etd) {
      if (arriveDateIncrement > 0) {
        const warehouseInfo = job.warehouseInfo
        if (warehouseInfo && warehouseInfo.length > 0) {
          for (const item of warehouseInfo) {
            item.arriveDate = this.getDecreaseDaysByEtd(job.etd, arriveDateIncrement, dateCalculateIncludeCurrentDay, calculateIncludeEtdIsWeekend)
            this.addWarehouseInfoToModifiedSet(item, modifiedData)
          }
        }
      }
    }
    if (incoTerm) {
      job.incoTerm = incoTerm
    }
    if (paymentTermMBL) {
      job.paymentTermMBL = paymentTermMBL
    }
    if (paymentTermHBL) {
      job.paymentTermHBL = paymentTermHBL
    }
  }

  /**
   * 根据ETD和提前量设置获取日期
   * @param etd
   * @param days
   * @param dateCalculateIncludeCurrentDay
   * @param calculateIncludeEtdIsWeekend
   */
  static getDecreaseDaysByEtd(etd, days, dateCalculateIncludeCurrentDay, calculateIncludeEtdIsWeekend) {
    const etdDate = new Date(etd)
    if (dateCalculateIncludeCurrentDay) {
      days = days - 1
    }
    // 有效的周末
    const validWeekends = []
    if (calculateIncludeEtdIsWeekend) {
      if (etdDate.getDay() === 6) { // 周六
        validWeekends.push(etdDate)
      }
      if (etdDate.getDay() === 0) { // 周末
        validWeekends.push(etdDate)
        /* 前一天的周六 */
        const saturday = new Date(etdDate)
        saturday.setDate(saturday.getDate() - 1)
        validWeekends.push(saturday)
      }
    }
    const newDate = this.getDaysAgoWithoutHoliday(etdDate, days, validWeekends)
    newDate.setHours(12, 0, 0)
    return DateUtils.formatStandardDateTime(newDate)
  }

  /**
   * 客户截关日期默认处理逻辑
   */
  static customerCutoffDefaultHandle(job) {
  }

  /**
   * 获取跳过周六周日的x天前（排除有效的周末）
   * @param date
   * @param days
   * @param validWeekends
   * @returns
   */
  static getDaysAgoWithoutHoliday(date, days, validWeekends) {
    validWeekends = validWeekends || []
    const currentDate = new Date(date)
    for (let i = 0; i < days; i++) {
      currentDate.setDate(currentDate.getDate() - 1) // 逐天减去指定天数
      while ((currentDate.getDay() === 0 || currentDate.getDay() === 6) && !DateUtils.includesByYearMonthDay(validWeekends, currentDate)) {
        currentDate.setDate(currentDate.getDate() - 1) // 如果是周末则再减一天
      }
    }
    return currentDate
  }

  /**
   * 添加seaCargoDoc到被修改的集合中
   * @param cargoDoc
   * @param modifiedData
   * @returns
   */
  static addSeaCargoDocToModifiedSet(cargoDoc, modifiedData) {
    if (!modifiedData) {
      return
    }
    modifiedData.seaCargoDoc = modifiedData.seaCargoDoc || []
    if (!modifiedData.seaCargoDoc.includes(cargoDoc)) {
      modifiedData.seaCargoDoc.push(cargoDoc)
    }
  }

  /**
   * 添加仓储信息到被修改的集合中
   * @param cargoDoc
   * @param modifiedData
   * @returns
   */
  static addWarehouseInfoToModifiedSet(item, modifiedData) {
    if (!modifiedData) {
      return
    }
    modifiedData.warehouseInfo = modifiedData.warehouseInfo || []
    if (!modifiedData.warehouseInfo.includes(item)) {
      modifiedData.warehouseInfo.push(item)
    }
  }

  /**
   * 下载港口要求相关附件
   * @param regionWarehouseMappingUuid
   * @returns
   */
  static downloadPortRequirementAttachment(regionWarehouseMappingUuid) {
    if (!regionWarehouseMappingUuid) {
      Message.warning(lang.t('SystemMaintenance.NoRelevantDocumentsAvailable'))
      return
    }
    const xmlParam =
      '<RequestObject><data><extendMetaData><entry><key>uuid</key><value>' +
      regionWarehouseMappingUuid +
      '</value></entry></extendMetaData></data></RequestObject>'
    getFileList(xmlParam).then(res => {
      if (res.data && res.data.length > 0) {
        const fileIds = Array.from(res.data, p => p.id).join(',')
        const day = moment().format('YYYYMMDDHHmmss')
        const fileName = day + '.zip'
        submitDataByPost(URL.common.downloadCompressFiles, {
          sessionId: $store.getters.userInfo.sessionId,
          fileIds,
          fileName
        })
      } else {
        Message.warning(lang.t('SystemMaintenance.NoRelevantDocumentsAvailable'))
      }
    })
  }

  // 处理费用信控提醒
  static async handleChargeCreditRemind(creditConfig, job, charge, field) {
    await cache.load(cacheName.CONFIG)
    if (Number(cache.config.get('creditOpen')) !== 1) {
      return
    }
    let receivableChargeAccountId = false
    if (job.cargoSource === 'NC') {
      receivableChargeAccountId = creditConfig.ncReceivableChargeAccountId
    } else if (job.cargoSource === 'SC') {
      receivableChargeAccountId = creditConfig.scReceivableChargeAccountId
    }
    if (!receivableChargeAccountId || !charge.receivable || !charge[field]) {
      return
    }
    await CreditInfo.checkCreditInfo(charge[field]).then(res => {
      if (!res.data || res.data.length <= 0) return
      const credit = res.data[0]
      if (!credit.dateExceeded && !credit.amountExceeded) {
        return
      }
      let msg = lang.t('ReleaseNotes.lineCreditDialog.partners')
      msg += ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', charge[field], 'chineseName')
      if (credit.dateExceeded) {
        msg += ' ' + lang.t('CargoMsg.Cargo_AccountPeriod')
      }
      if (credit.amountExceeded) {
        msg += ' ' + lang.t('CargoMsg.Cargo_Limit')
      }
      msg += ' ' + lang.t('CargoMsg.Cargo_Exceeded') + '！'
      Message.warning(msg)
    })
  }
  /**
   * 校验业务表字段是否有效,无效则置空
   * @param job
   */
  static async validateJobFieldActive(job, view, viewSource = '') {
    if (!job) return true
    await cache.load(cacheName.CONFIG)
    // 开启合作伙伴维护模式
    if (job.customerId > 0 && Number(cache.config.get('IsSpecifiedSalesBusiness')) === 1) {
      const cmp = await Company.getCompanyById(job.customerId)
      if (cmp) {
        const companyUsers = await Company.getCompanyUsers(cmp.uuid)
        if (companyUsers && companyUsers.length > 0) {
          const cargoSalesList = []
          for (const u of companyUsers) {
            if ((!u.lob || u.lob === job.lob || u.lob === 'ALL') && u.roleType === CargoOfRoleType.SALES_OF_GOODS.code) {
              const user = User.getUserByIdSync(u.userId)
              if (user) {
                cargoSalesList.push(user)
              }
            }
          }
          if (cargoSalesList.length === 0) {
            job.cargoSalesId = 0
            job.cargoSalesDepartment = 0
            job.cargoSalesOffice = 0
          }
        }
      }
    }
    // 自定义业务类型
    if (job.customJobType) {
      const item = getObjectByCache(basicCacheKeys.basic_data_CutomJobType, 'code', job.customJobType)
      if (!item) {
        job.customJobType = ''
      } else {
        // 有二级的时候，说明是二级自定义业务类型，需要清空掉
        if (item.masterUuid) {
          job.customJobType = ''
        }
      }
    }
    // 校验各个岗位人员是否失效
    const userList = getCacheListByKey(basicCacheKeys.basic_data_User)
    const userField = ['op', 'csr', 'sales', 'dc', 'planner', 'overseaOp', 'cargoSalesId',
      'userDefinedRoleId1', 'userDefinedRoleId2', 'userDefinedRoleId3', 'userDefinedRoleId4', 'userDefinedRoleId5', 'userDefinedRoleId6', 'userDefinedRoleId7',
      'siteOP', 'loadingPortOp', 'destinationPortOp', 'truckCsr']
    for (const field of userField) {
      if (job[field]) {
        const user = userList.find(p => p.userId === job[field])
        if (!user || !user.active) {
          job[field] = 0
        }
      }
    }
    return this.validateCompanyActive(job, view, viewSource)
  }

  /**
   * 校验合作伙伴是否失效
   */
  static async validateCompanyActive(job, view, viewSource = '') {
    // 校验合作伙伴是否失效
    let companyList
    const filter = {}
    filter.currentBranchId = $store.getters.currentOfficeId
    filter.all = true
    filter.active = false
    const loading = getLoading4Cxt(this)
    await getCompanyList(filter).then(res => {
      companyList = res.data.list
    }).catch(() => {
    }).finally(() => {
      loading.close()
    })

    if (!companyList) {
      return true
    }
    const notActiveCompanyList = []
    const companyMap = new Map(companyList.map(company => [company.cmpIdx, company]))
    const isZh = $store.getters.language === 'zh'

    function processCompany(obj, idKey) {
      if (obj[idKey] && obj[idKey] > 0) {
        const company = companyMap.get(obj[idKey])
        if (company && !company.active) {
          notActiveCompanyList.push(isZh ? company.chineseName : company.englishName)
          obj[idKey] = 0
        }
      }
    }

    if (job.charges && job.charges.length > 0) {
      for (const charge of job.charges) {
        // 结算对象
        processCompany(charge, 'accountId')
        // 结算代理
        processCompany(charge, 'settlementAgentId')
        // 结算对象失效，清空结算代理，联系人，开票抬头
        if (charge.accountId === 0) {
          // 结算代理
          charge.settlementAgentId = 0
          // 联系人
          charge.contactPerson = ''
          // 开票抬头
          charge.invoiceTitle = ''
        }
      }
    }
    if (job.warehouseInfo && job.warehouseInfo.length > 0 && viewSource && !['AeBooking', 'AeBookingVerify', 'AiBooking', 'AiOrder'].includes(viewSource)) {
      for (const warehouse of job.warehouseInfo) {
        // 仓库供应商
        processCompany(warehouse, 'warehouseCmp')
      }
    }
    if (job.trucking && job.trucking.length > 0 && viewSource && !['SiBooking', 'SiPrediction', 'AeBooking', 'AeBookingVerify', 'AiBooking', 'AiOrder'].includes(viewSource)) {
      for (const trucking of job.trucking) {
        // 运输公司
        processCompany(trucking, 'carryingCmp')
      }
    }

    // 委托单位
    if (!job.masterFlag) {
      processCompany(job, 'customerId')
    }
    if (viewSource && !['ReBooking', 'BookingVerify', 'IEBooking'].includes(viewSource)) {
      // 指定货代理
      processCompany(job, 'designationAgent')
    }
    if (viewSource && !['AeBooking', 'AeBookingVerify', 'AiOrder'].includes(viewSource)) {
      // 报关行
      processCompany(job, 'customsBroker')
    }
    if (viewSource && !['ReBooking', 'BookingVerify'].includes(viewSource)) {
      // 船公司/航空公司
      processCompany(job, 'carrierId')
    }
    if (viewSource && !['SiBooking', 'SiPrediction', 'AeBooking', 'AeBookingVerify', 'AiBooking', 'AiOrder', 'ReBooking', 'BookingVerify'].includes(viewSource)) {
      // 船代
      processCompany(job, 'carrierAgentId')
    }
    if (viewSource && !['AeBooking', 'AeBookingVerify', 'AiBooking', 'AiOrder', 'ReBooking', 'BookingVerify', 'IEBooking'].includes(viewSource)) {
      // 码头公司
      processCompany(job, 'terminalCompany')
    }
    if (viewSource && !['SiBooking', 'SiPrediction', 'AiBooking', 'AiOrder', 'IEBooking'].includes(viewSource)) {
      // 目的港代理
      processCompany(job, 'destinationAgent')
    }
    if (viewSource && !['AiOrder'].includes(viewSource)) {
      // 订舱代理
      processCompany(job, 'bookingAgent')
    }
    if (viewSource && !['AiOrder', 'ReBooking', 'BookingVerify', 'IEBooking'].includes(viewSource)) {
      // 换单代理
      processCompany(job, 'exChangeAgent')
    }
    if (viewSource && ['ReBooking', 'BookingVerify'].includes(viewSource)) {
      // 口岸代理
      processCompany(job, 'portAgent')
      // 发运代理
      processCompany(job, 'forwardingAgent')
    }
    let continueExec = true
    const notActiveCompanies = Array.from(new Set(notActiveCompanyList.map(JSON.stringify))).map(JSON.parse)
    if (notActiveCompanies && notActiveCompanies.length > 0) {
      const companyName = notActiveCompanies.join('、')
      await view.$confirm(view.$t('CargoMsg.Cargo_NotActiveCompanyCleared', [companyName]), view.$t('Message.Prompt'), {
        confirmButtonText: view.$t('constant.yes'),
        cancelButtonText: view.$t('constant.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        continueExec = true
      }).catch(() => {
        continueExec = false
      })
    }
    return continueExec
  }

  // 方法doNotMatchAgainSelect的消息映射
  static notMatchAgainSelectMsgMap = new Map()
  /**
   * 校验业务表字段是否有效,无效则置空
   * @param job
   * @param notMatchAgainSelect
   * @param {Object} otherParams
   * {
   *  onlySales // 是否仅针对销售
   * }
   */
  static async doNotMatchAgainSelect(job, notMatchAgainSelect, otherParams) {
    otherParams = otherParams || {}
    const delay = otherParams.delay || false
    const onlySales = otherParams.onlySales || false
    if (!job || !notMatchAgainSelect) {
      return
    }
    const validSaleList = []
    let validCrsList = null
    let validDcList = null
    await cache.load(cacheName.CONFIG)
    if (Number(cache.config.get('IsSpecifiedSalesBusiness')) === 1) {
      validCrsList = []
      validDcList = []
      const cmp = await Company.getCompanyById(job.customerId)
      if (cmp) {
        const companyUsers = await Company.getCompanyUsers(cmp.uuid)
        if (companyUsers && companyUsers.length > 0) {
          for (const u of companyUsers) {
            if (!u.lob || u.lob === job.lob || u.lob === 'ALL') {
              if (u.roleType === CargoOfRoleType.SALES_TYPE.code) {
                validSaleList.push(u.userId)
              } else if (u.roleType === CargoOfRoleType.CSR_TYPE.code) {
                validCrsList.push(u.userId)
              } else if (u.roleType === CargoOfRoleType.DOC_TYPE.code) {
                validDcList.push(u.userId)
              }
            }
          }
        }
      }
    } else {
      const cmp = await Company.getCompanyById(job.customerId)
      if (cmp) {
        const customerDetail = await new Company(cmp).getCustomerDetail()
        if (customerDetail && customerDetail.sales > 0) {
          validSaleList.push(customerDetail.sales)
        }
      }
    }
    if (!onlySales) {
      this.notMatchAgainSelectMsgMap.clear()
    }
    const callback = () => {
      const msgs = []
      for (const key of ['sales', 'csr', 'dc']) {
        if (this.notMatchAgainSelectMsgMap.has(key)) {
          msgs.push(this.notMatchAgainSelectMsgMap.get(key))
        }
      }
      this.notMatchAgainSelectMsgMap.clear()
      if (msgs.length > 0) {
        MessageBox.alert(msgs.join('<br>'), lang.t('queryJob.PositionReSelectionReminder'), {
          confirmButtonText: lang.t('Message.Confirm'),
          dangerouslyUseHTMLString: true,
          showCancelButton: false,
          closeOnClickModal: false,
          closeOnPressEscape: false
        })
      }
    }
    if (job.sales > 0) {
      this.notMatchAgainSelectMsgMap.delete('sales')
      let isMatch = false
      if (validSaleList.includes(job.sales)) {
        if (job.salesDepartment > 0) {
          const res = await getUserDeptOffices({ category: 'role', shape: 'sales', userId: job.sales })
          for (const item of res.data) {
            if (item.departmentId === job.salesDepartment) {
              isMatch = true
              break
            }
          }
        } else {
          isMatch = true
        }
      }
      if (isMatch) {
        if (validSaleList && validSaleList.length > 1) {
          this.notMatchAgainSelectMsgMap.set('sales', lang.t('queryJob.TherePositionPleaseConfirmSuitable', [lang.t('queryJob.sales')]))
        }
      } else {
        job.sales = 0
        job.salesDepartment = 0
        job.salesOffice = 0
        this.notMatchAgainSelectMsgMap.set('sales', lang.t('queryJob.TheWithBusinessStandardsSelection', [lang.t('queryJob.sales')]))
      }
    }
    if (onlySales) {
      callback()
    } else {
      if (job.csr > 0) {
        this.notMatchAgainSelectMsgMap.delete('csr')
        let isMatch = false
        if (!validCrsList || validCrsList.includes(job.csr)) {
          if (job.csrDepartment > 0) {
            const res = await getUserDeptOffices({ category: 'role', shape: 'csr', userId: job.csr })
            for (const item of res.data) {
              if (item.departmentId === job.csrDepartment) {
                isMatch = true
                break
              }
            }
          } else {
            isMatch = true
          }
        }
        if (isMatch) {
          if (validCrsList && validCrsList.length > 1) {
            this.notMatchAgainSelectMsgMap.set('csr', lang.t('queryJob.TherePositionPleaseConfirmSuitable', [lang.t('queryJob.CustomerService')]))
          }
        } else {
          job.csr = 0
          job.csrDepartment = 0
          job.csrOffice = 0
          this.notMatchAgainSelectMsgMap.set('csr', lang.t('queryJob.TheWithBusinessStandardsSelection', [lang.t('queryJob.CustomerService')]))
        }
      }
      if (job.dc > 0) {
        this.notMatchAgainSelectMsgMap.delete('dc')
        let isMatch = false
        if (!validDcList || validDcList.includes(job.dc)) {
          if (job.dcDepartment > 0) {
            const res = await getUserDeptOffices({ category: 'role', shape: 'doc', userId: job.dc })
            for (const item of res.data) {
              if (item.departmentId === job.dcDepartment) {
                isMatch = true
                break
              }
            }
          } else {
            isMatch = true
          }
        }
        if (isMatch) {
          if (validDcList && validDcList.length > 1) {
            this.notMatchAgainSelectMsgMap.set('dc', lang.t('queryJob.TherePositionPleaseConfirmSuitable', [lang.t('queryJob.Documents')]))
          }
        } else {
          job.dc = 0
          job.dcDepartment = 0
          job.dcOffice = 0
          this.notMatchAgainSelectMsgMap.set('dc', lang.t('queryJob.TheWithBusinessStandardsSelection', [lang.t('queryJob.Documents')]))
        }
      }
      if (delay) {
        setTimeout(callback, 5000)
      } else {
        callback()
      }
    }
  }

  // 获取客户属性信控提示信息
  static async getCustomerCreditTip(customerId, job) {
    if (customerId > 0) {
      const res = await CreditInfo.checkCreditInfo(customerId, job)
      if (res.data && res.data.length > 0) {
        const credit = res.data[0]
        if (credit.creditDateLimited === 0 && credit.creditDateType <= 0) {
          return lang.t('Message.ByTicket')
        } else {
          let settlementMethodLabel = ColumnUtils.creditDateTypeLabelFunc(credit.creditDateType)
          if (credit.creditDateType > 0) {
            settlementMethodLabel += `【${credit.creditDateType}】`
          }
          const dateTypeLabel = CommonState.getNameByCode(ContractConstants.DATETYPE_TYPE, credit.remarks)
          const accountPeriodLabel = ColumnUtils.AccountPeriodLabelFunc(credit)
          return `${settlementMethodLabel} ${lang.t('CargoMsg.Cargo_AccountPeriod')}：${dateTypeLabel}+${accountPeriodLabel} ${lang.t('CargoMsg.Cargo_Limit')}：${credit.credit}${credit.currency}`
        }
      }
    }
    return ''
  }

  static placeholderSFT(isShow, i) {
    if (isShow) {
      if (i === 1) {
        return 'Name'
      } else if (i === 3) {
        return 'Address'
      }
    }
    return ' '
  }

  /**
   * 按业务指定对应的揽货销售人员
   * @param view
   * @param job
   * @param isSpecifiedSalesBusiness
   * @param clearCargoSales
   * @returns
   */
  static async loadCompanyCargoSales(view, job, isSpecifiedSalesBusiness = false, clearCargoSales = false) {
    const cargoSalesList = []
    if (job.customerId > 0 && isSpecifiedSalesBusiness) {
      const cmp = await Company.getCompanyById(job.customerId)
      if (cmp) {
        const companyUsers = await Company.getCompanyUsers(cmp.uuid)
        if (companyUsers && companyUsers.length > 0) {
          for (const u of companyUsers) {
            if ((!u.lob || u.lob === job.lob || u.lob === 'ALL') && u.roleType === CargoOfRoleType.SALES_OF_GOODS.code) {
              const user = User.getUserByIdSync(u.userId)
              if (user) {
                cargoSalesList.push(user)
              }
            }
          }
        }
      }
      // CARGO-44988 复制业务，揽货销售栏位要根据委托单位过滤一遍
      if (clearCargoSales && cargoSalesList.length === 0) {
        job.cargoSalesId = 0
        job.cargoSalesDepartment = 0
        job.cargoSalesOffice = 0
      }
    }
    view.cargoSalesList = cargoSalesList.length > 0 ? cargoSalesList : null
  }

  static financeColor(data) {
    // verifyStateReceivable 是后端返回的中文
    if (!data) {
      return {}
    }
    const uuid = data.uuid || data.key
    if (!uuid) {
      return {}
    }
    // 颜色显示优先级按一下显示：1应收全部核销、2应收部分核销、3应收全部开票、4应收部分开票、6未录应收、5应收未开票。
    const verifyStateReceivable = data.verifyStateReceivable || ''
    const receivableInvoiceState = data.receivableInvoiceState
    const financeColorSettings = $store.state.settings.financeColorSettings
    if (!financeColorSettings) {
      return {}
    }
    let key = ''
    if (SystemConstants.ALL_VERIFICATION.chineseName === verifyStateReceivable) {
      key = '1'
    } else if (SystemConstants.PARTS_VERIFICATION.chineseName === verifyStateReceivable) {
      key = '2'
    } else if (BillingConstants.INVOICE_STATE_FULL.code === receivableInvoiceState) {
      key = '6'
    } else if (BillingConstants.INVOICE_STATE_HALF.code === receivableInvoiceState) {
      key = '5'
    } else if (SystemConstants.NO_RECIVABLE.chineseName === verifyStateReceivable) {
      key = '3'
    } else if (BillingConstants.INVOICE_STATE_NOT_INVOICE.code === receivableInvoiceState) {
      key = '4'
    }
    if (key) {
      const colorSetting = financeColorSettings.find(stateColor => stateColor.colorKey === key)
      return colorSetting ? { 'background': colorSetting.colorValue } : {}
    }
    return {}
  }
  /**
   * 校验mbl是否可用
   * 需要在主单号管理中存在且未使用
   * @param job
   * @returns {Promise<void>}
   */
  static async checkMblAvailable(job) {
    if (job.trustFromJob || job.relatedJob || !job.mbl) {
      return ''
    }
    const data = {
      mblNo: job.mbl,
      carrierId: job.carrierId,
      jobUuid: job.uuid,
      currentBranchId: $store.getters.currentOfficeId
    }
    return checkMblNoDataFunc(data)
  }

  static async checkJobHasMblData(job) {
    if (!job.mbl || !job.uuid) {
      return ''
    }
    const data = {
      mblNo: job.mbl,
      carrierId: job.carrierId,
      jobUuid: job.uuid,
      branchId: $store.getters.currentOfficeId
    }
    return checkJobHasMblFunc(data)
  }
  static async calculateMblNo(job) {
    if (!job.mbl || !job.uuid) {
      return ''
    }
    try {
      let maxNo = Number(job.mbl.slice(-2)) - 1
      for (const data of job.seaCargoDoc) {
        if (data.docType === MBL2) {
          const mblNow = data.mblNbr2.slice(-2)
          if (Number(mblNow) > Number(maxNo)) {
            maxNo = mblNow
          }
        }
      }
      const mblStar = job.mbl.slice(0, -2)
      return mblStar + String(Number(maxNo) + 1).padStart(2, '0')
    } catch (error) {
      console.log('error', error)
    }
    return ''
  }
  /**
   * 根据UUID以及所属分公司，应用分公司获取对应的航空公司
   * @param mblPrefix
   * @param officeId
   * @returns {null|*}
   */
  static getAirLineCompanyByMblPrefixAndOfficeId(mblPrefix = '', officeId = 0) {
    if (!officeId || !mblPrefix) return null
    let airlines = getFilterCacheList(basicCacheKeys.basic_data_Airline, (item) => {
      return item.mawbprefix === mblPrefix
    })
    let companyUuid = null
    airlines = sortByMultiField(airlines, ['dateCreated'], true)
    if (airlines && airlines.length > 0) {
      companyUuid = airlines[0].companyUuid
    }
    if (!companyUuid) return null
    const list = getFilterCacheList(basicCacheKeys.basic_data_Company, (item) => {
      return item.active && item.airCmp && item.uuid === companyUuid && (item.branchId === 1 || item.branchId === officeId ||
          (item.multipleBranchId && item.multipleBranchId.split(',').includes(String(officeId))))
    })
    return list && list.length > 0 ? list[0] : null
  }
  // 打开对单链接 0：客户地址 1：指定货地址
  static openDocLink(cargoDocUuid, type) {
    if (!cargoDocUuid) return
    xhqGetCfmAddress({ cargoDocUuid }).then(res => {
      if (type === 0) {
        if (!res.data || !res.data.url) {
          Message.warning(lang.t('SeaExport.LinkIsNull'))
          return
        }
        window.open(res.data.url)
      } else if (type === 1) {
        if (!res.data || !res.data.overseasLink) {
          Message.warning(lang.t('SeaExport.LinkIsNull'))
          return
        }
        window.open(res.data.overseasLink)
      }
    })
  }
  /**
   * 根据船公司 船名 带出edicode`
   * @param job
   */
  static async queryCarrierCodeHandler(job) {
    job.carrierCode = ''
    if (job.carrierId && job.carrierId > 0 && job.vessel) {
      await queryCarrierCodeFunc({ anyInteger: job.carrierId, anyStr: job.vessel }).then(res => {
        if (res.data) {
          job.carrierCode = res.data
        }
      })
    }
  }

  /**
   * 查询船公司约号
   * @param job
   * @returns {Promise<void>}
   */
  static async queryContractNumber() {
    const res = await getShippingContract({ weatherEnabled: true })
    return res.data.list
  }

  /**
   * 根据业务载入销售
   * @param job
   * @param ignoreSalesOfficeCheck
   * @returns
   */
  static async loadSalesByJob(job, ignoreSalesOfficeCheck = false) {
    await cache.load(cacheName.CONFIG)
    const salesOfficeCheck = ignoreSalesOfficeCheck ? false : Number(cache.config.get('SalesOfficeCheck')) === 1
    const isSpecifiedSalesBusiness = Number(cache.config.get('IsSpecifiedSalesBusiness')) === 1
    const branchOfficeCheck = Number(cache.config.get('departmentSalesOfficeCheck')) === 1
    if (job.designationAgent > 0) {
      const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', job.designationAgent)
      if (company) {
        const overseaAgentDetail = await new Company(company).getOverseaAgentDetail()
        const data = { value: 0 }
        if (overseaAgentDetail) {
          // 添加指定货代理等级
          const overseaAgentGrade = OverseaAgentGrade.getOverseaAgentGradeByCode(overseaAgentDetail.grade)
          if (overseaAgentGrade) {
            job.agentLevel = overseaAgentGrade.chineseName
          }
          const user = getObjectByCache(TYPE_NAMES.basic_data_User, 'userId', overseaAgentDetail.owner)
          if (user) {
            if (salesOfficeCheck) {
              if (user.active) {
                Object.assign(data, user)
                data.value = overseaAgentDetail.owner
              }
            } else {
              Object.assign(data, user)
              data.value = overseaAgentDetail.owner
            }
          }
        }
        await this.salesChangeHandler(job, data, branchOfficeCheck)
      }
    } else {
      if (isSpecifiedSalesBusiness) {
        const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', job.customerId)
        if (company) {
          const companyUsers = await Company.getCompanyUsers(company.uuid)
          // 销售
          const salesList = []
          let salesDefaultId = 0
          // 如果开启分公司过滤参数，查出来所有分公司
          let officeSaleList
          if (salesOfficeCheck) {
            officeSaleList = await User.getUsersByPrivilegeDetail('role', 'sales', '', job.opOffice)
          }
          officeSaleList = officeSaleList || []
          if (companyUsers && companyUsers.length > 0) {
            for (const u of companyUsers) {
              const userValid = job.fba ? u.lob === SystemConstants.FBA_SE.code : u.lob === job.lob
              if (!u.lob || userValid || u.lob === 'ALL') {
                const user = getObjectByCache(TYPE_NAMES.basic_data_User, 'userId', u.userId)
                if (user && user.active) {
                  if (u.roleType === CargoOfRoleType.SALES_TYPE.code) { // 销售
                    if (salesOfficeCheck) {
                      for (const obj of officeSaleList) {
                        if (user.userId === obj.userId) {
                          if (u.defaultUser) {
                            salesDefaultId = u.userId
                          }
                          salesList.push(user)
                        }
                      }
                    } else {
                      if (u.defaultUser) {
                        salesDefaultId = u.userId
                      }
                      salesList.push(user)
                    }
                  }
                }
              }
            }
          }
          // 销售
          if (salesList.length > 0) {
            if (salesDefaultId > 0) {
              job.sales = salesDefaultId
              const user = getObjectByCache(TYPE_NAMES.basic_data_User, 'userId', salesDefaultId)
              await this.salesChangeHandler(job, { ...user, value: user.userId }, branchOfficeCheck)
            } else {
              await this.salesChangeHandler(job, { ...salesList[0], value: salesList[0].userId }, branchOfficeCheck)
            }
          }
        }
      }
    }
  }

  /**
   * 当选择销售人员的时候自动关联该销售所在分公司
   * @param job
   * @param data
   * @param branchOfficeCheck
   */
  static async salesChangeHandler(job, data, branchOfficeCheck) {
    job.sales = data.value
    job.salesOffice = 0
    job.salesDepartment = 0
    if (data.value) {
      if (data.defaultOfficeId) { // 用户设置了默认公司和部门就用默认的
        job.salesOffice = data.defaultOfficeId
        job.salesDepartment = data.defaultDepId
      } else {
        const offices = await User.getUserDepartmentOffices('role', 'sales', data.value)
        if (offices.length > 1) {
          for (const item of offices) {
            if (branchOfficeCheck || (!branchOfficeCheck && item.officeId === job.opOffice)) {
              job.salesOffice = item.officeId
              job.salesDepartment = item.departmentId
              break
            }
          }
        } else {
          const user = new User(data)
          const department = await user.getDefaultDepartment('role', 'sales')
          job.salesDepartment = department ? department.departmentId : 0
          const office = department ? await Office.getOfficeByUuid(department.officeUuid) : null
          if (office) {
            job.salesOffice = office.officeId
          }
        }
      }
    }
  }
  static setSecondaryCustomJobTypeList(customJobType, lob) {
    if (customJobType) {
      const customerJobTypeList = getCacheListByKey(basicCacheKeys.basic_data_CutomJobType)
      const customerJobs = customerJobTypeList.filter(p => customJobType === p.code && p.active && p.grade === 0 && p.type === lob)
      if (customerJobs.length > 0) {
        const customerJobKey = customerJobs[0].uuid
        return customerJobTypeList.filter(p => customerJobKey === p.masterUuid && p.active && p.grade === 1 && p.type === lob)
      }
    }
    return []
  }

  static setCustomJobTypeList(lob, containerLoadType, isfba) {
    const customerJobTypeList = getCacheListByKey(basicCacheKeys.basic_data_CutomJobType)
    if (customerJobTypeList.length > 0) {
      const expectedFba = isfba === true || isfba === 1 || isfba === '1'
      return customerJobTypeList.filter(p => {
        const itemFba = p.fba === true || p.fba === 1 || p.fba === '1'
        const itemFbaMatched = expectedFba ? itemFba : !itemFba
        return p.active &&
          p.grade === 0 &&
          p.type === lob &&
          (p.containerLoadType === String(containerLoadType) || !p.containerLoadType) &&
          itemFbaMatched
      })
    }
    return []
  }

  /**
   * 匹配预设配置并保存
   * @param job
   * @param excludeFileds 需排除修改的字段
   * @returns
   */
  static async matchPresetConfigAndSave(job, excludeFileds) {
    if (!job) {
      return
    }
    // 禁止修改的job属性
    const disabledJobAttrs = {}
    if (excludeFileds && excludeFileds.length > 0) {
      for (const excludeFiled of excludeFileds) {
        switch (excludeFiled) {
          case 'csr':
            disabledJobAttrs.csr = job.csr
            disabledJobAttrs.csrDepartment = job.csrDepartment
            disabledJobAttrs.csrOffice = job.csrOffice
            break
          case 'op':
            disabledJobAttrs.op = job.op
            disabledJobAttrs.opDepartment = job.opDepartment
            break
        }
      }
    }
    const modifiedData = {}
    let warehouseCallback = null
    if (job.lob === 'SE' || job.lob === 'SI' || (job.lob === 'AE' && !job.masterFlag) || job.lob === 'RE' || job.lob === 'RI') {
      warehouseCallback = warehouseId => this.warehouseCmpChangeHandler(job, { value: warehouseId }, modifiedData)
    }
    const config = await getConfig(job.opOffice, false)
    const matchResult1 = await this.matchUserPortConfig(null, job)
    const matchResult2 = await this.matchRegionWarehouseMappingConfig(job, warehouseCallback, false, null, modifiedData, false, config)
    // 还原禁止修改的job属性
    Object.assign(job, disabledJobAttrs)
    if (matchResult1 || matchResult2) {
      const form = {}
      for (const key in job) {
        if (typeof job[key] !== 'object') {
          form[key] = job[key]
        }
      }
      const body = { job: form, ...modifiedData }
      switch (job.lob) {
        case 'SE':
          await saveSeaBookingSpaceSE(body)
          break
        case 'SI':
          await saveSeaBookingSpaceSI(body)
          break
        case 'AE':
          await saveAeBookingSpace(body)
          break
        case 'RE':
        case 'RI':
          await saveRailwayExport(body)
          break
      }
    }
  }

  /**
   * 仓库供应商改变处理
   * @param job
   * @param data
   * @param modifiedData
   */
  static async warehouseCmpChangeHandler(job, data, modifiedData) {
    job.warehouseCmp = data.value || 0
    job.warehouseRecord = job.warehouseCmp
    if (job.warehouseInfo.length === 0) {
      const newData = new WarehouseInfo().fillDefaultValue().getData()
      newData.jobUuid = job.uuid
      job.warehouseInfo.push(newData)
    }
    // 通过此方法加载warehouseInfo的联系电话地址等
    await this.getWarehouseInfo(job)
    const warehouse = job.warehouseInfo[0]
    warehouse.warehouseCmp = job.warehouseCmp
    if (warehouse.warehouseCmp && warehouse.warehouseCmp > 0) {
      warehouse.deleted = false
    }
    job.warehouseName = warehouse.warehouseName
    modifiedData.warehouseInfo = modifiedData.warehouseInfo || []
    if (!modifiedData.warehouseInfo.includes(warehouse)) {
      modifiedData.warehouseInfo.push(warehouse)
    }
  }

  /**
   * 默认创建仓库信息
   * @param job
   */
  static async getWarehouseInfo(job) {
    await new Job(job).getWarehouseInfo()
    let warehouseInfo = null
    if (job.warehouseCmp && job.warehouseCmp > 0) {
      if (!job.warehouseInfo || job.warehouseInfo.length === 0) {
        warehouseInfo = new WarehouseInfo().fillDefaultValue().getData()
      } else {
        warehouseInfo = job.warehouseInfo[0]
      }
      if (warehouseInfo && job.warehouseCmp !== warehouseInfo.warehouseCmp) {
        const config = await getConfig(job.opOffice, false)
        const fileCutoffDay = Number(config.get.get('SEFileCutoffDetaultDay'))
        const ctrlEstArrivalDate = Number(config.get.get('CtrlEstArrivalDate')) === 1
        if (fileCutoffDay > 0 && job.etd && ctrlEstArrivalDate) {
          warehouseInfo.arriveDate = DateUtils.getFourDaysAgoWithoutHoliday(job.etd, fileCutoffDay)
          warehouseInfo.arriveDate.setHours(16, 0)
        }
        warehouseInfo.warehouseCmp = job.warehouseCmp
        warehouseInfo.jobUuid = job.uuid
        warehouseInfo.contactData = false
        const company = await Company.getCompanyById(job.warehouseCmp)
        if (company) {
          company.warehouseDetail = ''
          await new Company(company).getWarehouseDetail()
          await this.loadWarehouseDetailHandler(warehouseInfo, company)
        }
      }
    } else { // 如果手动清空仓储，则打断仓储与Job的关联关系
      if (job.warehouseInfo && job.warehouseInfo.length > 0) {
        for (const warehouseInfo of job.warehouseInfo) {
          warehouseInfo.deleted = true
        }
      }
    }
  }

  /**
   * 加载仓库详情处理
   * @param warehouseInfo
   * @param company
   */
  static async loadWarehouseDetailHandler(warehouseInfo, company) {
    if (company) {
      const warehouseDetail = Company.defaultWarehouse(company)
      if (warehouseDetail) {
        if (warehouseDetail['warehouseAddress']) {
          warehouseInfo.warehouseAddress = warehouseDetail['warehouseAddress']
        } else {
          warehouseInfo.warehouseAddress = company.address
        }
        warehouseInfo.warehouseContact = warehouseDetail['warehouseContact']
        warehouseInfo.warehouseContactTel = warehouseDetail['warehouseContactTel']
        warehouseInfo.warehouseName = warehouseDetail['warehouseName']
        warehouseInfo.mapFile = warehouseDetail['mapFile']
        warehouseInfo.remarks = warehouseDetail['remarks']
        if (!warehouseInfo.warehouseContact && !warehouseInfo.warehouseContactTel) {
          await this.loadContactsFunc(warehouseInfo, company)
        }
      } else {
        warehouseInfo.warehouseContact = ''
        warehouseInfo.warehouseContactTel = ''
        warehouseInfo.warehouseName = ''
        warehouseInfo.mapFile = ''
        warehouseInfo.remarks = ''
        await this.loadContactsFunc(warehouseInfo, company)
        warehouseInfo.warehouseAddress = company.address
      }
    }
  }

  /**
   * 加载仓库联系信息
   * @param warehouseInfo
   * @param company
   */
  static async loadContactsFunc(warehouseInfo, company) {
    if (!warehouseInfo.warehouseContact && !warehouseInfo.warehouseContactTel) {
      warehouseInfo.contactData = true
      await new Company(company).getContacts()
      const contacts = company.contacts
      if (contacts && contacts.length > 0) {
        let contact = null
        for (const ct of contacts) {
          if (ct.defaultContact) {
            contact = ct
            break
          }
        }
        if (contact) {
          warehouseInfo.warehouseContact = contact['contactPerson']
          warehouseInfo.warehouseContactTel = contact['telephone']
        } else {
          warehouseInfo.warehouseContact = ''
          warehouseInfo.warehouseContactTel = ''
        }
        warehouseInfo.warehouseName = ''
      }
    }
  }
  static async checkBillTip(form, func) {
    await cache.load(cacheName.CONFIG)
    if ((form.cfmState === CARGODOC_CFM_STATE_YQR.code ||
        form.cfmState === CARGODOC_CFM_STATE_SHIPPER_CONFIRMED.code ||
        form.cfmState === CARGODOC_CFM_STATE_CMPFEED.code) && String(cache.config.get('ToExoSystem')) === 'TP') {
      CheckCargoDocHistory.queryDocHistory(form.uuid).then(data => {
        let checkTip = false
        for (const d of data) {
          if (d.dataSources === 'B2B') {
            checkTip = true
            break
          }
        }
        if (checkTip) {
          MessageBox.confirm(lang.t('Message.InvitationListTip'), lang.t('CargoMsg.Cargo_ConfirmOrNot'), {
            confirmButtonText: lang.t('SeaExport.Confirm'),
            cancelButtonText: lang.t('common.btn.cancel'),
            type: 'warning'
          }).then(() => {
            // 将提单状态还原至待确认
            func()
          })
        } else {
          func()
        }
      })
    } else {
      func()
    }
  }

  // 客服不能编辑业务字段
  static editJobFields(flag = false) {
    if (!flag) {
      return true
    }
    if (checkPermission(['role_op'])) {
      return true
    }
    return !checkPermission(['role_csr'])
  }

  /**
   * 比较并且合并业务数据
   * @param oldData 旧版本的数据
   * @param editOldData 正在编辑的旧版本的数据
   * @param newData 最新版本的数据
   */
  static compareAndMergeJobData(oldData, editOldData, newData) {
    const mergeResult = lodash.cloneDeep(newData)
    for (const key in editOldData) {
      // 需要排除的字段（存在循环引用）
      let excludeFiled = ''
      if (key === 'containers') {
        excludeFiled = 'container'
      } else if (key === 'containerUsages') {
        excludeFiled = 'containerUsage'
      }
      // 全部为数组
      if (editOldData[key] instanceof Array && oldData[key] instanceof Array && mergeResult[key] instanceof Array) {
        if (this.isValueArray(editOldData[key])) {
          if (editOldData.length !== oldData[key].length) {
            mergeResult[key] = editOldData[key]
          } else {
            for (let i = 0; i < editOldData.length; ++i) {
              if (editOldData[i] !== oldData[i]) {
                mergeResult[key] = editOldData[key]
                break
              }
            }
          }
        } else {
          this.compareAndMergeEntityData(oldData[key], editOldData[key], mergeResult[key], excludeFiled)
        }
        continue
      }
      // 全部为对象（非数组）
      if (editOldData[key] instanceof Object && !(editOldData[key] instanceof Array) && oldData[key] instanceof Object && !(oldData[key] instanceof Array) &&
        mergeResult[key] instanceof Object && !(mergeResult[key] instanceof Array)) {
        this.compareAndMergeEntityData(oldData[key], editOldData[key], mergeResult[key], excludeFiled)
        continue
      }
      if (editOldData[key] !== oldData[key]) {
        mergeResult[key] = editOldData[key]
      }
    }
    return mergeResult
  }

  /**
   * 是否为元素为值类型的数组
   * @param arr
   */
  static isValueArray(arr) {
    for (const item of arr) {
      if (item instanceof Object) {
        return false
      }
    }
    return true
  }

  /**
   * 比较并且合并实体数据
   * @param oldData 旧版本的数据
   * @param editOldData 正在编辑的旧版本的数据
   * @param mergeResult 合并结果
   * @param excludeFiled 需要排除的字段
   */
  static compareAndMergeEntityData(oldData, editOldData, mergeResult, excludeFiled) {
    if (editOldData instanceof Array) {
      for (const editOldItem of editOldData) {
        if (!editOldItem.uuid) {
          mergeResult.push(editOldItem)
          continue
        }
        const oldItem = oldData.find(p => p.uuid === editOldItem.uuid)
        const mergeItem = mergeResult.find(p => p.uuid === editOldItem.uuid)
        if (oldItem && mergeItem) {
          this.compareAndMergeEntityData(oldItem, editOldItem, mergeItem, excludeFiled)
        } else {
          mergeResult.push(editOldItem)
        }
      }
    } else {
      for (const key in editOldData) {
        if (key === excludeFiled) {
          continue
        }
        // 全部为数组
        if (editOldData[key] instanceof Array && oldData[key] instanceof Array && mergeResult[key] instanceof Array) {
          if (this.isValueArray(editOldData[key])) {
            if (editOldData.length !== oldData[key].length) {
              mergeResult[key] = editOldData[key]
            } else {
              for (let i = 0; i < editOldData.length; ++i) {
                if (editOldData[i] !== oldData[i]) {
                  mergeResult[key] = editOldData[key]
                  break
                }
              }
            }
          } else {
            this.compareAndMergeEntityData(oldData[key], editOldData[key], mergeResult[key], excludeFiled)
          }
          continue
        }
        // 全部为对象（非数组）
        if (editOldData[key] instanceof Object && !(editOldData[key] instanceof Array) && oldData[key] instanceof Object && !(oldData[key] instanceof Array) &&
          mergeResult[key] instanceof Object && !(mergeResult[key] instanceof Array)) {
          this.compareAndMergeEntityData(oldData[key], editOldData[key], mergeResult[key], excludeFiled)
          continue
        }
        if (editOldData[key] !== oldData[key]) {
          mergeResult[key] = editOldData[key]
        }
      }
    }
  }

  /**
   * 业务提交时校验是否预付款余额不足
   */
  static async checkBalanceBeforeSubmitHandler(jobKeys, failUuids = [], multiJob = false) {
    let continueExec = true
    if (!jobKeys) return continueExec
    await cache.load(cacheName.CONFIG)
    if (!(String(cache.config.get('ToExoSystem')) === 'zy' && Number(cache.config.get('isZhongyouAdvancePaymentOpen')) === 1)) { return continueExec }
    await checkBalanceBeforeSubmit(jobKeys).then(async res => {
      if (res.data && res.data.length > 0) {
        continueExec = false
        let promptText = ''
        for (const row of res.data) {
          if (failUuids.indexOf(row.jobUuid) === -1) failUuids.push(row.jobUuid)
          if (multiJob) {
            promptText += lang.t('AdvancePayment.CheckBalanceDetail', [row.jobNo, row.customerCode, row.customerName, NumberUtils.formatNumber(row.balance, 2), NumberUtils.formatNumber(row.submittingAmount, 2), NumberUtils.formatNumber(row.amount, 2)]) + '<br>'
          } else {
            promptText += lang.t('AdvancePayment.CheckBalanceDetail2', [row.customerCode, row.customerName, NumberUtils.formatNumber(row.balance, 2), NumberUtils.formatNumber(row.submittingAmount, 2), NumberUtils.formatNumber(row.amount, 2)]) + '<br>'
          }
        }
        console.log('checkFailUuids', failUuids)
        await MessageBox.confirm(promptText, lang.t('AdvancePayment.CheckBalanceTitle'), {
          confirmButtonText: multiJob && jobKeys.length > failUuids.length ? lang.t('CargoMsg.Cargo_Next') : lang.t('CargoMsg.Cargo_Cancel'),
          cancelButtonText: lang.t('CargoMsg.Cargo_Cancel'),
          dangerouslyUseHTMLString: true,
          customClass: multiJob ? 'checkBalanceConfirmWidth' : 'checkBalanceConfirmWidth2',
          showCancelButton: !!(multiJob && jobKeys.length > failUuids.length),
          type: 'warning'
        }).then(async() => {
          continueExec = true
        })
      }
    }).catch((data) => {
      //
    })
    return continueExec
  }

  /**
   * 中邮委托单位是否黑名单，提示“XXX已加入黑名单”
   */
  static async checkBlacklistByCustomerId(customerId, showWarning = true) {
    let flag = false
    if (!customerId) return flag
    await cache.load(cacheName.CONFIG)
    if (!(String(cache.config.get('ToExoSystem')) === 'zy' && Number(cache.config.get('isZhongyouAdvancePaymentOpen')) === 1)) { return flag }
    await CreditInfo.checkCreditInfo(customerId).then(res => {
      if (!res.data || res.data.length <= 0) return flag
      const creditInfo = res.data[0]
      console.log('checkBlacklist', creditInfo)
      if (creditInfo.blacklist) {
        flag = true
        if (showWarning) {
          const comp = getObjectByCache(basicCacheKeys.basic_data_Company, 'uuid', creditInfo.companyUuid)
          if (comp) {
            Message.warning(lang.t('AdvancePayment.AddedToBlacklist', [(StrUtils.isEmpty(comp.chineseName) ? comp.englishName : comp.chineseName)]))
          }
        }
      }
    })
    return flag
  }

  /**
   * 校验 业务委托单位 是否一致
   */
  static checkJobCustomerIdIfSame(arSettlementUnitOptional, chargeType, rows, view) {
    if (arSettlementUnitOptional &&
        [SystemConstants.CHARGE_TYPE_RADIO_COST_PAY.code, SystemConstants.CHARGE_TYPE_RADIO_COST.code].indexOf(chargeType) > -1) {
      const row = rows.find(p => p.customerId !== rows[0].customerId)
      if (row) {
        view.$message.warning(view.$t('CargoMsg.Cargo_BatchOperationSameEntrustedUnit'))
        return false
      }
    }
    return true
  }

  /**
   * 欧坚校验风险客户
   * @param customerId
   * @param isCreated
   * @returns {Promise<void>}
   */
  static async checkRiskyCustomersByByCustomerId(customerId, isCreated) {
    if (!customerId) return
    await cache.load(cacheName.CONFIG)
    if (parseInt(cache.config.get('oujianPartner')) === 1) {
      const cmp = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', customerId)
      if (cmp && cmp.ifRisk) {
        Message.warning(lang.t('Message.ThisCustomerRiskyCustomerOperateOrdersWithCaution', [isCreated ? lang.t('CargoMsg.Cargo_Create') : lang.t('CargoMsg.Cargo_Operation')]))
      }
    }
  }

  // 创建一个函数来处理数据映射和 AdvancedSearchField 对象的初始化
  static createSearchField(data, itemName, itemLabel) {
    const searchField = new AdvancedSearchField()
    searchField.action = AdvancedSearchField.UPDATE_ACTION
    searchField.itemType = 'select'
    searchField.multiple = 1
    searchField.itemCondition = []
    searchField.defaultConditionVal = ''
    searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
    searchField.itemName = itemName
    searchField.itemLabel = itemLabel
    searchField.itemValue = []
    searchField.defaultSelected = 0
    searchField.selected = 0
    searchField.dropdownDataRef = ''
    searchField.lock = false
    searchField.defaultValue = []
    searchField.dataProvider = data

    return searchField.formatObj2Json()
  }

  /**
   * 获取业务的结算类型
   * @param job
   * @returns {Promise<string>}
   */
  static async getSettlementTypeByJobInformation(job, field = 'customerId') {
    let returnMsg = ''
    let cmpIdx = 0
    if (field) {
      cmpIdx = Number(job[field])
    }
    if (cmpIdx) {
      const cmp = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', cmpIdx)
      if (cmp) {
        returnMsg = await getCreditInfoByJobUuid({ companyUuid: cmp.uuid, jobUuid: job.uuid }).then(res => {
          const creditInfo = res.data
          if (creditInfo) {
            const str = creditInfo.creditDateLimited === 0 && [-1, -2, -3, -4].includes(creditInfo.creditDateType) ? lang.t('Message.ByTicket') : lang.t('Message.Monthly')
            return '  [' + str + ']'
          }
          return ''
        })
      }
    }
    return returnMsg
  }
  /**
   * 获取业务的结算类型
   */
  static async getBillingTypeByCompany(cmp) {
    const billingType = await new Company(cmp).getCustomerDetail().then(data => {
      if (data) {
        const str1 = lang.t('Message.BillingType') + '[' + lang.t('Message.ByTicket') + ']'
        const str2 = lang.t('Message.BillingType') + '[' + lang.t('Message.Monthly') + ']'
        return data.invoiceMode === 0 ? str1 : str2
      }
      return ''
    })
    return billingType
  }
  /**
   * 配置查询条件子公司数据
   * @param defaultSearchItems
   * @param customSearchItems
   */
  static configSearchItemsChildOffice(defaultSearchItems, customSearchItems) {
    const isHQ = $store.getters.currentOfficeId === 1
    const officeIds = this.getChildOfficeIds($store.getters.currentOfficeUuid)
    const officeIdTxts = officeIds.length > 0 ? officeIds.join(',') : ''
    const customItemNameSet = new Set()
    for (const item of customSearchItems) {
      switch (item.itemType) {
        case 'allOfficeUser':
          item.subType = item.subType || {}
          item.subType.officeId = ''
          item.subType.officeIds = isHQ ? '' : officeIdTxts
          break
        case 'user':
        case 'userSea':
          item.subType = item.subType || {}
          item.subType.officeId = ''
          item.subType.officeIds = officeIdTxts
          if (item.fieldType === 'FIELD_SALES_OF_GOODS' || item.itemName === 'job.CARGO_SALES_ID') {
            item.subType.officeIds = ''
          }
          break
        case 'department':
        case 'department5':
          item.itemType = 'department4'
          break
        case 'office':
          item.subType = item.subType || {}
          item.subType.includeChildOffice = true
          break
        case 'company':
          item.subType = item.subType || {}
          item.subType.officeIds = officeIds
          break
      }
      customItemNameSet.add(item.itemName)
    }
    for (const item of defaultSearchItems) {
      if (customItemNameSet.has(item.itemName)) {
        continue
      }
      const newItem = lodash.cloneDeep(item)
      newItem.action = AdvancedSearchField.UPDATE_ACTION
      switch (newItem.itemType) {
        case 'allOfficeUser':
          newItem.subType = newItem.subType || {}
          newItem.subType.officeId = ''
          newItem.subType.officeIds = isHQ ? '' : officeIdTxts
          customSearchItems.push(newItem)
          break
        case 'user':
        case 'userSea':
          newItem.subType = newItem.subType || {}
          newItem.subType.officeId = ''
          newItem.subType.officeIds = officeIdTxts
          if (newItem.fieldType === 'FIELD_SALES_OF_GOODS' || newItem.itemName === 'job.CARGO_SALES_ID') {
            newItem.subType.officeIds = ''
          }
          customSearchItems.push(newItem)
          break
        case 'department':
        case 'department2':
        case 'department5':
          newItem.itemType = 'department4'
          customSearchItems.push(newItem)
          break
        case 'office':
          newItem.subType = newItem.subType || {}
          newItem.subType.includeChildOffice = true
          customSearchItems.push(newItem)
          break
        case 'company':
          newItem.subType = newItem.subType || {}
          newItem.subType.officeIds = officeIds
          customSearchItems.push(newItem)
          break
      }
    }
  }

  /**
   * 获取子公司（包含当前公司）
   * @param officeUuid
   * @returns
   */
  static getChildOfficeIds(officeUuid) {
    const allOffice = [...getCacheListByKey(basicCacheKeys.basic_data_Office_All)]
    allOffice.sort((a, b) => a.level - b.level)
    const keySet = new Set([officeUuid])
    const officeIds = []
    for (const office of allOffice) {
      if (keySet.has(office.uuid)) {
        officeIds.push(office.officeId)
      } else if (office.parentBranchUuid && keySet.has(office.parentBranchUuid)) {
        keySet.add(office.uuid)
        officeIds.push(office.officeId)
      }
    }
    return officeIds
  }

  /**
   * 获取子公司（包含当前公司）
   * @param officeUuid
   * @returns
   */
  static getChildOfficeUUIDs(officeUuid) {
    const allOffice = [...getCacheListByKey(basicCacheKeys.basic_data_Office_All)]
    allOffice.sort((a, b) => a.level - b.level)
    const officeUuids = []
    officeUuids.push(officeUuid)
    for (const office of allOffice) {
      if (office.parentBranchUuid && office.parentBranchUuid === officeUuid) {
        officeUuids.push(office.uuid)
      }
    }
    return officeUuids
  }

  /**
   * 获取子公司（包含当前公司）
   * @param officeUuid
   * @returns
   */
  static checkHierarchicalDetailFinancial(branchId) {
    if (Number(cache.config.get('QueryChildernDataRole')) === 1) {
      return true
    }
    const officeIds = this.getChildOfficeIds($store.getters.currentOfficeUuid)
    return officeIds.includes(branchId) && checkPermission(['role_ViewHierarchicalDetailAtFinancial'])
  }

  // 批量填写GP说明
  static toBatchFillGpExplain(selectedRows, gpExplain) {
    const jobUuids = []
    for (const j of selectedRows) {
      jobUuids.push(j.uuid)
    }
    // 填充弹窗需要的数据
    gpExplain.visible = true
    gpExplain.jobUuids = jobUuids
  }

  /**
   * 根据运输公司带出司机信息
   * @param truckingInfo
   * @param carryingCmp
   * @returns {Promise<*[]>}
   */
  static async getDriverInformationByCarryingCap(truckingInfo, carryingCmp) {
    let driverInformationList = []
    if (truckingInfo) {
      const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', carryingCmp)
      if (!company) {
        truckingInfo.driverName = ''
        truckingInfo.driverPhone = ''
        truckingInfo.plateNumber = ''
        truckingInfo.driverIdCard = ''
        truckingInfo.deliveryArea = ''
        return driverInformationList
      }
      driverInformationList = await Company.loadDriverInformation(company.uuid)
      if (!driverInformationList || driverInformationList.length === 0) {
        truckingInfo.driverName = ''
        truckingInfo.driverPhone = ''
        truckingInfo.plateNumber = ''
        truckingInfo.driverIdCard = ''
        truckingInfo.deliveryArea = ''
        return driverInformationList
      }
      let driver = driverInformationList.find(p => p.defaultDriver)
      if (!driver) {
        driver = driverInformationList[0]
      }
      truckingInfo.driverName = driver.driverName
      truckingInfo.driverPhone = driver.driverPhone
      truckingInfo.plateNumber = driver.plateNumber
      truckingInfo.driverIdCard = driver.driverIdCard
      truckingInfo.deliveryArea = driver.deliveryArea
    }
    return driverInformationList
  }

  /**
   * 发送EDI, 组装上传云存储参数
   * @param params
   * @param defaultFileType
   * @param button
   * @param content
   * @returns {{fileName: string, params: {}, content: *}|null}
   */
  static assemblyParametersForUploadFileOfSendEdi(params, defaultFileType = '', button = 0, content) {
    const uploadEdiFileVo = { 'fileName': lang.t('SeaExport.Send'), 'content': content, 'params': {}}
    const ediType = params.ediType
    if (ediType > 0 && [1, 2, 3, 4, 6, 7, 8, 11, 15, 30, 23, 26, 27, 43].includes(ediType)) {
      let documentType = ''
      switch (ediType) {
        case 1 : // 订舱
          documentType = 'BOOKING_EDI'
          break
        case 2 : // 提单
          documentType = 'LADING_BILL_EDI'
          break
        case 4 : // 安装箱
          documentType = 'INSTALL_EDI'
          break
        case 6 : // 预配舱单
          documentType = 'PRECONFIGURE_SHIPPING_EDI'
          break
        case 7 : // 清洁舱单
          documentType = 'IFCSUM_EDI'
          break
        case 8 : // 反恐舱单
          documentType = 'JP24SMF_EDI'
          break
        case 11 : // VGM
          documentType = 'VGM_EDI'
          break
        case 3 : // 海外代理预报
        case 15 : // 海外代理预报(包括CargoWise和荆艺接口)
          documentType = 'OVERSEAS_AGENT_EDI'
          break
        case 30 : // 提箱
          documentType = 'SUITCASE_TYPE_EDI'
          break
        case 23 : // VGM
          documentType = 'VGM2_MANIFESTINFO_EDI'
          break
        case 26 : // 预配舱单-MANIFESTINFO方式
          documentType = 'PRECONFIGURE_MANIFESTINFO_SHIPPING_EDI'
          break
        case 27 : // 清洁舱单-MANIFESTINFO方式
          documentType = 'IFCSUM_MANIFESTINFO_EDI'
          break
        case 43 : // JCL预报
          documentType = 'OVERSEAS_AGENT_EDI'
          break
        default:
          return null
      }
      if (documentType) {
        const uploadParams = {}
        uploadParams.fileType = this.getExportFileFix(params, defaultFileType)
        uploadParams.createdBy = $store.getters.userInfo ? String($store.getters.userInfo.userId) : 0
        const sendType = !params.ediTemplate ? '' : params.ediTemplate.sendType
        const sendTypeItem = ChargeItemTarget.getChargeItemTargetByCode2(sendType)
        uploadParams.fileSource = (sendTypeItem && sendTypeItem.code) ? sendTypeItem.code : ''
        uploadParams.documentType = documentType
        if (params.hasOwnProperty('ediStatusName') && params.ediStatusName) {
          let buttonName = ''
          if (button === 1) {
            buttonName = lang.t('CargoMsg.Cargo_DataExport')
          } else if (button === 2 || button === 3) {
            buttonName = lang.t('SeaExport.Send')
          } else if (button === 4) {
            buttonName = lang.t('SeaExport.MailSending')
          }
          uploadEdiFileVo.fileName = buttonName + params.ediStatusName + '_ediStatusName' + this.getExportFileFix(params, defaultFileType)
        } else {
          uploadEdiFileVo.fileName = uploadEdiFileVo.fileName + this.getExportFileFix(params, defaultFileType)
        }
        uploadParams.uuid = encodeURIComponent(params.job.uuid)
        uploadParams.jobNo = params.job.jobNo
        uploadEdiFileVo.params = uploadParams
      }
    }
    return uploadEdiFileVo
  }

  static getExportFileFix(params, defaultFileType = '') {
    const ediTemplate = params.ediTemplate
    if (!ediTemplate || !ediTemplate.defaultFileType) {
      if (defaultFileType) {
        return defaultFileType
      }
      return '.data'
    }
    return ediTemplate.defaultFileType
  }

  static async getOfficeSaleList() {
    await cache.load(cacheName.CONFIG)
    if (Number(cache.config.get('SalesOfficeCheck')) === 1) {
      return await User.getUsersByPrivilegeDetail('role', 'sales', '', $store.getters.currentOfficeId, true)
    }
    return await User.getUsersByPrivilegeDetail('role', 'sales', '', null, true)
  }

  static async getCustomerContact(companyUuid, contactList) {
    if (!contactList || contactList.length === 0) {
      contactList = await Company.loadContact(companyUuid)
    }
    const contact = this.getDefaultContact(contactList)
    return contact ? contact.contactPerson : ''
  }
  static getDefaultContact(contactList) {
    if (!contactList || contactList.length <= 0) return ''
    const c = contactList.find(item => item.defaultContact)
    return c || contactList[0]
  }

  /**
   * 处理保存业务时，费用问题
   * @param body
   */
  static handleChargeForSave(body) {
    if (!body.charges || body.charges.length === 0) {
      return
    }
    const uniqueCharges = []
    for (let i = body.charges.length - 1; i >= 0; --i) {
      const item = body.charges[i]
      if (item.uuid && (item.uuid.startsWith('addTabSelling__') || item.uuid.startsWith('addTabCost__'))) {
        item.uuid = ''
      }
      if (item.uuid) { // 编辑的
        const index = uniqueCharges.findIndex(p => p === item || p.uuid === item.uuid)
        if (index >= 0) {
          body.charges.splice(i, 1)
          continue
        }
      } else if (item._id) { // 费用唯一标识
        const index = uniqueCharges.findIndex(p => p._id === item._id)
        if (index >= 0) {
          body.charges.splice(i, 1)
          continue
        }
      } else { // 新增的
        const index = uniqueCharges.findIndex(p => p === item || (p.receivable === item.receivable && p.serialNumber && p.serialNumber === item.serialNumber))
        if (index >= 0) {
          body.charges.splice(i, 1)
          continue
        }
      }
      uniqueCharges.push(item)
    }
  }
  /**
   * 初始化业务各个岗位角色(岗位角色有数据，则不需要初始化)
   * @param job
   */
  static async initJobRoleOptionAfterMatchUserPortConfig(job = null) {
    if (!job || !job.customerId || Number(cache.config.get('IsSpecifiedSalesBusiness')) !== 1) {
      return
    }
    const cmp = await Company.getCompanyById(job.customerId)
    if (!cmp) {
      return
    }
    const companyUsers = await Company.getCompanyUsers(cmp.uuid)
    if (!companyUsers || companyUsers.length === 0) {
      return
    }
    // 客服
    let csrDefaultId = 0
    let matchCargoSourceCsrId = 0
    // 单证
    let dcDefaultId = 0
    let matchCargoSourceDcId = 0
    // 自定义岗位1
    let userDefinedRoleId1 = 0
    let matchCargoSourceUserDefinedRoleId1Id = 0
    // 自定义岗位2
    let userDefinedRoleId2 = 0
    let matchCargoSourceUserDefinedRoleId2Id = 0
    // 合作伙伴服务人员
    for (const u of companyUsers) {
      const userValid = job.fba ? u.lob === SystemConstants.FBA_SE.code : u.lob === job.lob
      if (!u.lob || userValid || u.lob === 'ALL') {
        const user = User.getUserByIdSync(u.userId)
        if (!user || !user.active) {
          continue
        }
        if (u.roleType === CargoOfRoleType.CSR_TYPE.code && !job.csr) { // 客服
          if (u.defaultUser) {
            csrDefaultId = u.userId
          }
          if (matchCargoSourceCsrId === 0 && job.cargoSource && u.cargoSource === job.cargoSource) {
            matchCargoSourceCsrId = u.userId
          }
        } else if (u.roleType === CargoOfRoleType.DOC_TYPE.code && !job.dc) { // 单证
          if (u.defaultUser) {
            dcDefaultId = u.userId
          }
          if (matchCargoSourceDcId === 0 && job.cargoSource && u.cargoSource === job.cargoSource) {
            matchCargoSourceDcId = u.userId
          }
        } else if (u.roleType === CargoOfRoleType.USER_DEFINED_ROLE1.code && !job.userDefinedRoleId1) { // 自定义岗位1
          if (u.defaultUser) {
            userDefinedRoleId1 = u.userId
          }
          if (matchCargoSourceUserDefinedRoleId1Id === 0 && job.cargoSource && u.cargoSource === job.cargoSource) {
            matchCargoSourceUserDefinedRoleId1Id = u.userId
          }
        } else if (u.roleType === CargoOfRoleType.USER_DEFINED_ROLE2.code && !job.userDefinedRoleId2) { // 自定义岗位2
          if (u.defaultUser) {
            userDefinedRoleId2 = u.userId
          }
          if (matchCargoSourceUserDefinedRoleId2Id === 0 && job.cargoSource && u.cargoSource === job.cargoSource) {
            matchCargoSourceUserDefinedRoleId2Id = u.userId
          }
        }
      }
    }
    // 客服
    if (matchCargoSourceCsrId > 0) {
      job.csr = matchCargoSourceCsrId
    } else if (csrDefaultId > 0) {
      job.csr = csrDefaultId
    }
    if (job.csr > 0) {
      await this.loadUserDepOfficeByRole(job.csr, 'csr', depId => { job.csrDepartment = depId }, officeId => { job.csrOffice = officeId })
    }
    // 单证
    if (matchCargoSourceDcId > 0) {
      job.dc = matchCargoSourceDcId
    } else if (dcDefaultId > 0) {
      job.dc = dcDefaultId
    }
    if (job.dc) {
      await this.loadUserDepOfficeByRole(job.csr, 'doc', depId => { job.dcDepartment = depId }, officeId => { job.dcOffice = officeId })
    }
    // 自定义岗位1
    if (matchCargoSourceUserDefinedRoleId1Id > 0) {
      job.userDefinedRoleId1 = matchCargoSourceUserDefinedRoleId1Id
    } else if (userDefinedRoleId1 > 0) {
      job.userDefinedRoleId1 = userDefinedRoleId1
    }
    if (job.userDefinedRoleId1 > 0) {
      await this.loadUserDepOfficeByRole(job.csr, 'userDefinedRole1', depId => { job.userDefinedRoleDept1 = depId }, officeId => { job.userDefinedRoleOffice1 = officeId })
    }
    // 自定义岗位2
    if (matchCargoSourceUserDefinedRoleId2Id > 0) {
      job.userDefinedRoleId2 = matchCargoSourceUserDefinedRoleId2Id
    } else if (userDefinedRoleId2 > 0) {
      job.userDefinedRoleId2 = userDefinedRoleId2
    }
    if (job.userDefinedRoleId2 > 0) {
      await this.loadUserDepOfficeByRole(job.csr, 'userDefinedRole2', depId => { job.userDefinedRoleDept2 = depId }, officeId => { job.userDefinedRoleOffice2 = officeId })
    }
  }
  static async getTransportationModeAll(form) {
    try {
      let transportationModeInfos
      await getTransportationModeAll().then(res => {
        transportationModeInfos = res.data
      })
      if (transportationModeInfos && transportationModeInfos.length > 0 && form && form.transshipmentTransportationModeCode) {
        const transportationModeInfo = transportationModeInfos.filter(item => item.code === form.transshipmentTransportationModeCode)
        if (!transportationModeInfo) {
          form.transshipmentTransportationModeCode = ''
        }
      }
      return transportationModeInfos
    } catch (error) {
      console.log('error', error)
    }
  }
  static async getTransportationMode(value) {
    try {
      let transportationModeInfos
      await getTransportationModeAll().then(res => {
        transportationModeInfos = res.data
      })
      if (transportationModeInfos && transportationModeInfos.length > 0) {
        for (const transportationModeInfo of transportationModeInfos) {
          if (transportationModeInfo.uuid === value) {
            return transportationModeInfo.englishName
          }
        }
      }
      return ''
    } catch (error) {
      console.log('error', error)
    }
  }
  /**
   * 变更对应用户调整事件
   * @param job 变更业务
   * @param data 变更事件取值
   * @param shape 角色名 例：userDefinedRole1
   * @param fieldUser 角色用户 例：userDefinedRoleId1
   * @param fieldDept 角色用户部门 例：userDefinedRoleDept1
   * @param fieldOffice 角色用户分公司,可为空 例：userDefinedRoleOffice1
   * @returns {Promise<void>}
   */
  static async userChangeHandler(job, data, shape, fieldUser, fieldDept, fieldOffice) {
    job[fieldUser] = data.value || 0
    job[fieldDept] = 0
    if (fieldOffice) {
      job[fieldOffice] = 0
    }
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', shape, data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === $store.getters.currentOfficeId) {
            const office = await Office.getOfficeById(item.officeId)
            if (fieldOffice) {
              job[fieldOffice] = office ? office.officeId : 0
            }
            job[fieldDept] = item.departmentId
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', shape)
        job[fieldDept] = dep ? dep.departmentId : 0
        if (fieldOffice) {
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job[fieldOffice] = office ? office.officeId : 0
        }
      }
    }
  }

  /**
   * 初始化文件上传参数
   * @param params
   */
  static initUploadFileParam(uploadFileParam = null) {
    if (!uploadFileParam) {
      uploadFileParam = {}
    }
    if (!uploadFileParam.hasOwnProperty('isShared')) {
      uploadFileParam.isShared = 'false'
    }
    if (!uploadFileParam.hasOwnProperty('op')) {
      uploadFileParam.op = 'false'
    }
    if (!uploadFileParam.hasOwnProperty('sales')) {
      uploadFileParam.sales = 'false'
    }
    if (!uploadFileParam.hasOwnProperty('cargoSales')) {
      uploadFileParam.cargoSales = 'false'
    }
    if (!uploadFileParam.hasOwnProperty('csr')) {
      uploadFileParam.csr = 'false'
    }
    if (!uploadFileParam.hasOwnProperty('overseaOp')) {
      uploadFileParam.overseaOp = 'false'
    }
    if (!uploadFileParam.hasOwnProperty('dc')) {
      uploadFileParam.dc = 'false'
    }
    if (!uploadFileParam.hasOwnProperty('planner')) {
      uploadFileParam.planner = 'false'
    }
    if (!uploadFileParam.hasOwnProperty('userDefinedRoleId1')) {
      uploadFileParam.userDefinedRoleId1 = 'false'
    }
    if (!uploadFileParam.hasOwnProperty('userDefinedRoleId21')) {
      uploadFileParam.userDefinedRoleId2 = 'false'
    }
    if (!uploadFileParam.hasOwnProperty('all')) {
      uploadFileParam.all = 'false'
    }
    if (!uploadFileParam.hasOwnProperty('customer')) {
      uploadFileParam.customer = 'false'
    }
    if (!uploadFileParam.hasOwnProperty('shipper')) {
      uploadFileParam.shipper = 'false'
    }
    if (!uploadFileParam.hasOwnProperty('consignee')) {
      uploadFileParam.consignee = 'false'
    }
    if (!uploadFileParam.hasOwnProperty('bookingAgent')) {
      uploadFileParam.bookingAgent = 'false'
    }
    if (!uploadFileParam.hasOwnProperty('destinationAgent')) {
      uploadFileParam.destinationAgent = 'false'
    }
    if (!uploadFileParam.hasOwnProperty('b2bCustomer')) {
      uploadFileParam.b2bCustomer = 'false'
    }
    if (!uploadFileParam.hasOwnProperty('b2bDesignationAgent')) {
      uploadFileParam.b2bDesignationAgent = 'false'
    }
    if (!uploadFileParam.hasOwnProperty('b2bDestinationAgent')) {
      uploadFileParam.b2bDestinationAgent = 'false'
    }
    if (!uploadFileParam.hasOwnProperty('b2bConsignee')) {
      uploadFileParam.b2bConsignee = 'false'
    }
    if (!uploadFileParam.hasOwnProperty('synchronization')) {
      uploadFileParam.synchronization = '0'
    }
    if (!uploadFileParam.hasOwnProperty('synchronizationState')) {
      uploadFileParam.synchronizationState = '0'
    }
    if (!uploadFileParam.hasOwnProperty('fileSource')) {
      uploadFileParam.fileSource = ''
    }
    return uploadFileParam
  }

  /**
   * 根据文件类型配置，设置对应的文件类型属性
   * @param uploadFileParam
   * @param fileTypeConfig
   */
  static setUploadFileParam(uploadFileParam = null, fileTypeConfig = null) {
    // 初始化文件上传参数
    uploadFileParam = this.initUploadFileParam(uploadFileParam)
    //
    if (!fileTypeConfig) {
      return uploadFileParam
    }
    // 是否允许外部访问
    if (fileTypeConfig.shared && String(fileTypeConfig.shared) === 'true') {
      uploadFileParam.isShared = 'true'
    }
    // 操作
    if (fileTypeConfig.op && String(fileTypeConfig.op) === 'true') {
      uploadFileParam.op = 'true'
    }
    // 销售
    if (fileTypeConfig.sales && String(fileTypeConfig.sales) === 'true') {
      uploadFileParam.sales = 'true'
    }
    // 揽货销售
    if (fileTypeConfig.cargoSales && String(fileTypeConfig.cargoSales) === 'true') {
      uploadFileParam.cargoSales = 'true'
    }
    // 客服
    if (fileTypeConfig.csr && String(fileTypeConfig.csr) === 'true') {
      uploadFileParam.csr = 'true'
    }
    // 海外客服
    if (fileTypeConfig.overseaOp && String(fileTypeConfig.overseaOp) === 'true') {
      uploadFileParam.overseaOp = 'true'
    }
    // 单证
    if (fileTypeConfig.dc && String(fileTypeConfig.dc) === 'true') {
      uploadFileParam.dc = 'true'
    }
    // 航线负责任人
    if (fileTypeConfig.planner && String(fileTypeConfig.planner) === 'true') {
      uploadFileParam.planner = 'true'
    }
    // 自定义岗位1
    if (fileTypeConfig.userDefinedRoleId1 && String(fileTypeConfig.userDefinedRoleId1) === 'true') {
      uploadFileParam.userDefinedRoleId1 = 'true'
    }
    // 自定义岗位2
    if (fileTypeConfig.userDefinedRoleId2 && String(fileTypeConfig.userDefinedRoleId2) === 'true') {
      uploadFileParam.userDefinedRoleId1 = 'true'
    }
    // 所有岗位
    if (fileTypeConfig.all && String(fileTypeConfig.all) === 'true') {
      uploadFileParam.all = 'true'
    }
    // 发货人
    if (fileTypeConfig.shipper && String(fileTypeConfig.shipper) === 'true') {
      uploadFileParam.shipper = 'true'
    }
    // 收货人
    if (fileTypeConfig.consignee && String(fileTypeConfig.consignee) === 'true') {
      uploadFileParam.consignee = 'true'
    }
    // 委托单位
    if (fileTypeConfig.customer && String(fileTypeConfig.customer) === 'true') {
      uploadFileParam.customer = 'true'
    }
    // 订舱代理
    if (fileTypeConfig.bookingAgent && String(fileTypeConfig.bookingAgent) === 'true') {
      uploadFileParam.bookingAgent = 'true'
    }
    // 海外代理
    if (fileTypeConfig.destinationAgent && String(fileTypeConfig.destinationAgent) === 'true') {
      uploadFileParam.destinationAgent = 'true'
    }
    // B2B客户
    if (fileTypeConfig.b2bCustomer && String(fileTypeConfig.b2bCustomer) === 'true') {
      uploadFileParam.b2bCustomer = 'true'
    }
    // B2B指定货代理
    if (fileTypeConfig.b2bDesignationAgent && String(fileTypeConfig.b2bDesignationAgent) === 'true') {
      uploadFileParam.b2bDesignationAgent = 'true'
    }
    // B2B目的港代理
    if (fileTypeConfig.b2bDestinationAgent && String(fileTypeConfig.b2bDestinationAgent) === 'true') {
      uploadFileParam.b2bDestinationAgent = 'true'
    }
    // B2B收货人
    if (fileTypeConfig.b2bConsignee && String(fileTypeConfig.b2bConsignee) === 'true') {
      uploadFileParam.b2bConsignee = 'true'
    }
    //
    if (fileTypeConfig.hasOwnProperty('synchronization')) {
      uploadFileParam.synchronization = fileTypeConfig.synchronization || '0'
    }
    return uploadFileParam
  }

  static canPreviewFile(fileType = '') {
    if (!fileType) {
      return false
    }
    fileType = String(fileType).toLowerCase()
    const fileTypeList = ['jpg', 'png', 'jpeg', 'gif', 'webp', 'pdf', 'doc', 'docx', 'xls', 'xlsx']
    return fileTypeList.includes(fileType)
  }

  /**
   * CARGO-47047 收发通栏位支持录入小写
   *
   * 新增参数控制首发通的大小写
   */
  static async uppercaseShipperConsigneNotify(config) {
    if (!config) {
      await cache.load(cacheName.CONFIG)
    }
    const notUppercaseShipperConsigneNotify = Number(cache.config.get('NotUppercaseShipperConsigneNotify'))
    if (notUppercaseShipperConsigneNotify === 1) {
      return false
    } else {
      return true
    }
  }

  /**
   * CARGO-49117 英文品名、唛头可以支持小写字符根据参数配置
   * @param config
   * @returns {Promise<boolean>}
   */
  static async uppercaseCargoEnglishNameAndMark(config) {
    if (!config) {
      await cache.load(cacheName.CONFIG)
    }
    const uppercaseCargoEnglishNameAndMark = Number(cache.config.get('autoUppercaseEnabled'))
    if (uppercaseCargoEnglishNameAndMark === 0) {
      return true
    } else {
      return false
    }
  }

  /**
   * 校验业务单据字段是否一致
   * @param job
   * @param jobList
   * @param differentForm
   * @param lob
   */
  static verifyCheckJobFieldDifferent(job, jobList, differentForm, lob) {
    if (!job || !jobList || jobList.length === 1) return false
    for (const field in differentForm) {
      // 空出实体字段为siteOP，查询结果字段为siteOp
      if (lob === SystemConstants.AE.code && field === 'siteOP') {
        const value = job['siteOP']
        if (!(jobList.every(item => item['siteOp'] === value))) {
          differentForm['siteOP'] = false
        }
        continue
      }
      const value = job[field]
      if (!(jobList.every(item => item[field] === value))) {
        differentForm[field] = false
      }
    }
    for (const key in differentForm) {
      if (!differentForm[key]) {
        if ((lob === SystemConstants.SE.code || lob === SystemConstants.AE.code || lob === SystemConstants.IE.code || lob === SystemConstants.RE.code) && key === 'opOffice') {
          job.opOffice = $store.getters.currentOfficeId
          continue
        }
        job[key] = null
      }
    }
    return Object.values(differentForm).filter(p => !p).length > 0
  }

  /**
   * 撤回提交 || 退回预提交 校验业务状态是否符合条件
   * @param jobKeys
   * @param selectedJob
   * @param operate 1：撤回提交  ||  2：退回预提交
   * @returns {Promise<boolean>}
   */
  static async backCheckJobState(jobKeys, operate, selectedJob = null) {
    if (!jobKeys || jobKeys.length === 0) return true
    const jobList = await getJobByKeys(jobKeys).then(res => res.data)
    if (jobList && jobList.length > 0) {
      // 撤回提交校验
      if (operate === SystemConstants.OPERATE_PRINT_RETURN.code) {
        const filterJob = jobList.find(item => item.jobState !== SystemConstants.STATE_COMMITED.code)
        if (filterJob) {
          if (selectedJob != null) {
            const findJob = jobList.find(p => p.uuid === selectedJob.uuid)
            selectedJob.jobState = findJob.jobState
          }
          Message.warning(lang.t('Message.BusinessIsNotCommittedAndCannotBeWithdrawn'))
          return false
        }
      } else if (operate === SystemConstants.OPERATE_RETURN_ACTION.code) {
        // 退回预提交校验
        const filterJob = jobList.find(item => item.jobState !== SystemConstants.STATE_PRE_COMMIT.code)
        if (filterJob) {
          if (selectedJob != null) {
            const findJob = jobList.find(p => p.uuid === selectedJob.uuid)
            selectedJob.jobState = findJob.jobState
          }
          Message.warning(lang.t('Message.BusinessIsNotPreCommittedAndCannotBeReturn'))
          return false
        }
      }
    }
    return true
  }

  /**
   * 复制时校验费用名称是否被禁用
   */
  static async checkChargeItemDisabled(view, charges) {
    if (!charges || !charges.length) {
      return true
    }
    const tempCharges = new Set()
    const tempChargeNames = []
    for (const charge of charges) {
      if (tempCharges.has(charge.chargeItemId)) {
        continue
      }
      const active = await ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', Number(charge.chargeItemId), 'active')
      if (active) {
        continue
      }
      const name = await ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', Number(charge.chargeItemId), 'zhName')
      const chargeCode = await ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', Number(charge.chargeItemId), 'chargecode')
      const nameStr = `{${name}} [${chargeCode}]`
      tempChargeNames.push(nameStr)
      tempCharges.add(charge.chargeItemId)
    }
    if (tempChargeNames.length > 0) {
      const message = tempChargeNames.join('，')
      view.$message.warning(view.$t('CargoMsg.Cargo_DisabledUnableToSave', [message]))
      return false
    }
    return true
  }

  /**
   * 舱位管理退舱成功并弹框
   */
  static async createSuccessHandler(view, res, back) {
    const jobs = res.data
    const h = view.$createElement
    const content = h('div', null, [
      h('p', null, [
        h('span', null, view.$t('CargoMsg.Cargo_CabinSpaceSerialNo')),
        h('div', { style: 'word-break: break-all;overflow-wrap: break-word;width: 350px; margin: 0 10px;font-size:18px;color:#1F75D5' }, jobs)
      ])
    ])
    const title = back ? view.$t('CargoMsg.Cargo_CabinRetrievalAndReturnSuccessful') : view.$t('CargoMsg.Cargo_CabinRetrievalSuccessful')
    view.$confirm(content, title, {
      confirmButtonText: view.$t('CargoMsg.Cargo_CloseAndCopySerialNumber'),
      cancelButtonText: view.$t('CargoMsg.Cargo_Close'),
      showClose: false,
      closeOnClickModal: false,
      closeOnPressEscape: false,
      distinguishCancelAndClose: true,
      customClass: 'message-box-width-450',
      type: 'success'
    }).then(() => {
      let input = document.createElement('input')
      document.body.appendChild(input)
      input.setAttribute('value', jobs)
      input.select()
      if (document.execCommand('copy')) {
        document.execCommand('copy')
        view.$message.success(view.$t('SeaExport.CopySuccess'))
      }
      document.body.removeChild(input)
      input = null
    }).catch((action) => {})
  }

  /**
   * 协作转换Job
   * @param job
   * @param cooperate
   */
  static convertJobFromCooperateInfo(job, cooperate) {
    if (!job || !cooperate) return
    // 记录原值
    job.sales_original = job.sales
    job.salesDepartment_original = job.salesDepartment
    job.salesOffice_original = job.salesOffice
    job.cargoSalesId_original = job.cargoSalesId
    job.cargoSalesDepartment_original = job.cargoSalesDepartment
    job.cargoSalesOffice_original = job.cargoSalesOffice
    job.userDefinedRoleId1_original = job.userDefinedRoleId1
    job.userDefinedRoleDept1_original = job.userDefinedRoleDept1
    job.userDefinedRoleOffice1_original = job.userDefinedRoleOffice1
    job.userDefinedRoleId2_original = job.userDefinedRoleId2
    job.userDefinedRoleDept2_original = job.userDefinedRoleDept2
    job.userDefinedRoleOffice2_original = job.userDefinedRoleOffice2

    // 替换成协作分公司的值
    if (cooperate.sales) {
      job.sales = cooperate.sales
      job.salesDepartment = cooperate.salesDepartment
      job.salesOffice = cooperate.salesOffice
    }
    if (cooperate.cargoSalesId) {
      job.cargoSalesId = cooperate.cargoSalesId
      job.cargoSalesDepartment = cooperate.cargoSalesDepartment
      job.cargoSalesOffice = cooperate.cargoSalesOffice
    }
    if (cooperate.userDefinedRoleId1) {
      job.userDefinedRoleId1 = cooperate.userDefinedRoleId1
      job.userDefinedRoleDept1 = cooperate.userDefinedRoleDept1
      job.userDefinedRoleOffice1 = cooperate.userDefinedRoleOffice1
    }
    if (cooperate.userDefinedRoleId2) {
      job.userDefinedRoleId2 = cooperate.userDefinedRoleId2
      job.userDefinedRoleDept2 = cooperate.userDefinedRoleDept2
      job.userDefinedRoleOffice2 = cooperate.userDefinedRoleOffice2
    }
  }

  /**
   * 协作还原Job
   * @param job
   * @param cooperate
   */
  static restoreJobFromCooperateInfo(job) {
    if (!job) return
    job.sales = job.sales_original || 0
    job.salesDepartment = job.salesDepartment_original || 0
    job.salesOffice = job.salesOffice_original || 0
    job.cargoSalesId = job.cargoSalesId_original || 0
    job.cargoSalesDepartment = job.cargoSalesDepartment_original || 0
    job.cargoSalesOffice = job.cargoSalesOffice_original || 0
    job.userDefinedRoleId1 = job.userDefinedRoleId1_original || 0
    job.userDefinedRoleDept1 = job.userDefinedRoleDept1_original || 0
    job.userDefinedRoleOffice1 = job.userDefinedRoleOffice1_original || 0
    job.userDefinedRoleId2 = job.userDefinedRoleId2_original || 0
    job.userDefinedRoleDept2 = job.userDefinedRoleDept2_original || 0
    job.userDefinedRoleOffice2 = job.userDefinedRoleOffice2_original || 0
  }

  /**
   * 根据起运港，目的港，航空公司获取IATA运价
   * @param job
   * @param iataPrice
   * @returns {Promise<any|null>}
   */
  static async queryIataPriceCarrier(job = null, iataPrice = null) {
    if (!job) {
      return null
    }
    // 航空公司
    const cmp = job.carrierId > 0 ? await Company.getCompanyById(job.carrierId) : null
    const carrier = !cmp ? null : cmp.shortName
    // 判断起运港，目的港，航空公司 是否一致，任意一个不一致就需要重新查询数据
    const needLoadIataPrice = !iataPrice || !iataPrice.uuid || (job.loadingPortCode && iataPrice.pol !== job.loadingPortCode) ||
        (job.destinationPortCode && iataPrice.pod !== job.destinationPortCode) || (carrier && carrier !== iataPrice.carrier) || (!carrier && iataPrice.carrier)
    if (needLoadIataPrice) {
      const result = await queryIataPriceCarrier({ pol: job.loadingPortCode, pod: job.destinationPortCode, carrier: carrier }).then(res => res.data)
      return result || null
    }
    return iataPrice
  }

  /**
   * 处理状态追踪节点查询（财务审核，销售查询模块）
   * @param conditions
   * @param lob
   */
  static handleTrackingInfoMultipleState(conditions = [], lob = '') {
    // CARGO-48334 选择铁路业务的SOP，查询不到铁路业务的数据
    if (lob && conditions instanceof Array && conditions &&
        AdvancedSearchOption.hasField(SpecialFieldConstants.TRACKING_INFO_MULTIPLE_STATE, conditions)) {
      const option = AdvancedSearchOption.getOption(SpecialFieldConstants.TRACKING_INFO_MULTIPLE_STATE, conditions)
      if (option.value && option.value.value) {
        if ([SystemConstants.RE.code, SystemConstants.RI.code].includes(lob)) {
          conditions.push(new AdvancedSearchOption(null, 'job.LOB', [SystemConstants.RE.code, SystemConstants.RI.code], AdvancedSearchConsts.OPERATOR_IN.code))
        } else {
          conditions.push(new AdvancedSearchOption(null, 'job.LOB', lob, AdvancedSearchConsts.OPERATOR_EQUAL.code))
        }
      } else {
        AdvancedSearchOption.removeOption(SpecialFieldConstants.TRACKING_INFO_MULTIPLE_STATE, conditions)
      }
    }
  }

  // EDI公共方法
  static common(view) {
    const self = view
    // config检测方法
    const checkConfig = (prop, targetValue) => {
      return self.config !== null && self.config.get(prop) === targetValue
    }
    // 获取selectedJobs & 拼接各类所需对象
    const getSelectedJobs = () => {
      if (!self.job) {
        return
      }
      // 点击行
      const selectedJob = self.job
      if (selectedJob) {
        self.globalVar.selectedJob = selectedJob
        self.globalVar.selectedJobKey = selectedJob.uuid
      }
    }
    // 显示EDI模板选择弹窗(selectorDialog)
    const showEDITemplateWin = (uuids, item = null) => {
      if (uuids) {
        self.globalVar.ediTemplateWin.uuids = uuids
      } else {
        self.globalVar.ediTemplateWin.item = item
      }
      self.loading = getLoading4Cxt(self)
      getEDITemplate({ templateType: self.globalVar.ediType }).then(result => {
        self.selectorDialog.title = self.globalVar.title
        self.selectorDialog.rowData = result.data
        if (self.globalVar.sendRPA && self.selectorDialog.rowData) {
          self.selectorDialog.rowData = self.selectorDialog.rowData.filter(p => p.sendType === 'YD')
        }
        self.selectorDialog.visible = true
      }).finally(() => {
        self.loading.close()
      })
    }

    // 弹出messagePreviewDialog
    const setEdiTabWindow = () => {
      self.messagePreviewDialog.params = {
        job: self.globalVar.selectedJob,
        title: self.globalVar.title,
        ediType: self.globalVar.ediType,
        // ediFileName: self.globalVar,
        ediCollection: self.globalVar.ediDatas,
        ediTemplate: self.globalVar.ediTemplate,
        ediStatusName: self.globalVar.ediStatusName,
        sendRPA: self.globalVar.sendRPA
      }
      if (self.globalVar.ediType === 1) {
        self.messagePreviewDialog.params.jobKeys = self.globalVar.selectedJobKeys
      }
      self.messagePreviewDialog.visible = true
    }
    // 判断SeaExportJob是否需要加载CargoDoc
    const needLoadCargoDoc = (job) => {
      return job.uuid && (job.cargoDoc == null || job.cargoDoc.length < 1)
    }
    // 判断SeaExportJob是否需要加载Containers
    const needLoadContainers = (job) => {
      return job.uuid && (job.containers == null || job.containers.length < 1)
    }
    // 判断数据选择情况(勾选行)
    const selectedJobItemCheck = () => {
      if (!self.globalVar.selectedJobKeys) {
        self.$message.warning(self.$t('SeaExport.NoBusinessSelected'))
        return Promise.reject()
      }
    }
    // 判断数据选择情况(点击行，非勾选)
    const selectedJobItemClick = () => {
      if (!self.globalVar.selectedJobKey) {
        self.$message.warning(self.$t('SeaExport.NoBusinessSelected'))
        return Promise.reject()
      }
    }
    return { checkConfig, getSelectedJobs, showEDITemplateWin, setEdiTabWindow, needLoadCargoDoc, needLoadContainers,
      selectedJobItemCheck, selectedJobItemClick }
  }

  // EDI公共回调方法
  static commonCallback(view) {
    const self = view
    // edi导出成功回调方法
    const onExportEDISuccess = (response) => {
      if (!response || !response.data || JSON.stringify(response.data) === '{}') {
        self.$message.info(self.$t('SeaExport.NoImportEDI'))
        return
      }
      self.globalVar.ediDatas = response.data
      this.common(view).setEdiTabWindow()
    }
    // edi导出失败回调方法
    const onExportEDIFail = (dataMsg) => {
      if (dataMsg instanceof Error) {
        return
      }
      const modelMap = ModelMap['ProperyLabelMap']
      const errorMsgArr = dataMsg ? dataMsg.split(';') : null
      let finalMessage = ''
      const suffixMsg = self.$t('SeaExport.ItIsEmpty') + '<br/>'
      if (errorMsgArr && errorMsgArr.length > 0) {
        errorMsgArr.forEach(errorMsg => {
          const modelField = errorMsg.split('.')
          if (modelField && modelField.length > 0) {
            const model = modelMap[modelField[0]]
            if (model) {
              finalMessage += (model[modelField[1]] + suffixMsg)
            }
          } else {
            finalMessage += errorMsg
          }
        })
      }
      if (finalMessage) {
        self.$message.error({ dangerouslyUseHTMLString: true, message: finalMessage })
      } else {
        self.$message.error({ dangerouslyUseHTMLString: true, message: dataMsg })
      }
    }
    return { onExportEDISuccess, onExportEDIFail }
  }

  static async initImperialSetting() {
    // 获取基础配置中的英制单位设置
    const imperials = await getSpecificBasicData(basicCacheKeys.basic_data_ImperialUnitsSetting)
    // 如果基础配置为空或未开启空运，则直接返回 false
    if (!imperials || imperials.length === 0 || !imperials[0].openAe) {
      return false
    }
    return true
  }
  /**
   * 检查是否开启英制单位
   * @param {string} key - 需要检查的配置键
   * @param {string} module - 模块标识，默认为 'ae'
   * @returns {Promise<boolean>} 是否开启英制单位
   */
  static async initImperialData(key, module = 'ae') {
    try {
      // 获取基础配置中的英制单位设置
      const imperials = await getSpecificBasicData(basicCacheKeys.basic_data_ImperialUnitsSetting)
      // 如果基础配置为空或未开启空运，则直接返回 false
      if (!imperials || imperials.length === 0 || !imperials[0].openAe) {
        return false
      }
      // 获取全局的英制设置
      const icc = $store.state.settings.imperialSettings
      // 如果全局设置为空，则直接返回 false
      if (!icc) {
        return false
      }

      const nowIcc = icc.find(p => p.key === module)
      if (!nowIcc || !nowIcc.children) {
        return false
      }
      // 根据 key 和模块查找对应的配置
      const cData = nowIcc.children.find(p => p.key === `${module}_${key}`)
      // 如果找到对应配置，则返回其 imperial 值，否则返回 false
      return cData ? cData.imperial : false
    } catch (error) {
      console.error('Error in initImperialData:', error)
      return false // 发生错误时返回默认值 false
    }
  }

  /**
   * 传入毛重，计算公制 或英制毛重
   * 支持计费重
   * @param value
   * @param division 默认公制， 英制
   * 录入公制算英制 用true
   * 录入英制算公制 用false
   * @returns {Promise<number>}
   */
  static async calculateWeight(value, division = false) {
    if (!value) {
      return 0
    }
    // 获取基础配置中的英制单位设置
    const imperials = await getSpecificBasicData(basicCacheKeys.basic_data_ImperialUnitsSetting)
    // 如果基础配置为空或未开启空运，则直接返回 false
    if (!imperials || imperials.length === 0) {
      return 0
    }
    const i = imperials[0]
    if (!i.openAe || !i.pound) {
      return 0
    }
    if (!division) {
      // 获取公制
      return NumberUtils.ToFixed2(value * i.pound, 2)
    } else {
      // 获取英制
      return NumberUtils.ToFixed2(value / i.pound, 2)
    }
  }

  /**
   * 传入英制体积，计算公制体积
   * @param value
   * @param division 默认公制， 英制
   * 录入公制算英制 用true
   * 录入英制算公制 用false
   * @returns {Promise<number>}
   */
  static async calculateCubAge(value, division = false) {
    if (!value) {
      return 0
    }
    // 获取基础配置中的英制单位设置
    const imperials = await getSpecificBasicData(basicCacheKeys.basic_data_ImperialUnitsSetting)
    // 如果基础配置为空或未开启空运，则直接返回 false
    if (!imperials || imperials.length === 0) {
      return 0
    }
    const i = imperials[0]
    if (!i.openAe || !i.cubicFoot) {
      return 0
    }
    if (!division) {
      // 获取公制
      return NumberUtils.ToFixed2(value * i.cubicFoot, 3)
    } else {
      // 获取英制
      return NumberUtils.ToFixed2(value / i.cubicFoot, 3)
    }
  }

  /**
   * 计算英制长宽高
   * @param sizeLength
   * @param sizeWidth
   * @param sizeHeight
   * @param sizeQuantity
   * @param division
   *
   * 录入公制算英制 用true
   * 录入英制算公制 用false
   * @returns {Promise<string>}
   */
  static async calculateDimension(sizeLength, sizeWidth, sizeHeight, sizeQuantity, division = false) {
    sizeLength = (sizeLength || 0)
    sizeWidth = (sizeWidth || 0)
    sizeHeight = (sizeHeight || 0)
    sizeQuantity = (sizeQuantity || 0)
    // 获取基础配置中的英制单位设置
    const imperials = await getSpecificBasicData(basicCacheKeys.basic_data_ImperialUnitsSetting)
    // 如果基础配置为空或未开启空运，则直接返回 false
    if (!imperials || imperials.length === 0) {
      return ''
    }
    const i = imperials[0]
    if (!i.openAe || !i.inch) {
      return ''
    }
    if (!division) {
      // 获取公制
      return NumberUtils.ToFixed2(sizeLength * i.inch, 2) + '*' + NumberUtils.ToFixed2(sizeWidth * i.inch, 2) + '*' + NumberUtils.ToFixed2(sizeHeight * i.inch, 2) + '*' + sizeQuantity
    } else {
      // 获取英制
      return NumberUtils.ToFixed2(sizeLength / i.inch, 2) + '*' + NumberUtils.ToFixed2(sizeWidth / i.inch, 2) + '*' + NumberUtils.ToFixed2(sizeHeight / i.inch, 2) + '*' + sizeQuantity
    }
  }

  // 港前、尾程审核
  static priceAuditHandle(view, job, source = 'list') {
    switch (view.priceAuditCommand) {
      case view.$t('CargoMsg.Cargo_preportAudit'):
        this.toPriceAudit(1, view, job, source)
        break
      case view.$t('CargoMsg.Cargo_TailEndAudit'):
        this.toPriceAudit(3, view, job, source)
        break
    }
  }

  // 港前、尾程审核
  static async toPriceAudit(type, view, job, source) {
    if (!job) {
      view.$message.warning(view.$t('Message.PleaseSelectJob'))
      return
    }
    const row = job
    const userId = view.$store.getters.userId // 当前用户
    const isAdmin = view.$store.getters.isAdmin
    if (type === 1 && source === 'list') {
      const preFlag = !row.prePortPlanner
      if (preFlag) { // 港前价格是否开启
        view.$message.warning(view.$t('CargoMsg.Cargo_NoItems_NoAudit', [view.$t('CargoMsg.Cargo_PrePortBusinessLeader')]))
        return
      }
      if (row.prePortApproveStatus === 1 || row.prePortApproveStatus === 2) { // 已审核或已拒绝
        view.$message.warning(view.$t('CargoMsg.Cargo_Audited_NoNeedAudit'))
        return
      }
      if (row.prePortPlanner !== userId && !isAdmin) { // 不是审核人
        view.$message.warning(view.$t('CargoMsg.Cargo_NoAuthorityReview'))
        return
      }
    } else if (type === 3 && source === 'list') {
      const preFlag = !row.lastMilePlanner
      if (preFlag) { // 尾程价格是否开启
        view.$message.warning(view.$t('CargoMsg.Cargo_NoItems_NoAudit', [view.$t('CargoMsg.Cargo_LastMileBusinessLeader')]))
        return
      }
      if (row.lastMileApproveStatus === 1 || row.lastMileApproveStatus === 2) { // 已审核或已拒绝
        view.$message.warning(view.$t('CargoMsg.Cargo_Audited_NoNeedAudit'))
        return
      }
      if (row.lastMilePlanner !== userId && !isAdmin) { // 不是审核人
        view.$message.warning(view.$t('CargoMsg.Cargo_NoAuthorityReview'))
        return
      }
    }
    await updateInquiryJobState(row.jobUuid, type, 1).then(async res => {
      view.$message.success(view.$t('CargoMsg.Cargo_AuditSuccessfully'))
      if (source === 'list') {
        view.toQuery()
        view.gridApi.clearFocusedCell()
      } else if (source === 'detail') {
        await view.mergeCurrentRow(res)
        view.refresh()
      }
    })
  }

  static async txtPlannerChangeHandler(data, job, view) {
    if (data.value) {
      const user = new User(data)
      job.planner = user.userId
      const offices = await User.getUserDepartmentOffices('role', 'sealine', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === view.$store.getters.currentOfficeId) {
            const office = await Office.getOfficeById(item.officeId)
            job.plannerOffice = office ? office.officeId : 0
            job.plannerDepartment = item.departmentId
            break
          }
        }
      } else {
        const dep = await user.getDefaultDepartment('role', 'sealine')
        job.plannerDepartment = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.plannerOffice = office ? office.officeId : 0
      }
    } else {
      job.planner = 0
      job.plannerDepartment = 0
      job.plannerOffice = 0
    }
  }

  static async prePortPlannerChangeHandler(data, job, view) {
    if (data.value) {
      const user = new User(data)
      job.prePortPlanner = user.userId
      const offices = await User.getUserDepartmentOffices('role', 'sealine', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === view.$store.getters.currentOfficeId) {
            job.prePortPlannerDepartment = item.departmentId
            job.prePortPlannerOffice = view.$store.getters.currentOfficeId
            break
          }
        }
      } else {
        const dep = await user.getDefaultDepartment('role', 'sealine')
        job.prePortPlannerDepartment = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.prePortPlannerOffice = office ? office.officeId : 0
      }
    } else {
      job.prePortPlanner = 0
      job.prePortPlannerDepartment = 0
      job.prePortPlannerOffice = 0
    }
  }

  static async lastMilePlannerChangeHandler(data, job, view) {
    if (data.value) {
      const user = new User(data)
      job.lastMilePlanner = user.userId
      const offices = await User.getUserDepartmentOffices('role', 'sealine', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === view.$store.getters.currentOfficeId) {
            job.lastMilePlannerDepartment = item.departmentId
            job.lastMilePlannerOffice = view.$store.getters.currentOfficeId
            break
          }
        }
      } else {
        const dep = await user.getDefaultDepartment('role', 'sealine')
        job.lastMilePlanner = user.userId
        job.lastMilePlannerDepartment = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.lastMilePlannerOffice = office ? office.officeId : 0
      }
    } else {
      job.lastMilePlanner = 0
      job.lastMilePlannerDepartment = 0
      job.lastMilePlannerOffice = 0
    }
  }

  // 多段号码规则配置弹窗(multi-seg-num-rule-dialog)回调函数入口
  static multiSegNumRulesCallback(ruleEDINos, view) {
    switch (view.globalVar.popMultiSegNumRulesType) {
      case 1: this.multiSegNumRulesCallbackHandler(view).callbackHandle1(ruleEDINos)
        break
      case 2: this.multiSegNumRulesCallbackHandler(view).callbackHandle2(ruleEDINos)
        break
    }
  }

  static encodeSpecialField(res) {
    // 定义编码函数
    const encodeField = (value) => encodeURIComponent(value)

    // 定义需要编码的字段
    const jobFieldsToEncode = [
      'cargoChineseName', 'cargoEnglishName', 'mark', 'remarks', 'userDefinedField1',
      'userDefinedField2', 'userDefinedField3', 'userDefinedField4', 'operationTips',
      'cargoManifestName', 'remarksBooking', 'remarksShipping', 'alsoNotify', 'bargeRemarks',
      'customerCfmException', 'portRequirement', 'withholdReason', 'notifyLine1', 'notifyLine2',
      'notifyLine3', 'notifyLine4', 'notifyLine5', 'notifyLine6', 'notifyLine7', 'consigneeLine1',
      'consigneeLine2', 'consigneeLine3', 'consigneeLine4', 'consigneeLine5', 'consigneeLine6',
      'consigneeLine7', 'shipperLine1', 'shipperLine2', 'shipperLine3', 'shipperLine4', 'shipperLine5',
      'shipperLine6', 'shipperLine7', 'agentPartyLine1', 'agentPartyLine2', 'agentPartyLine3',
      'agentPartyLine4', 'agentPartyLine5', 'agentPartyLine6', 'agentPartyLine7'
    ]

    const containerFields = ['mark', 'cargoName']
    const poItemFields = ['mark', 'englishCommodity']

    // 增强的编码函数，避免重复编码
    const encodeObjectFields = (obj, fields) => {
      if (!obj || obj._encoded) return // 如果对象已被处理过则跳过

      fields.forEach((field) => {
        if (obj[field] && typeof obj[field] === 'string') {
          // 检查是否已经被编码过（简单判断是否包含%）
          if (!obj[field].includes('%') || !/^%[0-9A-Fa-f]{2}/.test(obj[field])) {
            obj[field] = encodeField(obj[field])
          }
        }
      })

      obj._encoded = true // 标记为已处理
    }
    // 编码 job 对象
    if (res.job) {
      encodeObjectFields(res.job, jobFieldsToEncode)
    }

    // 编码提单 (seaCargoDoc)
    if (res.seaCargoDoc?.length) {
      res.seaCargoDoc.forEach(doc => {
        encodeObjectFields(doc, jobFieldsToEncode)

        // 编码 afrAddress 中的字段
        if (doc.afrAddress?.length) {
          doc.afrAddress.forEach(address => {
            encodeObjectFields(address, jobFieldsToEncode)
          })
        }
      })
    }

    // 编码装箱 (containers)
    if (res.containers) {
      res.containers.forEach(container => {
        encodeObjectFields(container, containerFields)

        // 处理 containerUsage
        if (container.containerUsage?.length) {
          container.containerUsage.forEach(usage => {
            encodeObjectFields(usage, containerFields)

            // 处理 poItems
            if (usage.poItems?.length) {
              usage.poItems.forEach(item => {
                encodeObjectFields(item, poItemFields)
              })
            }
          })
        }
      })
    }

    // 编码 containerUsages
    if (res.containerUsages) {
      res.containerUsages.forEach(containerUsage => {
        encodeObjectFields(containerUsage, containerFields)

        // 处理 containerUsages 中的 container 字段
        if (containerUsage.container) {
          encodeObjectFields(containerUsage.container, containerFields)
        }

        // 处理 poItems
        if (containerUsage.poItems?.length) {
          containerUsage.poItems.forEach(item => {
            encodeObjectFields(item, poItemFields)
          })
        }
      })
    }
  }

  // 多段号码规则配置弹窗(multi-seg-num-rule-dialog)回调函数实际处理方法
  static multiSegNumRulesCallbackHandler(view) {
    const self = view
    // 回调处理方法1, 订舱菜单触发多段号码规则弹窗回调函数
    const callbackHandle1 = (ruleEDINos) => {
      let ruleEDINoArr = []
      if (ruleEDINos && this.common(self).checkConfig('EDINoRuleConfigMode', '1') && self.globalVar.ediType === 5) {
        ruleEDINoArr = ruleEDINos
      }
      if (self.globalVar.ediTemplateWin.item) {
        self.globalVar.ediTemplateWin.item.ruleEDINos = ruleEDINoArr
        const param = {}
        param.ediType = self.globalVar.ediType
        param.templateId = self.globalVar.ediTemplate.uuid
        param.item = self.globalVar.ediTemplateWin.item
        param.editStatus = self.globalVar.editStatus
        self.loading = getLoading4Cxt(self)
        ediApi.getEDIObject(param).then(result => this.commonCallback(self).onExportEDISuccess(result))
          .catch(message => this.commonCallback(self).onExportEDIFail(message))
          .finally(() => {
            self.globalVar.ediTemplateWin.item = undefined
            self.loading.close()
          })
      } else {
        const param = {}
        param.ediType = self.globalVar.ediType
        param.templateId = self.globalVar.ediTemplate.uuid
        param.jobUuids = self.globalVar.ediTemplateWin.uuids
        param.editStatus = self.globalVar.editStatus
        param.ruleEDINos = ruleEDINoArr
        self.loading = getLoading4Cxt(self)
        ediApi.getEDI(param).then(result => this.commonCallback(self).onExportEDISuccess(result))
          .catch(message => this.commonCallback(self).onExportEDIFail(message))
          .finally(() => { self.loading.close() })
      }
    }
    // 回调处理方法2, 舱单菜单触发多段号码规则弹窗回调函数
    const callbackHandle2 = (ruleEDINos) => {
      self.shippingHandler().getShippingEDI(ruleEDINos)
    }
    return { callbackHandle1, callbackHandle2 }
  }
  static loadingAgentIdFilter(item) {
    // 检查BRANCH_ID条件
    const branchMatch = item.branchId === $store.getters.currentOfficeId ||
        item.branchId === 1 ||
        (item.multipleBranchId &&
            (item.multipleBranchId.split(',').includes(String($store.getters.currentOfficeId)) ||
                item.multipleBranchId.split(',').includes('1')))
    // 检查LOCAL和ACTIVE
    return branchMatch
  }

  static async loadPlaceOfDeliveryRegion(job) {
    if (job.destinationPortCode && job.destinationPortCode.length > 0) {
      const seaPorts = await getSpecificBasicData(basicCacheKeys.basic_data_Seaport)
      const ports = seaPorts.filter(p => p.code === job.destinationPortCode)
      if (ports && ports.length > 0) {
        job.placeOfDeliveryRegion = ports[0].region
      }
    }
  }

  /**
   * 处理收发通换行
   * @param data
   * @param field
   * @param maxLength
   * @param wrapSymbol
   */
  static disposeScnLinebreaks(data = '', field = '', maxLength = 0, wrapSymbol = 'n') {
    if (!data || !field || !maxLength || maxLength === 0 || !wrapSymbol) {
      return
    }
    // 先把收发通的1-7行合并
    const line = this.mergeLineForScn(data, field)
    // 根据每行最大字符数拆分
    const splitLine = this.splitStringByBrAndLength(line, maxLength, 'n')
    // 把最终的结果回写到提单上
    this.splitLineForScn(data, field, splitLine)
  }
  /**
   * 根据每行最大字符数进行换行
   * @param text 字符串
   * @param maxLength 最大换行数
   * @param wrapSymbol 换行符
   * @returns {string|string}
   */
  static splitStringByBrAndLength(text = '', maxLength = 0, wrapSymbol = 'n') {
    if (!text || !maxLength || maxLength === 0) {
      return text
    }
    const curWrapSymbol = wrapSymbol === 'n' ? '\n' : '\r'
    text = text.replace(/(\r\n)|(\n)|(\r)/g, wrapSymbol)
    text = text.replace(/\t/g, '')
    const strArr = []
    const lines = text.split(wrapSymbol)
    // 遍历每行，进行切分
    lines.forEach(line => {
      // 如果当前行的长度不超过指定长度，直接添加到结果行中
      if (line.length <= maxLength) {
        return strArr.push(line)
      }
      // 当前行的分段切分逻辑
      let currentIndex = 0
      while (currentIndex < line.length) {
        const currentLine = line.slice(currentIndex, currentIndex + maxLength)
        // 确保完整单词不被截断
        if (currentLine.length < maxLength) {
          strArr.push(currentLine)
          currentIndex = line.length
        } else {
          const lastIndexOfSpace = currentLine.lastIndexOf(' ')
          const wrapIndex = lastIndexOfSpace > 0 && line[currentIndex + maxLength] !== ' ' ? lastIndexOfSpace : maxLength
          strArr.push(currentLine.slice(0, wrapIndex))
          currentIndex += wrapIndex
          // 跳过空格字符，避免不必要的空格干扰
          while (line[currentIndex] === ' ') {
            currentIndex++
          }
        }
      }
    })
    const result = strArr.join(curWrapSymbol)
    return result ? result.trim() : result
  }

  /**
   * 合并收发通1到7行
   * @param data
   * @param field
   * @returns {string}
   */
  static mergeLineForScn(data = null, field = '') {
    let result = ''
    for (let i = 1; i < 7; ++i) {
      result += data[field + i] || ''
      result += '\n'
    }
    result += (data[field + '7'] || '')
    return result.trimEnd()
  }

  /**
   * 拆分收发通1-7行
   * @param data
   * @param field
   * @param text
   */
  static splitLineForScn(data = null, field = '', text = '') {
    if (!data || !field || !text) {
      return
    }
    let fromIndex = 0
    let i = 1
    for (; i < 7; ++i) {
      const index = text.indexOf('\n', fromIndex)
      if (index === -1) {
        break
      }
      data[field + i] = text.substring(fromIndex, index)
      fromIndex = index + 1
    }
    data[field + i] = text.substring(fromIndex)
    for (++i; i < 8; ++i) {
      data[field + i] = ''
    }
  }

  /**
   * CARGO-53866 东丽 新增业务 销售默认代入当前登录人
   * @param job
   * @param view
   * @returns {Promise<void>}
   */
  static async loadingDlwlSales(job, view = null) {
    const isDlwl = String(cache.config.get('ToExoSystem')) === 'DLWL'
    if (!isDlwl || !job) {
      return
    }
    // 校验当前登录人员是否有销售权限
    if (view && !view.$checkPermission(['role_sales'])) {
      return
    }
    // 当前分公司
    const salesOffice = $store.getters.currentOfficeId
    // 当前登录人员
    const salesId = $store.getters.userId
    // 校验当前登录人员是否有销售权限
    // const salesList = await User.getUsersByPrivilegeDetail('role', 'sales', null, salesOffice, true)
    // if (salesList && salesOffice.length > 0) {
    //   const salesUser = salesList.find(item => item.userId === salesId)
    //   if (!salesUser) {
    //     return
    //   }
    // }
    job.sales = salesId
    // 获取部门和分公司
    const isZh = $store.getters.language === 'zh'
    const offices = await User.getUserDepartmentOffices('role', 'sales', salesId)
    if (offices.length > 1) {
      let item = offices.find(item => item.officeId === salesOffice)
      if (!item) {
        item = offices[0]
      }
      job.salesOffice = item.officeId
      job.salesDepartment = item.departmentId
      if (view) {
        const office = await Office.getOfficeById(job.salesOffice)
        if (office) {
          view.txtSalesOffice = isZh ? office.chineseName : office.englishName
        } else {
          view.txtSalesOffice = ''
        }
      }
    } else {
      const salesUser = await User.getUserById(salesId)
      if (salesUser) {
        const user = new User(salesUser)
        const department = await user.getDefaultDepartment('role', 'sales')
        job.salesDepartment = department ? department.departmentId : 0
        const office = department ? await Office.getOfficeByUuid(department.officeUuid) : null
        if (office) {
          job.salesOffice = office.officeId
          if (view) {
            view.txtSalesOffice = isZh ? office.chineseName : office.englishName
          }
        }
      }
    }
  }

  /**
   * 加载job船期数据
   */
  static async loadingShipDate(job) {
    const isXycw = String(cache.config.get('ToExoSystem')) === 'XYCW'
    const vesslPlanUpdate = Number(cache.config.get('VesslPlanUpdate')) === 1
    if (!isXycw && !vesslPlanUpdate) {
      return
    }
    loadingShipTime({ vessel: job.vessel, voyageFlight: job.voyageFlight, carrierId: job.carrierId, loadingPortCode: job.loadingPortCode, dischargingPortCode: job.dischargingPortCode }).then(res => {
      const data = res.data
      if (isXycw) {
        job.currentETD = data.currentETD || ''
        job.currentArrivalTime = data.currentETA || ''
        job.estimatedArrivalTime = data.originalETA || ''
        job.unBerthPlanDate = data.originalETD || ''
        job.actualArrivalTime = data.ata || ''
        job.actualUnBerthPlanDate = data.atd || ''
      }
      if (vesslPlanUpdate) {
        if (data.originalETD) {
          job.unBerthPlanDate = data.originalETD
        }
        if (data.originalETD) {
          job.etd = data.originalETD
        }
      }
    })
  }

  /**
   * 新增时，处理提单收发通，英文品名，唛头换行问题
   * @param cargoDoc
   * @returns {Promise<null>}
   */
  static async handlerCargoDocLinebreaks(cargoDoc = null) {
    if (!cargoDoc || !!cargoDoc.uuid || cargoDoc.docType !== CargoDocConsts.MBL) {
      return
    }
    await cache.load(cacheName.CONFIG)
    // 是否太平, 非太平则不处理
    const isTp = String(cache.config.get('ToExoSystem')) === 'TP'
    if (!isTp) {
      return
    }
    // 唛头最大字符数
    const sEMarkMaxChars = parseInt(cache.config.get('SEMarkMaxChars'))
    // 英文品名最大字符数
    const sEEnglishDescriptionOfGoodsMaxChars = parseInt(cache.config.get('SEEnglishDescriptionOfGoodsMaxchars'))
    // 收发通最大换行数
    const sEShipperConsigneeNotifyMaxChars = parseInt(cache.config.get('SEShipperConsigneNotifyMaxchars'))
    cargoDoc.mark = this.splitStringByBrAndLength(cargoDoc.mark, sEMarkMaxChars, 'r')
    cargoDoc.cargoEnglishName = this.splitStringByBrAndLength(cargoDoc.cargoEnglishName, sEEnglishDescriptionOfGoodsMaxChars, 'r')
    this.disposeScnLinebreaks(cargoDoc, 'shipperLine', sEShipperConsigneeNotifyMaxChars, 'n')
    this.disposeScnLinebreaks(cargoDoc, 'consigneeLine', sEShipperConsigneeNotifyMaxChars, 'n')
    this.disposeScnLinebreaks(cargoDoc, 'notifyLine', sEShipperConsigneeNotifyMaxChars, 'n')
  }

  /**
   * 匹配航交所最终运价配置
   * @param body
   * @param branchId
   * @param view
   * @returns {Promise<boolean>}
   */
  static async matchOpenPriceConfig(body, branchId, view) {
    if (!body || !branchId || Number(cache.config.get('IsActivateOpenPrice')) !== 1) {
      return true
    }

    const job = body.job || {}
    const param = lodash.cloneDeep(body)
    body.matchOpenPriceResultDTO = null
    const matchResult = await matchOpenPriceConfig(param, branchId).then(res => res.data)
    if (matchResult != null) {
      // 未申报、超限
      if (matchResult.notDeclared || matchResult.overrun) {
        if (matchResult.warningContact) {
          // matchResult.warningContact = matchResult.warningContact.replace(/<br\/>/g, '\n')
        }
        if (matchResult.reminderType === SystemConstants.OPEN_PRICE_REMINDER_TYPE_NOT_RECORD.code) {
          return true
        }
        if (matchResult.reminderType === SystemConstants.OPEN_PRICE_REMINDER_TYPE_NOT_SAVE.code) { // 禁止保存
          let msg = ''
          if (matchResult.notDeclared) {
            msg = view.$t('CargoMsg.Cargo_UnregisteredRateSaveError', [matchResult.warningContact])
          } else if (matchResult.overrun) {
            msg = view.$t('CargoMsg.Cargo_ExceedDeclaredLimitSaveError', [matchResult.warningContact])
          }
          await view.$confirm(msg, view.$t('Message.Error2'), {
            confirmButtonText: view.$t('common.btn.ok'),
            showCancelButton: false,
            closeOnClickModal: false,
            showClose: false,
            dangerouslyUseHTMLString: true,
            type: 'error'
          }).then(() => {})
          // 业务非新建的情况需要发送邮件和插入预警记录
          if (job.uuid) {
            job.matchOpenPriceResultDTO = matchResult
            await executeOpenPriceWarning(job, branchId).then(res => res.data)
          }
          return false
        } else if (matchResult.reminderType === SystemConstants.OPEN_PRICE_REMINDER_TYPE_REMINDER_USER.code) { // 提醒用户
          let isSave = true
          let msg = ''
          if (matchResult.notDeclared) {
            msg = view.$t('CargoMsg.Cargo_UnregisteredRateWarning', [matchResult.warningContact])
          } else if (matchResult.overrun) {
            msg = view.$t('CargoMsg.Cargo_ExceedDeclaredLimitWarning', [matchResult.warningContact])
          }
          if (msg) {
            await view.$confirm(msg, view.$t('Message.Tips'), {
              confirmButtonText: view.$t('CargoMsg.Cargo_GoOn'),
              cancelButtonText: view.$t('common.btn.cancel'),
              closeOnClickModal: false,
              showClose: false,
              dangerouslyUseHTMLString: true,
              type: 'warning'
            }).then(() => {}).catch(() => {
              isSave = false
            })
          }
          // 取消保存
          if (!isSave) {
            // 业务非新建的情况下需要发送邮件和插入预警记录
            // if (job.uuid) {
            //   job.matchOpenPriceResultDTO = matchResult
            //   await executeOpenPriceWarning(job, branchId).then(res => res.data)
            // }
            return false
          }
        }
        body.matchOpenPriceResultDTO = matchResult
      }
    }
    return true
  }
  /**
   * 匹配航交所最终运价配置
   * @param job
   * @param view
   * @returns {Promise<boolean>}
   */
  static async checkExportControlledProduct(job, view) {
    let exec = true
    if (job && job.exportControlledProduct === SystemConstants.EXPORT_CONTROLLED_PRODUCT_YES_NOT_PERMISSION.code) {
      const promptText = `<span style="color:red">` + view.$t('CargoMsg.Cargo_SureSaveUnControlledProduct') + `</span>` + `<br>` + view.$t('CargoMsg.Cargo_ScmNeedAllowProduct')
      await view.$confirm(promptText, '', {
        confirmButtonText: view.$t('CargoMsg.Cargo_SureSave'),
        cancelButtonText: view.$t('Message.ReturnToModify'),
        closeOnClickModal: false,
        showClose: false,
        customClass: 'export-controlled-product-class',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(() => {
        job.exportControlledLocked = true
      }).catch(() => {
        exec = false
      })
    }
    return exec
  }

  /**
   * 字符串拆分为Num数组
   * @param str
   * @returns {number[]|*[]}
   */
  static handleNumArry(str) {
    if (!str || typeof str !== 'string') return []
    return str.split(',')
      .map(item => item.trim())
      .filter(item => item !== '')
      .map(Number)
      .filter(num => !isNaN(num) && Number.isInteger(num))
  }

  static async checkJobSensitiveWord(job, wordField) {
    let ifContainSensitiveWord = false
    const loading = getLoading4Cxt()
    await checkSensitiveWord({ job, wordField: wordField }).then(res => {
      ifContainSensitiveWord = res.data.ifContainSensitiveWord
    }).finally(() => {
      loading.close()
    })
    return ifContainSensitiveWord
  }

  /**
   * 校验中邮敏感词
   * @param job
   * @param view
   * @returns {Promise<boolean>}
   */
  static async checkZySensitiveWord(job, view) {
    let exec = true
    if (!job) {
      return exec
    }
    if (!job.cargoChineseName) {
      job.cargoChineseNameWarning = 0
    }
    if (!job.cargoEnglishName) {
      job.cargoEnglishNameWarning = 0
    }
    if ((job.cargoChineseName && job.cargoChineseName_original !== job.cargoChineseName) ||
        (job.cargoEnglishName && job.cargoEnglishName_original !== job.cargoEnglishName)) {
      let loading = getLoading4Cxt()
      await checkSensitiveWord({ job, wordField: CARGO_CHINESE_NAME.code }).then(res => {
        if (res.data.ifContainSensitiveWord) {
          job.cargoChineseNameWarning = 1
        } else {
          job.cargoChineseNameWarning = 2
        }
      }).finally(() => {
        loading.close()
      })
      loading = getLoading4Cxt()
      await checkSensitiveWord({ job, wordField: CARGO_ENGLISH_NAME.code }).then(res => {
        if (res.data.ifContainSensitiveWord) {
          job.cargoEnglishNameWarning = 1
        } else {
          job.cargoEnglishNameWarning = 2
        }
      }).finally(() => {
        loading.close()
      })
      // 若中文品名或英文品名发生变化且包含关键词
      const h = view.$createElement
      const content = h('div', null, [
        view.$t('CargoMsg.Cargo_CheckZySave'),
        h('br', null),
        h('a', { attrs: { href: 'http://exportcontrol.mofcom.gov.cn/ckgzqdsjk.shtml?columnID=8&num=1', target: '_blank', rel: 'noopener' }, style: { color: '#409EFF', textDecoration: 'underline' }}, 'http://exportcontrol.mofcom.gov.cn/ckgzqdsjk.shtml?columnID=8&num=1')
      ])
      await view.$confirm(content, view.$t('Message.WarmReminder'), {
        dangerouslyUseHTMLString: true,
        confirmButtonText: view.$t('CargoMsg.Cargo_HasVerified'),
        showCancelButton: false
      }).catch(() => {
        exec = false
      })
    }
    return exec
  }

  /**
   * 获取船公司信息对应的amsScacCode
   */
  static async getScacList(carrierScac = null) {
    const res = await getAllShipCompany()
    const scacList = []
    res.data.forEach(item => {
      if (item.amsScacCode) {
        scacList.push({ code: item.amsScacCode, englishName: item.shipCompanyEnglishName })
      }
    })
    if (carrierScac) {
      const exists = scacList.some(item => item.code === carrierScac)
      if (!exists) {
        scacList.push({ code: carrierScac, englishName: carrierScac })
      }
    }
    return scacList
  }

  /**
   * 获取船公司信息对应的amsScacCode
   */
  static async getCarrierScac(carrierId, scacList, carrierScacEdit = false) {
    let carrierScac = ''
    if (!carrierId) {
      return carrierScac
    }
    const company = await Company.getCompanyById(carrierId)
    if (!company) {
      return carrierScac
    }
    if (company.shipCompanyUuid) {
      const resp = await getByUuidShipCompany({ uuid: company.shipCompanyUuid })
      if (resp.data && resp.data.amsScacCode) {
        carrierScac = resp.data.amsScacCode
      }
    } else if (company.scac) {
      if (scacList && carrierScacEdit) {
        const foundScac = scacList.find(item => item.code === company.scac)
        if (foundScac) {
          carrierScac = company.scac
        }
      } else {
        carrierScac = company.scac
        scacList.push({ code: carrierScac, chineseName: carrierScac })
      }
    }
    return carrierScac
  }

  /**
   * 判断UI自定义配置中是否允许编辑
   * @param elementDict
   * @returns {boolean}
   */
  static checkCarrierScacEdit(elementDict) {
    let carrierScacEdit = false
    for (const key in elementDict) {
      const element = elementDict[key]
      if (!element.fieldNames) {
        continue
      }
      let continueExec = false
      for (const fieldName of element.fieldNames) {
        if (fieldName === 'carrierScac') {
          continueExec = true
          carrierScacEdit = element.customContent && element.customContent.carrierScacEdit
          break
        }
      }
      if (continueExec) {
        break
      }
    }
    return carrierScacEdit
  }

  /**
   * 校验新增业务的ETD天数是否超信控
   * @param job
   * @param type 1job 2hbl
   * @returns
   */
  static async checkEtdDaysCreditInfo(cmpIdx, type = 1) {
    if (!cmpIdx) {
      console.log('checkEtdDaysCreditInfo missing cmpIdx: -1')
      return -1
    }
    await cache.load(cacheName.OFFICE)
    const officeId = cache.office.officeId || $store.getters.currentOfficeId
    if (!officeId) {
      console.log('checkEtdDaysCreditInfo missing officeId: -1')
      return -1
    }
    const res = await getOfficeConfigByName({ officeId, configName: 'forceCheckEtdDays' }).catch(() => null)
    const value = res && res.data ? res.data.value : null
    if (String(value) !== '1') {
      console.log('checkEtdDaysCreditInfo forceCheckEtdDays not enabled: -1')
      return -1
    }
    const etddays = await checkEtdDaysCreditInfo({ accountId: cmpIdx, type: type }).then(res => res.data)
    console.log('checkEtdDaysCreditInfo result: ', etddays)
    return etddays
  }

  /**
   * 校验新增业务的ETD天数是否超信控
   * @param jobKey
   * @param accountId
   * @returns
   */
  static async checkJobAtdDesc(jobKey, accountId) {
    return await checkJobAtdDescFunc({ jobUuid: jobKey, accountId: accountId }).then(res => res.data)
  }
}
